import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null | undefined;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export * from "./apollo-helpers";
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** An ISO 8601-encoded date */
  ISO8601Date: any;
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: any;
  /** Represents non-fractional signed whole numeric values. Since the value may exceed the size of a 32-bit integer, it's encoded as a string. */
  BigInt: any;
  /** Represents untyped JSON */
  JSON: { [key: string]: any };
  Upload: any;
};

export type Query = {
  __typename?: 'Query';
  activateCampaignCode: CampaignCode;
  autocomplete: Autocomplete;
  availableOneTimeCode: AvailableSubscriptionPlan;
  availableSubscriptionPlans: AvailableSubscriptionPlan;
  availableTrialExtensions: AvailableSubscriptionPlan;
  /** Search video */
  batchVideos: Array<Video>;
  bundle: Maybe<Bundle>;
  bundles: Maybe<PagedBundles>;
  campaignCode: Maybe<CampaignCode>;
  currentUser: Maybe<CurrentUser>;
  document: Maybe<Document>;
  emailCheck: Maybe<Email>;
  emailPreferences: Maybe<Array<EmailPreference>>;
  favoritePlaylists: Maybe<PagedPlaylists>;
  favoriteVideos: PagedVideos;
  flipperFlags: Maybe<Array<FlipperFlag>>;
  genericProgram: Maybe<GenericProgram>;
  genericPrograms: Maybe<PagedGenericPrograms>;
  getFavoritePlaylists: Maybe<PagedPlaylists>;
  getFavoriteVideos: Maybe<PagedVideos>;
  getUser: Maybe<User>;
  giftGenericProgram: Maybe<GenericProgramWithCode>;
  instructor: Maybe<Instructor>;
  instructorByGenre: InstructorInGenre;
  instructors: Maybe<PagedInstructors>;
  lastWatchedSessions: Array<Video>;
  liveEvent: Maybe<LiveEvent>;
  liveEventCodes: LiveEventCodes;
  liveEvents: Maybe<PagedLiveEvents>;
  myBundles: Maybe<PagedBundles>;
  myGenericPrograms: Maybe<PagedGenericPrograms>;
  onboardingChoices: OnboardingChoices;
  order: Maybe<Order>;
  overviewPlaylists: Maybe<Array<Maybe<OverviewPlaylist>>>;
  pageByRoute: Maybe<Page>;
  pages: Maybe<PagedPages>;
  pay: PaymentResponse;
  phasedProgram: Maybe<PhasedProgram>;
  playlist: Maybe<Playlist>;
  playlists: Maybe<PagedPlaylists>;
  playOverview: PlayOverview;
  posts: Maybe<PagedBlogPosts>;
  precheckMobileSubscription: Maybe<AppleSubscriptionPrecheck>;
  predictedLtv: Scalars['Int'];
  program: Maybe<Program>;
  programActiveState: Maybe<ProgramActiveState>;
  programById: Maybe<Program>;
  programBySlug: Maybe<Program>;
  programSurveyCompletion: Maybe<ProgramSurveyCompletion>;
  programThemes: Maybe<Array<Scalars['String']>>;
  receipts: Maybe<Scalars['String']>;
  recentVideos: Maybe<Array<Maybe<Video>>>;
  recommendations: Recommendations;
  recommendedOnboardingPlaylists: PagedPlaylists;
  recommendedOnboardingVideos: PagedVideos;
  recommendedPlaylists: Maybe<PagedPlaylists>;
  relatedPagesByRoute: Maybe<Array<Maybe<Page>>>;
  relatedVideos: Maybe<Array<Maybe<Video>>>;
  search: Maybe<Search>;
  searchSuggestions: Maybe<Array<Maybe<Scalars['String']>>>;
  specificSearch: Maybe<SpecificSearch>;
  startOverview: StartOverview;
  subPagesByRoute: Maybe<PagedPages>;
  survey: Maybe<Survey>;
  surveyPart: Maybe<ProgramSurveyElement>;
  surveys: Maybe<PagedSurveys>;
  taxonomies: Maybe<Array<Maybe<TaxonomyItem>>>;
  testimonials: Array<Testimonial>;
  userOptions: Maybe<Options>;
  userPlaylists: Maybe<PagedPlaylists>;
  users: Maybe<PagedUsers>;
  userStats: Stats;
  validateBundleCode: Maybe<ValidateCode>;
  validateLiveEventCode: ValidateCode;
  validateSubscriptionTransfer: Maybe<ValidateTransfer>;
  /** Search video */
  video: Maybe<Video>;
  videos: PagedVideos;
  videosByFeature: Maybe<PagedVideos>;
  waitingListBundles: Maybe<PagedBundles>;
  weeklyProgram: Maybe<WeeklyProgram>;
};


export type QueryActivateCampaignCodeArgs = {
  code: Scalars['String'];
};


export type QueryAutocompleteArgs = {
  query: Scalars['String'];
  searchType?: GlobalSearch;
};


export type QueryAvailableOneTimeCodeArgs = {
  code: InputMaybe<Scalars['String']>;
  platform: DevicePlatformKind;
};


export type QueryAvailableSubscriptionPlansArgs = {
  code: InputMaybe<Scalars['String']>;
  platform: DevicePlatformKind;
};


export type QueryAvailableTrialExtensionsArgs = {
  code: InputMaybe<Scalars['String']>;
  platform: DevicePlatformKind;
};


export type QueryBatchVideosArgs = {
  ids: Array<Scalars['String']>;
};


export type QueryBundleArgs = {
  client: Scalars['String'];
  slug: Scalars['String'];
};


export type QueryBundlesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
};


export type QueryCampaignCodeArgs = {
  code: Scalars['String'];
};


export type QueryDocumentArgs = {
  id: InputMaybe<Scalars['String']>;
  name: InputMaybe<Scalars['String']>;
};


export type QueryEmailCheckArgs = {
  email: Scalars['String'];
};


export type QueryEmailPreferencesArgs = {
  email: InputMaybe<Scalars['String']>;
  token: InputMaybe<Scalars['String']>;
};


export type QueryFavoritePlaylistsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  searchQuery?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<PlaylistSortAttribute>;
};


export type QueryFavoriteVideosArgs = {
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<VideoSortAttribute>;
};


export type QueryFlipperFlagsArgs = {
  names: Array<Scalars['String']>;
};


export type QueryGenericProgramArgs = {
  slug: Scalars['String'];
};


export type QueryGenericProgramsArgs = {
  category: InputMaybe<ProgramCategory>;
  instructor: InputMaybe<Scalars['String']>;
  languages: InputMaybe<Array<LanguageKind>>;
  onlyMine?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<GenericProgramSortAttribute>;
  tags: InputMaybe<Array<Scalars['String']>>;
  theme: InputMaybe<Scalars['String']>;
};


export type QueryGetFavoritePlaylistsArgs = {
  id: Scalars['ID'];
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  searchQuery?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<PlaylistSortAttribute>;
};


export type QueryGetFavoriteVideosArgs = {
  id: Scalars['ID'];
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  searchQuery?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<VideoSortAttribute>;
};


export type QueryGetUserArgs = {
  id: Scalars['ID'];
};


export type QueryGiftGenericProgramArgs = {
  discountCode: InputMaybe<Scalars['String']>;
  slug: Scalars['String'];
};


export type QueryInstructorArgs = {
  contentLanguages?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id: Scalars['ID'];
};


export type QueryInstructorByGenreArgs = {
  genre: InputMaybe<Scalars['String']>;
  instructor: Scalars['String'];
  languages: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryInstructorsArgs = {
  contentLanguages?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  option?: InputMaybe<Option>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sortBy: InputMaybe<SortAttribute>;
  sortOrder?: InputMaybe<SortOrder>;
  theme: InputMaybe<Scalars['String']>;
};


export type QueryLiveEventArgs = {
  slug: Scalars['String'];
};


export type QueryLiveEventsArgs = {
  instructor: InputMaybe<Scalars['String']>;
  keyword?: InputMaybe<Scalars['String']>;
  kind: InputMaybe<LiveEventKind>;
  languages: InputMaybe<Array<LanguageKind>>;
  maxEventDate: InputMaybe<Scalars['ISO8601DateTime']>;
  minEventDate: InputMaybe<Scalars['ISO8601DateTime']>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<LiveEventSortAttribute>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QueryMyBundlesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
};


export type QueryMyGenericProgramsArgs = {
  category: InputMaybe<ProgramCategory>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
};


export type QueryOrderArgs = {
  id: Scalars['String'];
};


export type QueryPageByRouteArgs = {
  path: Scalars['String'];
};


export type QueryPagesArgs = {
  feature?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryPayArgs = {
  paymentType: InputMaybe<Scalars['String']>;
};


export type QueryPhasedProgramArgs = {
  slug: Scalars['String'];
};


export type QueryPlaylistArgs = {
  id: Scalars['ID'];
};


export type QueryPlaylistsArgs = {
  collection: InputMaybe<Scalars['String']>;
  languages: InputMaybe<Array<Scalars['String']>>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<PlaylistSortAttribute>;
};


export type QueryPostsArgs = {
  category?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
};


export type QueryPrecheckMobileSubscriptionArgs = {
  platform: DevicePlatformKind;
  purchaseIdentifier: Scalars['String'];
};


export type QueryProgramArgs = {
  id: Scalars['ID'];
};


export type QueryProgramActiveStateArgs = {
  id: Scalars['String'];
};


export type QueryProgramByIdArgs = {
  id: Scalars['String'];
};


export type QueryProgramBySlugArgs = {
  slug: Scalars['String'];
};


export type QueryProgramSurveyCompletionArgs = {
  genericProgramSlug: Scalars['String'];
  programSurveyKind: Scalars['String'];
};


export type QueryRecommendationsArgs = {
  languages: Array<InputMaybe<Scalars['String']>>;
};


export type QueryRecommendedOnboardingPlaylistsArgs = {
  languages: Array<InputMaybe<Scalars['String']>>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  slugs: Array<InputMaybe<Scalars['String']>>;
};


export type QueryRecommendedOnboardingVideosArgs = {
  languages: Array<InputMaybe<Scalars['String']>>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  slugs: Array<InputMaybe<Scalars['String']>>;
};


export type QueryRecommendedPlaylistsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
};


export type QueryRelatedPagesByRouteArgs = {
  path: Scalars['String'];
};


export type QueryRelatedVideosArgs = {
  id: Scalars['ID'];
};


export type QuerySearchArgs = {
  languages: Array<LanguageKind>;
  query: Scalars['String'];
  searchType: GlobalSearch;
};


export type QuerySearchSuggestionsArgs = {
  query: Scalars['String'];
};


export type QuerySpecificSearchArgs = {
  languages: Array<LanguageKind>;
  modelType: ModelNameKind;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  query: Scalars['String'];
};


export type QuerySubPagesByRouteArgs = {
  page?: InputMaybe<Scalars['Int']>;
  path: Scalars['String'];
  perPage?: InputMaybe<Scalars['Int']>;
};


export type QuerySurveyArgs = {
  slug: Scalars['String'];
};


export type QuerySurveyPartArgs = {
  surveyPartId: Scalars['Int'];
};


export type QuerySurveysArgs = {
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
};


export type QueryTaxonomiesArgs = {
  filter: InputMaybe<Scalars['String']>;
  genre: InputMaybe<Scalars['String']>;
  languages: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryUserPlaylistsArgs = {
  id: InputMaybe<Scalars['ID']>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  searchQuery?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<PlaylistSortAttribute>;
};


export type QueryUsersArgs = {
  page: InputMaybe<Scalars['Int']>;
  perPage: InputMaybe<Scalars['Int']>;
  query: InputMaybe<Scalars['String']>;
};


export type QueryUserStatsArgs = {
  period?: InputMaybe<StatsPeriodKind>;
};


export type QueryValidateBundleCodeArgs = {
  client: Scalars['String'];
  code: Scalars['String'];
  slug: Scalars['String'];
};


export type QueryValidateLiveEventCodeArgs = {
  code: Scalars['String'];
  slug: Scalars['String'];
};


export type QueryValidateSubscriptionTransferArgs = {
  newUser: Scalars['String'];
  oldUser: Scalars['String'];
};


export type QueryVideoArgs = {
  id: Scalars['ID'];
};


export type QueryVideosArgs = {
  contentLanguages: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  durations?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  excludeTerms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  flavor?: InputMaybe<Scalars['String']>;
  genre?: InputMaybe<Scalars['String']>;
  kinds?: InputMaybe<Array<VideoKindInput>>;
  orderBy?: InputMaybe<VideoOrderBy>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  quickstartCategory?: InputMaybe<Scalars['String']>;
  taxonomies?: InputMaybe<Array<TaxonomyInput>>;
  useLocale?: InputMaybe<Scalars['Boolean']>;
  videoLevels?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryVideosByFeatureArgs = {
  feature?: Scalars['String'];
  languages: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  q: InputMaybe<Scalars['String']>;
};


export type QueryWaitingListBundlesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
};


export type QueryWeeklyProgramArgs = {
  slug: Scalars['String'];
};

export type CampaignCode = {
  __typename?: 'CampaignCode';
  code: Scalars['String'];
  days: Scalars['Int'];
  id: Scalars['ID'];
};

export enum GlobalSearch {
  All = 'All',
  Blog = 'Blog',
  CourseTravel = 'CourseTravel',
  Live = 'Live',
  Play = 'Play',
  Resources = 'Resources'
}

export type Autocomplete = {
  __typename?: 'Autocomplete';
  error: Maybe<Scalars['String']>;
  query: Maybe<Scalars['String']>;
  results: Array<Scalars['String']>;
};

export enum DevicePlatformKind {
  Android = 'android',
  Ios = 'ios',
  Web = 'web'
}

export type AvailableSubscriptionPlan = {
  __typename?: 'AvailableSubscriptionPlan';
  /** Code that user applied */
  code: Maybe<Scalars['String']>;
  /** Kind may be one of global, extra_global, subscription_discount_code, subscription_full_access_code, trial_campaign_code, one_time_code, trial_referral_code, trial_reclaim */
  codeType: Maybe<Code>;
  /** Subscriptions that are full accesses will show up here after inputing a valid access code by user */
  fullAccesses: Maybe<Array<UserSubscription>>;
  isCodeValid: Maybe<Scalars['Boolean']>;
  /** One time code promotions will show up after inputing valid code. They do not have subscription plan assigned. They are extending access by defined days or access_until */
  oneTimeCodes: Maybe<Array<UserSubscription>>;
  /** Subscriptions including basic and promotional */
  subscriptions: Array<UserSubscription>;
  /** Codes that will only extend trial period days, but are connected to referring user and can be used by referred user, giving the reffered user some extra days fo access_until and reffering user another extra days of access_until when reffered user will make first payment */
  trialReferralCodes: Maybe<Array<UserSubscription>>;
  /** Promotional trial plans if available */
  trials: Maybe<Array<UserSubscription>>;
  /** Localized, written by admins, custom success/failure message for user to show after applying the code */
  validationMessage: Maybe<Scalars['String']>;
};

export enum Code {
  OneTimeCode = 'one_time_code',
  SubscriptionDiscountCode = 'subscription_discount_code',
  SubscriptionFullAccessCode = 'subscription_full_access_code',
  TrialCampaignCode = 'trial_campaign_code',
  TrialReferralCode = 'trial_referral_code'
}

export type UserSubscription = {
  __typename?: 'UserSubscription';
  accessUntil: Maybe<Scalars['ISO8601Date']>;
  /** Regular price of a basic plan or promotion */
  amount: Maybe<Scalars['Float']>;
  currency: Maybe<Scalars['String']>;
  /** Days to extend the access */
  days: Maybe<Scalars['Int']>;
  description: Maybe<Scalars['String']>;
  /** Will be present only for basic plan on which global discount is applied */
  discountedAmount: Maybe<Scalars['Float']>;
  /** true when promotion is added next to the basic plans */
  extraPromotion: Scalars['Boolean'];
  /** Months to extend the access */
  months: Maybe<Scalars['Int']>;
  platform: Scalars['String'];
  /** Product id defined in external store, i.e. appstore(Apple), playstore(Google), etc. */
  productId: Maybe<Scalars['String']>;
  /** Kind may be one of global, extra_global, subscription_discount_code, subscription_full_access_code, trial_campaign_code, one_time_code, trial_referral_code, trial_reclaim */
  promotionKind: Maybe<Scalars['String']>;
  /** Only for promotions. Returns promotion name */
  promotionName: Maybe<Scalars['String']>;
  /** If set to true, next and every other payment cycle will charge the discounted amount */
  recurringPromotion: Maybe<Scalars['Boolean']>;
  shortDescription: Maybe<Scalars['String']>;
  /** Gives unique value by which payment could be made. For basic plans and promotions */
  subscriptionName: Scalars['String'];
  /** Basic plan name, may be one of trial, monthly, quarterly, yearly, free_plan, notrial_monthly, notrial_quarterly, notrial_yearly, trial_monthly, trial_quarterly, trial_yearly */
  subscriptionPlan: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
};

export type Video = VideoInterface & {
  __typename?: 'Video';
  assets: Maybe<VideoAssets>;
  categories: Array<Scalars['String']>;
  content: Maybe<VideoContent>;
  crossPromotion: Maybe<Array<GenericProgram>>;
  crossPromotionCourse: Maybe<Array<Scalars['String']>>;
  crossPromotionModel: Maybe<Scalars['String']>;
  cursorAt: Maybe<Scalars['Int']>;
  customThumbnailUrl: Maybe<Scalars['String']>;
  durationInSeconds: Maybe<Scalars['Int']>;
  favorited: Scalars['Boolean'];
  fileAssets: Array<VideoFileAsset>;
  freeAccess: Scalars['Boolean'];
  hasAccess: Scalars['Boolean'];
  hls: Scalars['String'];
  id: Scalars['ID'];
  identifier: Scalars['String'];
  inPlaylists: Array<Scalars['String']>;
  kind: Scalars['String'];
  language: LanguageKind;
  longDescription: Scalars['String'];
  meta: Maybe<VideoMeta>;
  minutes: Scalars['Int'];
  pinnedTo: Scalars['String'];
  player: Maybe<VideoInfo>;
  primaryStyle: Maybe<Term>;
  protectionContinueTitle: Maybe<Scalars['String']>;
  protectionMessage: Maybe<Scalars['String']>;
  protectionTitle: Maybe<Scalars['String']>;
  publishedAt: Scalars['Int'];
  quickstartCategory: Scalars['String'];
  shortDescription: Scalars['String'];
  taxonomies: Taxonomy;
  thumbnailUrl: Maybe<Scalars['String']>;
  thumbnailUrlMedium: Maybe<Scalars['String']>;
  title: Scalars['String'];
  twentythreeIframeUrl: Scalars['String'];
  userPlaylists: Maybe<Array<Scalars['ID']>>;
};

export type VideoInterface = {
  assets: Maybe<VideoAssets>;
  categories: Array<Scalars['String']>;
  content: Maybe<VideoContent>;
  crossPromotion: Maybe<Array<GenericProgram>>;
  crossPromotionCourse: Maybe<Array<Scalars['String']>>;
  crossPromotionModel: Maybe<Scalars['String']>;
  cursorAt: Maybe<Scalars['Int']>;
  customThumbnailUrl: Maybe<Scalars['String']>;
  durationInSeconds: Maybe<Scalars['Int']>;
  favorited: Scalars['Boolean'];
  fileAssets: Array<VideoFileAsset>;
  freeAccess: Scalars['Boolean'];
  hasAccess: Scalars['Boolean'];
  hls: Scalars['String'];
  id: Scalars['ID'];
  identifier: Scalars['String'];
  inPlaylists: Array<Scalars['String']>;
  kind: Scalars['String'];
  language: LanguageKind;
  longDescription: Scalars['String'];
  meta: Maybe<VideoMeta>;
  minutes: Scalars['Int'];
  pinnedTo: Scalars['String'];
  player: Maybe<VideoInfo>;
  primaryStyle: Maybe<Term>;
  protectionContinueTitle: Maybe<Scalars['String']>;
  protectionMessage: Maybe<Scalars['String']>;
  protectionTitle: Maybe<Scalars['String']>;
  publishedAt: Scalars['Int'];
  quickstartCategory: Scalars['String'];
  shortDescription: Scalars['String'];
  taxonomies: Taxonomy;
  thumbnailUrl: Maybe<Scalars['String']>;
  thumbnailUrlMedium: Maybe<Scalars['String']>;
  title: Scalars['String'];
  twentythreeIframeUrl: Scalars['String'];
  userPlaylists: Maybe<Array<Scalars['ID']>>;
};

export type VideoAssets = {
  __typename?: 'VideoAssets';
  thumbnailUrl: Maybe<Scalars['String']>;
  thumbnailUrlMedium: Maybe<Scalars['String']>;
};

export type VideoContent = {
  __typename?: 'VideoContent';
  longDescription: Maybe<Scalars['String']>;
  shortDescription: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
};

export type GenericProgram = {
  __typename?: 'GenericProgram';
  accessPeriod: AccessPeriod;
  accessStatus: ProgramAccessStatus;
  category: ProgramCategory;
  description: Maybe<Scalars['String']>;
  discount: Maybe<Discount>;
  duration: Maybe<Duration>;
  durationDisplay: Maybe<DurationDisplay>;
  id: Scalars['ID'];
  instructors: Maybe<Array<Maybe<Instructor>>>;
  kind: ProgramKind;
  language: Maybe<LanguageKind>;
  markets: Maybe<Array<LanguageKind>>;
  meta: Maybe<ProgramMeta>;
  postSurvey: Maybe<ProgramSurvey>;
  preSurvey: Maybe<ProgramSurvey>;
  price: Maybe<Price>;
  priceType: Maybe<PriceTypeKind>;
  programAccess: Maybe<ProgramAccess>;
  progress: Maybe<Scalars['Float']>;
  promotionalImageUrl: Maybe<Scalars['String']>;
  published: Scalars['Boolean'];
  publishedAt: Maybe<Scalars['ISO8601DateTime']>;
  recomendation: Maybe<Scalars['String']>;
  shortDescription: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  summaryAsset: Maybe<Scalars['String']>;
  tags: Array<Scalars['String']>;
  themes: Maybe<Array<ThemeKind>>;
  title: Maybe<Scalars['String']>;
  titleImageUrl: Maybe<Scalars['String']>;
  trailer: Maybe<Video>;
};

export type AccessPeriod = {
  __typename?: 'AccessPeriod';
  unit: Maybe<AccessPeriodUnitKind>;
  value: Maybe<Scalars['Int']>;
};

export enum AccessPeriodUnitKind {
  Days = 'days',
  Months = 'months',
  Weeks = 'weeks'
}

export enum ProgramAccessStatus {
  /** Access to program is active */
  Active = 'active',
  /** Access to program is expired */
  Expired = 'expired',
  /** Access to program is expiring in 30 days */
  ExpiringSoon = 'expiring_soon',
  /** No access to program */
  Locked = 'locked'
}

export enum ProgramCategory {
  Challenges = 'challenges',
  Courses = 'courses',
  Healthcare = 'healthcare',
  Programs = 'programs'
}

export type Discount = {
  __typename?: 'Discount';
  discountedPrice: Maybe<Scalars['Int']>;
  discountType: DiscountTypeKind;
  discountValue: Maybe<Scalars['Int']>;
  endDate: Maybe<Scalars['ISO8601DateTime']>;
  identifier: Maybe<PriceTypeKind>;
  startDate: Maybe<Scalars['ISO8601DateTime']>;
};

export enum DiscountTypeKind {
  ByValue = 'by_value',
  Percentage = 'percentage'
}

export enum PriceTypeKind {
  AccessCodesOnly = 'access_codes_only',
  BySubscription = 'by_subscription',
  DiscountForAll = 'discount_for_all',
  DiscountForPaying = 'discount_for_paying',
  FreeForAll = 'free_for_all',
  FreeForPaying = 'free_for_paying',
  RegularPrice = 'regular_price'
}

export type Duration = {
  __typename?: 'Duration';
  unit: Maybe<DurationUnitKind>;
  value: Maybe<Scalars['Int']>;
};

export enum DurationUnitKind {
  Days = 'days',
  Weeks = 'weeks'
}

export type DurationDisplay = {
  __typename?: 'DurationDisplay';
  unit: Maybe<DurationDisplayUnitKind>;
  value: Maybe<Scalars['Int']>;
};

export enum DurationDisplayUnitKind {
  DaysDisplay = 'days_display',
  PartsDisplay = 'parts_display',
  WeeksDisplay = 'weeks_display'
}

export type Instructor = {
  __typename?: 'Instructor';
  assets: Maybe<InstructorAssets>;
  blogDescription: Maybe<Scalars['String']>;
  dateOfBirth: Maybe<Scalars['ISO8601Date']>;
  description: Maybe<Scalars['String']>;
  education: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  languages: Maybe<Scalars['String']>;
  location: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  philosophy: Maybe<Scalars['String']>;
  quote: Maybe<Scalars['String']>;
  shortDescription: Maybe<Scalars['String']>;
  slug: Maybe<Scalars['String']>;
  speciality: Maybe<Scalars['String']>;
  subtitle: Maybe<Scalars['String']>;
  team: Maybe<Scalars['String']>;
  titleImageUrl: Scalars['String'];
  videos: Maybe<PagedVideos>;
  videosCount: Scalars['Int'];
  webpage: Maybe<Scalars['String']>;
  youtubeId: Maybe<Scalars['String']>;
};


export type InstructorVideosArgs = {
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
};

export type InstructorAssets = {
  __typename?: 'InstructorAssets';
  externalImage: Maybe<Scalars['String']>;
  squareImage: Maybe<Scalars['String']>;
  titleImage: Maybe<Scalars['String']>;
};

export type PagedVideos = PagedInterface & {
  __typename?: 'PagedVideos';
  data: Array<Video>;
  page: Scalars['Int'];
  perPage: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type PagedInterface = {
  page: Scalars['Int'];
  perPage: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export enum ProgramKind {
  CompletionBased = 'completion_based',
  ContentBased = 'content_based',
  DailyBased = 'daily_based',
  DateBased = 'date_based',
  PhaseBased = 'phase_based',
  WeeklyBased = 'weekly_based'
}

export enum LanguageKind {
  En = 'en',
  Fi = 'fi',
  No = 'no',
  Se = 'se'
}

export type ProgramMeta = {
  __typename?: 'ProgramMeta';
  description: Maybe<Scalars['String']>;
  imageUrl: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
};

export type ProgramSurvey = {
  __typename?: 'ProgramSurvey';
  finished: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  kind: SurveyKind;
  label: Scalars['String'];
  link: Scalars['String'];
  locked: Scalars['Boolean'];
};

export enum SurveyKind {
  Post = 'post',
  Pre = 'pre'
}

export type Price = {
  __typename?: 'Price';
  currency: Maybe<Scalars['String']>;
  discountApplied: Scalars['Boolean'];
  discountedPrice: Maybe<Scalars['Int']>;
  originalPrice: Maybe<Scalars['Int']>;
};

export type ProgramAccess = {
  __typename?: 'ProgramAccess';
  accessStatus: ProgramAccessStatus;
  accessUntil: Maybe<Scalars['BigInt']>;
  path: Maybe<Scalars['String']>;
  program: Maybe<Program>;
  progressPercentage: Maybe<Scalars['Int']>;
};

export type Program = {
  __typename?: 'Program';
  body: Maybe<Scalars['String']>;
  category: Maybe<ProgramCategory>;
  children: Maybe<Array<Maybe<Program>>>;
  duration: Duration;
  id: Scalars['ID'];
  instructorIds: Maybe<Array<Scalars['ID']>>;
  instructors: Maybe<Array<Maybe<Instructor>>>;
  kind: Scalars['String'];
  language: Maybe<Scalars['String']>;
  lede: Maybe<Scalars['String']>;
  legacy: Scalars['Boolean'];
  name: Scalars['String'];
  postRollQuiz: Maybe<Scalars['String']>;
  preRollQuiz: Maybe<Scalars['String']>;
  progressIsCurrent: Scalars['Boolean'];
  progressNext: Maybe<Program>;
  progressPercentage: Maybe<Scalars['Int']>;
  progressState: Scalars['String'];
  quizCount: Maybe<Scalars['Int']>;
  shortDescription: Maybe<Scalars['String']>;
  slug: Maybe<Scalars['String']>;
  tags: Array<Scalars['String']>;
  themes: Maybe<Array<ThemeKind>>;
  title: Maybe<Scalars['String']>;
  titleImageUrl: Maybe<Scalars['String']>;
  video: Maybe<Video>;
  videoCount: Maybe<Scalars['Int']>;
  videoId: Maybe<Scalars['String']>;
  videoObject: Maybe<Video>;
  weekCount: Maybe<Scalars['Int']>;
};

export enum ThemeKind {
  Athletes = 'athletes',
  Beginner = 'beginner',
  Breathing = 'breathing',
  DietAndNutrition = 'diet_and_nutrition',
  Meditation = 'meditation',
  MobilityAndPrehab = 'mobility_and_prehab',
  PersonalGrowth = 'personal_growth',
  Philosophy = 'philosophy',
  Postnatal = 'postnatal',
  Prenatal = 'prenatal',
  Restoration = 'restoration',
  Skills = 'skills',
  SmartBreaks = 'smart_breaks',
  StressAndAnxiety = 'stress_and_anxiety',
  WomensHealth = 'womens_health',
  Workout = 'workout',
  Yoga = 'yoga',
  YogaTeachers = 'yoga_teachers'
}

export type VideoFileAsset = {
  __typename?: 'VideoFileAsset';
  resolution: Maybe<Scalars['Int']>;
  size: Maybe<Scalars['Int']>;
  src: Maybe<Scalars['String']>;
};

export type VideoMeta = {
  __typename?: 'VideoMeta';
  freeAccess: Maybe<Scalars['Boolean']>;
  language: Maybe<Scalars['String']>;
  minutes: Maybe<Scalars['Int']>;
  publishedAt: Maybe<Scalars['Int']>;
};

export type VideoInfo = {
  __typename?: 'VideoInfo';
  assets: Maybe<Array<Maybe<VideoFileAsset>>>;
  hasAccess: Maybe<Scalars['Boolean']>;
  twentyThree: Maybe<TwentyThree>;
};

export type TwentyThree = {
  __typename?: 'TwentyThree';
  iframeUrl: Maybe<Scalars['String']>;
};

export type Term = {
  __typename?: 'Term';
  genres: Maybe<Array<Maybe<Scalars['String']>>>;
  id: Scalars['ID'];
  important: Maybe<Scalars['Boolean']>;
  languages: Maybe<Array<Maybe<Scalars['String']>>>;
  name: Maybe<Scalars['String']>;
  prio: Maybe<Scalars['Boolean']>;
  selected: Maybe<Scalars['Boolean']>;
  slug: Maybe<Scalars['String']>;
  titleImageUrl: Maybe<Scalars['String']>;
  types: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Taxonomy = {
  __typename?: 'Taxonomy';
  bodyparts: Maybe<Array<Maybe<Term>>>;
  duration: Maybe<Array<Maybe<Term>>>;
  flavor: Maybe<Term>;
  genre: Maybe<Term>;
  instructors: Maybe<Array<Maybe<Instructor>>>;
  needs: Maybe<Array<Maybe<Term>>>;
  props: Maybe<Array<Maybe<Term>>>;
  styles: Maybe<Array<Maybe<Term>>>;
  tags: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Bundle = {
  __typename?: 'Bundle';
  accessPeriodUnit: Maybe<Scalars['String']>;
  accessPeriodValue: Maybe<Scalars['Int']>;
  accessStrategy: BundleAccessStrategyKind;
  active: Scalars['Boolean'];
  bundleCategory: Maybe<BundleCategoryKind>;
  bundleItems: BundleItem;
  client: Maybe<Client>;
  heroImage: Maybe<Scalars['String']>;
  heroMobileImage: Maybe<Scalars['String']>;
  hiddenInListing: Scalars['Boolean'];
  id: Scalars['ID'];
  infoPanel: Maybe<BundleInfoPanel>;
  infoPanel2: Maybe<BundleInfoPanel2>;
  isUserEligible: Scalars['Boolean'];
  kind: BundleKind;
  metaDescription: Scalars['String'];
  metaImage: Maybe<Scalars['String']>;
  promotionalImage: Maybe<Scalars['String']>;
  publishedAt: Maybe<Scalars['ISO8601DateTime']>;
  sections: Array<BundleSectionKind>;
  shortDescription: Scalars['String'];
  slug: Scalars['String'];
  tags: Array<Maybe<Scalars['String']>>;
  title: Scalars['String'];
  trailer: Maybe<Video>;
  userAccess: Maybe<UserAccess>;
  waitingItemInfo: WaitingItemInfo;
};

export enum BundleAccessStrategyKind {
  ByCode = 'by_code',
  ForAll = 'for_all',
  ForPremiumOnly = 'for_premium_only',
  ForUsersWithAccess = 'for_users_with_access'
}

export enum BundleCategoryKind {
  ContentHub = 'content_hub',
  FaR = 'FaR',
  Partners = 'partners'
}

export type BundleItem = {
  __typename?: 'BundleItem';
  blogPosts: Array<Item>;
  challenges: Array<Item>;
  documents: Array<Item>;
  liveEvents: Array<Item>;
  playlists: Array<Item>;
  programs: Array<Item>;
  videos: Array<Item>;
};

export type Item = BlogPost | Document | GenericProgram | LiveEvent | Playlist | Video;

export type BlogPost = {
  __typename?: 'BlogPost';
  authors: Array<Scalars['ID']>;
  body: Scalars['String'];
  categories: Array<Scalars['String']>;
  featuredImage: Scalars['String'];
  id: Scalars['ID'];
  language: Scalars['String'];
  market: Array<Scalars['String']>;
  publishedAt: Scalars['ISO8601DateTime'];
  slug: Scalars['String'];
  tags: Array<Maybe<Scalars['String']>>;
  title: Scalars['String'];
};

export type Document = {
  __typename?: 'Document';
  contentType: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  url: Maybe<Scalars['String']>;
};

export type LiveEvent = {
  __typename?: 'LiveEvent';
  accessories: Array<Scalars['String']>;
  availableSpots: Scalars['Int'];
  bookingAvailable: Scalars['Boolean'];
  descriptionLong: Scalars['String'];
  /** duration in minutes. Should step by 15 minutes, so 0, 15, 30, etc. */
  duration: Scalars['Int'];
  eventDates: Array<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  instructors: Maybe<Array<Maybe<Instructor>>>;
  isComingSoon: Maybe<Scalars['Boolean']>;
  isExpired: Maybe<Scalars['Boolean']>;
  kind: LiveEventKind;
  language: LanguageKind;
  level: LiveEventLevel;
  linkToRecordings: Maybe<Array<LinkToRecording>>;
  maximumParticipants: Scalars['Int'];
  otherInstructors: Array<Instructor>;
  price: Maybe<Price>;
  primaryInstructor: Maybe<Instructor>;
  publishedAt: Maybe<Scalars['ISO8601DateTime']>;
  registrationEndDate: Scalars['ISO8601DateTime'];
  registrationStartDate: Scalars['ISO8601DateTime'];
  slug: Scalars['String'];
  status: LiveEventStatus;
  theme: Scalars['String'];
  thumbnail: Scalars['String'];
  title: Scalars['String'];
};

export enum LiveEventKind {
  Classe = 'classe',
  DonationClass = 'donation_class',
  FreeEvent = 'free_event',
  Lecture = 'lecture',
  PartOfOnlineCourse = 'part_of_online_course',
  Skills = 'skills',
  Talk = 'talk',
  Workshop = 'workshop'
}

export enum LiveEventLevel {
  Advanced = 'advanced',
  Beginner = 'beginner',
  Everyone = 'everyone',
  Intermediate = 'intermediate',
  Other = 'other'
}

export type LinkToRecording = {
  __typename?: 'LinkToRecording';
  eventDate: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  link: Maybe<Scalars['String']>;
};

export enum LiveEventStatus {
  Archived = 'archived',
  Canceled = 'canceled',
  Draft = 'draft',
  Published = 'published'
}

export type Playlist = {
  __typename?: 'Playlist';
  assets: Maybe<PlaylistAssets>;
  description: Maybe<Scalars['String']>;
  favorited: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  identifier: Maybe<Scalars['String']>;
  languages: Maybe<Array<Scalars['String']>>;
  meta: Maybe<Meta>;
  owner: Maybe<UserInterface>;
  public: Maybe<Scalars['Boolean']>;
  publishedState: Scalars['String'];
  thumbnailUrl: Maybe<Scalars['String']>;
  title: Scalars['String'];
  userName: Maybe<Scalars['String']>;
  videos: Maybe<Array<Maybe<Video>>>;
  visibility: Maybe<Scalars['String']>;
};

export type PlaylistAssets = {
  __typename?: 'PlaylistAssets';
  thumbnailUrl: Maybe<Scalars['String']>;
};

export type Meta = {
  __typename?: 'Meta';
  minutes: Maybe<Scalars['Int']>;
  videoCount: Maybe<Scalars['Int']>;
};

export type UserInterface = {
  accessToken: Maybe<Scalars['String']>;
  accessUntil: Maybe<Scalars['String']>;
  accountActivatedAt: Maybe<Scalars['ISO8601DateTime']>;
  address: Maybe<Scalars['String']>;
  assets: Maybe<Assets>;
  challengeParticipations: Array<Maybe<ChallengeParticipant>>;
  city: Maybe<Scalars['String']>;
  completedAt: Maybe<Scalars['ISO8601DateTime']>;
  country: Maybe<Scalars['String']>;
  courseAccesses: Array<Maybe<CourseAccess>>;
  dateOfBirth: Maybe<Scalars['Int']>;
  eligibleForDelete: Maybe<Scalars['Boolean']>;
  eligibleForTrial: Maybe<Scalars['Boolean']>;
  eligibleForTrialReclaim: Maybe<EligibleForTrialReclaimKind>;
  email: Maybe<Scalars['String']>;
  emailLanguage: Maybe<Scalars['String']>;
  extraPayments: Maybe<Array<Maybe<ExtraPayment>>>;
  favorites: Maybe<Favorites>;
  firstName: Maybe<Scalars['String']>;
  gender: Maybe<Scalars['String']>;
  group: Scalars['String'];
  hasWebPayments: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  interests: Maybe<Array<Interest>>;
  isEmailActivated: Maybe<Scalars['Boolean']>;
  isPublic: Maybe<Scalars['Boolean']>;
  kind: Maybe<Scalars['String']>;
  lastName: Maybe<Scalars['String']>;
  liveEventsAccess: Maybe<Array<Maybe<LiveEventAccess>>>;
  locale: Maybe<Scalars['String']>;
  nextBillingCycle: Maybe<NextBillingCycle>;
  onboardingCompleted: Scalars['Boolean'];
  onboardingInterestsSkipped: Scalars['Boolean'];
  onboardingSkipped: Scalars['Boolean'];
  onboardingTopicsSkipped: Scalars['Boolean'];
  paymentFailedAt: Maybe<Scalars['String']>;
  paymentType: Maybe<Scalars['String']>;
  paymentTypeRenews: Maybe<Scalars['Boolean']>;
  phone: Maybe<Scalars['String']>;
  playlists: Array<Maybe<Playlist>>;
  preferences: Maybe<Preferences>;
  previousEmail: Maybe<Scalars['String']>;
  privacySettings: Maybe<PrivacySettings>;
  profession: Maybe<Scalars['String']>;
  profile: Maybe<Profile>;
  programAccess: Array<Maybe<ProgramAccess>>;
  programs: Maybe<Array<Maybe<Page>>>;
  provider: Provider;
  receipts: Array<Maybe<Payment>>;
  referralCode: Maybe<Scalars['String']>;
  registrationDetail: RegistrationDetail;
  signUpPlatform: Maybe<Scalars['String']>;
  slug: Maybe<Scalars['String']>;
  statistics: Maybe<Statistics>;
  stories: Array<Story>;
  subscription: Subscription;
  subscriptionPlanSelected: Scalars['Boolean'];
  topics: Maybe<Array<Topic>>;
  trialPeriod: Maybe<Scalars['Int']>;
  url: Scalars['String'];
  videoNotes: Maybe<VideoNote>;
  zipcode: Maybe<Scalars['String']>;
};


export type UserInterfaceEligibleForTrialReclaimArgs = {
  promotionName: UserDecisionKind;
};

export type Assets = {
  __typename?: 'Assets';
  avatar: Maybe<Scalars['String']>;
  headerImage: Maybe<Scalars['String']>;
};

export type ChallengeParticipant = {
  __typename?: 'ChallengeParticipant';
  accessUntil: Scalars['ISO8601DateTime'];
  challenge: Challenge;
};

export type Challenge = {
  __typename?: 'Challenge';
  name: Scalars['String'];
};

export type CourseAccess = {
  __typename?: 'CourseAccess';
  accessStatus: ProgramAccessStatus;
  accessUntil: Maybe<Scalars['Int']>;
  course: Maybe<Course>;
  courseProgress: Maybe<Scalars['Int']>;
};

export type Course = {
  __typename?: 'Course';
  content: Content;
  externalImageUrl: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  legacy: Scalars['Boolean'];
  name: Maybe<Scalars['String']>;
  path: Maybe<Scalars['String']>;
  slug: Maybe<Scalars['String']>;
  themes: Maybe<Array<ThemeKind>>;
  titleImageUrl: Maybe<Scalars['String']>;
};

export type Content = {
  __typename?: 'Content';
  externalLede: Maybe<Scalars['String']>;
  externalTitle: Maybe<Scalars['String']>;
  internalLede: Maybe<Scalars['String']>;
  internalTitle: Maybe<Scalars['String']>;
  lede: Maybe<Scalars['String']>;
};

export enum UserDecisionKind {
  ProvaYogobe14 = 'ProvaYogobe14'
}

export enum EligibleForTrialReclaimKind {
  Available = 'available',
  Declined = 'declined'
}

export type ExtraPayment = {
  __typename?: 'ExtraPayment';
  amount: Maybe<Scalars['String']>;
  currency: Maybe<Scalars['String']>;
  date: Maybe<Scalars['String']>;
  downloadUrl: Maybe<Scalars['String']>;
  number: Maybe<Scalars['String']>;
  paymentType: Maybe<Scalars['String']>;
  transact: Maybe<Scalars['String']>;
};

export type Favorites = {
  __typename?: 'Favorites';
  blogPosts: Maybe<Array<Maybe<BlogPost>>>;
  playlists: Array<Maybe<Scalars['ID']>>;
  videos: Array<Maybe<Scalars['ID']>>;
};

export type Interest = {
  __typename?: 'Interest';
  hasContent: Scalars['Boolean'];
  id: Scalars['ID'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type LiveEventAccess = {
  __typename?: 'LiveEventAccess';
  liveEvent: Maybe<LiveEvent>;
  zoomLink: Scalars['String'];
  zoomPassword: Scalars['String'];
};

export type NextBillingCycle = {
  __typename?: 'NextBillingCycle';
  amount: Maybe<Scalars['String']>;
  billingDate: Maybe<Scalars['ISO8601Date']>;
  paymentStatus: Maybe<PaymentStatusKind>;
  planName: Maybe<Scalars['String']>;
};

export enum PaymentStatusKind {
  Archived = 'archived',
  Authorized = 'authorized',
  Done = 'done',
  Draft = 'draft',
  Pending = 'pending',
  Processed = 'processed',
  Refunded = 'refunded',
  Rejected = 'rejected',
  Timeout = 'timeout'
}

export type Preferences = {
  __typename?: 'Preferences';
  contentLanguages: Maybe<Array<Maybe<Scalars['String']>>>;
  excludeTerms: Maybe<Array<Maybe<Scalars['String']>>>;
  preferTerms: Maybe<Array<Maybe<Scalars['String']>>>;
  searchFilters: Maybe<Array<Maybe<Scalars['String']>>>;
  videoLevels: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type PrivacySettings = {
  __typename?: 'PrivacySettings';
  isPrivateFavorites: Maybe<Scalars['Boolean']>;
  isPrivateHistory: Maybe<Scalars['Boolean']>;
  isPrivatePlaylists: Maybe<Scalars['Boolean']>;
  isPrivateProfile: Maybe<Scalars['Boolean']>;
  isPrivateStats: Maybe<Scalars['Boolean']>;
};

export type Profile = {
  __typename?: 'Profile';
  displayName: Maybe<Scalars['String']>;
  facebookURL: Maybe<Scalars['String']>;
  instagramURL: Maybe<Scalars['String']>;
  linkedinURL: Maybe<Scalars['String']>;
  shortBio: Maybe<Scalars['String']>;
  subtitle: Maybe<Scalars['String']>;
  timezone: Maybe<Scalars['String']>;
};

export type Page = {
  __typename?: 'Page';
  assets: Maybe<PageAssets>;
  blogPosts: Maybe<Array<Maybe<BlogPost>>>;
  content: Maybe<PageContent>;
  externalLede: Maybe<Scalars['String']>;
  externalTitle: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  internalLede: Maybe<Scalars['String']>;
  internalTitle: Maybe<Scalars['String']>;
  kind: Scalars['String'];
  name: Scalars['String'];
  path: Scalars['String'];
  playlists: Maybe<Array<Maybe<Playlist>>>;
  programs: Maybe<Array<Maybe<Page>>>;
  programsDetails: Maybe<Array<Maybe<ProgramsDetails>>>;
  slug: Scalars['String'];
  taxonomies: Maybe<TaxonomyForLandingPage>;
  testimonials: Maybe<Array<Maybe<Testimonial>>>;
  trailerVideo: Maybe<Video>;
  utmCampaign: Maybe<Scalars['String']>;
  videos: Maybe<Array<Maybe<Video>>>;
};

export type PageAssets = {
  __typename?: 'PageAssets';
  externalImage: Scalars['String'];
  internalImage: Scalars['String'];
  ledeVideos: Maybe<Array<Maybe<Video>>>;
  titleImage: Scalars['String'];
  titleVideo: Maybe<Video>;
};

export type PageContent = {
  __typename?: 'PageContent';
  body: Maybe<Scalars['String']>;
  body1: Maybe<Scalars['String']>;
  body2: Maybe<Scalars['String']>;
  body3: Maybe<Scalars['String']>;
  body4: Maybe<Scalars['String']>;
  body5: Maybe<Scalars['String']>;
  body6: Maybe<Scalars['String']>;
  englishTitle: Maybe<Scalars['String']>;
  externalLede: Maybe<Scalars['String']>;
  externalTitle: Maybe<Scalars['String']>;
  extraImages: Maybe<Scalars['String']>;
  internalLede: Maybe<Scalars['String']>;
  internalTitle: Maybe<Scalars['String']>;
  lede: Maybe<Scalars['String']>;
  localLanguageTitle: Maybe<Scalars['String']>;
  sanskritTitle: Maybe<Scalars['String']>;
  subtitle: Maybe<Scalars['String']>;
};

export type ProgramsDetails = {
  __typename?: 'ProgramsDetails';
  description: Scalars['String'];
  instructor: Maybe<Instructor>;
  label: Scalars['String'];
  perks: Maybe<Array<Maybe<Scalars['String']>>>;
  title: Scalars['String'];
  video: Maybe<Video>;
};

export type TaxonomyForLandingPage = {
  __typename?: 'TaxonomyForLandingPage';
  duration: Maybe<Term>;
  genre: Maybe<Term>;
  instructors: Maybe<Array<Instructor>>;
};

export type Testimonial = {
  __typename?: 'Testimonial';
  id: Scalars['ID'];
  imageUrl: Maybe<Scalars['String']>;
  name: Scalars['String'];
  quote: Scalars['String'];
  title: Scalars['String'];
};

export enum Provider {
  Apple = 'apple',
  Email = 'email',
  Facebook = 'facebook',
  Google = 'google'
}

export type Payment = {
  __typename?: 'Payment';
  amount: Scalars['String'];
  currency: Scalars['String'];
  date: Scalars['String'];
  downloadUrl: Maybe<Scalars['String']>;
  mobilePayment: Scalars['Boolean'];
  number: Scalars['String'];
  paymentProvider: Scalars['String'];
  paymentType: Scalars['String'];
  transact: Maybe<Scalars['String']>;
};

export type RegistrationDetail = {
  __typename?: 'RegistrationDetail';
  campaign: Maybe<Scalars['String']>;
  campaignCode: Maybe<Scalars['String']>;
  paymentType: Maybe<Scalars['String']>;
  redirectTo: Maybe<Scalars['String']>;
};

export type Statistics = {
  __typename?: 'Statistics';
  averageDuration: Maybe<Scalars['Int']>;
  favoriteStyle: Maybe<Term>;
  sessionsCompleted: Scalars['Int'];
  sessionsLastWeek: Scalars['Int'];
  totalTime: Scalars['Int'];
};

export type Story = {
  __typename?: 'Story';
  createdAt: Scalars['ISO8601DateTime'];
  hasAccess: Scalars['Boolean'];
  id: Scalars['ID'];
  progress: Scalars['Int'];
  resourceClass: Maybe<Scalars['String']>;
  resourceId: Scalars['ID'];
  updatedAt: Scalars['ISO8601DateTime'];
  userId: Scalars['ID'];
};

export type Subscription = {
  __typename?: 'Subscription';
  /** The latest plan (1m, 3m, 12, preglife, ninetynine ...) that user subscribed with, in other words, its the current subscription plan of the user of this subscripltion */
  currentSubscriptionPlan: SubscriptionPlan;
  /** In trial period if current subscription is trial and is active */
  inTrialPeriod: Scalars['Boolean'];
  /** Provider of the subscripton based on plan platform */
  provider: Maybe<Scalars['String']>;
  status: SubscriptionStatus;
  /** User access_until will be present only if user is on trial */
  trialExpiration: Maybe<Scalars['ISO8601Date']>;
};

export type SubscriptionPlan = {
  __typename?: 'SubscriptionPlan';
  amountCents: Scalars['Int'];
  amountCurrency: Scalars['String'];
  planType: Scalars['String'];
  platform: Maybe<DevicePlatformKind>;
  /** Not relevant for web platform */
  productId: Maybe<Scalars['String']>;
};

export enum SubscriptionStatus {
  Active = 'active',
  Cancelled = 'cancelled',
  PastDue = 'past_due',
  Unpaid = 'unpaid'
}

export type Topic = {
  __typename?: 'Topic';
  hasContent: Scalars['Boolean'];
  id: Scalars['ID'];
  imageUrl: Maybe<Scalars['String']>;
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type VideoNote = {
  __typename?: 'VideoNote';
  note: Maybe<Scalars['String']>;
  videoId: Maybe<Scalars['ID']>;
};

export type Client = {
  __typename?: 'Client';
  active: Scalars['Boolean'];
  bundles: Array<Bundle>;
  id: Scalars['ID'];
  logo: Maybe<Scalars['String']>;
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type BundleInfoPanel = {
  __typename?: 'BundleInfoPanel';
  description: Maybe<Scalars['String']>;
  image: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
};

export type BundleInfoPanel2 = {
  __typename?: 'BundleInfoPanel2';
  image: Maybe<Scalars['String']>;
  longText: Maybe<Scalars['String']>;
  previewText: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
};

export enum BundleKind {
  BySubscription = 'by_subscription',
  WithAccess = 'with_access'
}

export enum BundleSectionKind {
  BlogPosts = 'blog_posts',
  Challenges = 'challenges',
  Documents = 'documents',
  InfoPanel = 'info_panel',
  InfoPanel_2 = 'info_panel_2',
  LiveEvents = 'live_events',
  Playlists = 'playlists',
  Programs = 'programs',
  Videos = 'videos'
}

export type UserAccess = {
  __typename?: 'UserAccess';
  accessUntil: Maybe<Scalars['ISO8601DateTime']>;
  active: Scalars['Boolean'];
  id: Scalars['ID'];
  user: User;
};

export type User = UserInterface & {
  __typename?: 'User';
  accessToken: Maybe<Scalars['String']>;
  accessUntil: Maybe<Scalars['String']>;
  accountActivatedAt: Maybe<Scalars['ISO8601DateTime']>;
  address: Maybe<Scalars['String']>;
  assets: Maybe<Assets>;
  challengeParticipations: Array<Maybe<ChallengeParticipant>>;
  city: Maybe<Scalars['String']>;
  completedAt: Maybe<Scalars['ISO8601DateTime']>;
  country: Maybe<Scalars['String']>;
  courseAccesses: Array<Maybe<CourseAccess>>;
  dateOfBirth: Maybe<Scalars['Int']>;
  eligibleForDelete: Maybe<Scalars['Boolean']>;
  eligibleForTrial: Maybe<Scalars['Boolean']>;
  eligibleForTrialReclaim: Maybe<EligibleForTrialReclaimKind>;
  email: Maybe<Scalars['String']>;
  emailLanguage: Maybe<Scalars['String']>;
  extraPayments: Maybe<Array<Maybe<ExtraPayment>>>;
  favorites: Maybe<Favorites>;
  firstName: Maybe<Scalars['String']>;
  gender: Maybe<Scalars['String']>;
  group: Scalars['String'];
  hasWebPayments: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  interests: Maybe<Array<Interest>>;
  isEmailActivated: Maybe<Scalars['Boolean']>;
  isPublic: Maybe<Scalars['Boolean']>;
  kind: Maybe<Scalars['String']>;
  lastName: Maybe<Scalars['String']>;
  liveEventsAccess: Maybe<Array<Maybe<LiveEventAccess>>>;
  locale: Maybe<Scalars['String']>;
  nextBillingCycle: Maybe<NextBillingCycle>;
  onboardingCompleted: Scalars['Boolean'];
  onboardingInterestsSkipped: Scalars['Boolean'];
  onboardingSkipped: Scalars['Boolean'];
  onboardingTopicsSkipped: Scalars['Boolean'];
  paymentFailedAt: Maybe<Scalars['String']>;
  paymentType: Maybe<Scalars['String']>;
  paymentTypeRenews: Maybe<Scalars['Boolean']>;
  phone: Maybe<Scalars['String']>;
  playlists: Array<Maybe<Playlist>>;
  preferences: Maybe<Preferences>;
  previousEmail: Maybe<Scalars['String']>;
  privacySettings: Maybe<PrivacySettings>;
  profession: Maybe<Scalars['String']>;
  profile: Maybe<Profile>;
  programAccess: Array<Maybe<ProgramAccess>>;
  programs: Maybe<Array<Maybe<Page>>>;
  provider: Provider;
  receipts: Array<Maybe<Payment>>;
  referralCode: Maybe<Scalars['String']>;
  registrationDetail: RegistrationDetail;
  signUpPlatform: Maybe<Scalars['String']>;
  slug: Maybe<Scalars['String']>;
  statistics: Maybe<Statistics>;
  stories: Array<Story>;
  subscription: Subscription;
  subscriptionPlanSelected: Scalars['Boolean'];
  topics: Maybe<Array<Topic>>;
  trialPeriod: Maybe<Scalars['Int']>;
  url: Scalars['String'];
  videoNotes: Maybe<VideoNote>;
  zipcode: Maybe<Scalars['String']>;
};


export type UserEligibleForTrialReclaimArgs = {
  promotionName: UserDecisionKind;
};

export type WaitingItemInfo = {
  __typename?: 'WaitingItemInfo';
  startDate: Maybe<Scalars['ISO8601Date']>;
  waitingListEnabled: Maybe<Scalars['Boolean']>;
  waitingListEndDate: Maybe<Scalars['ISO8601Date']>;
  waitingListStartDate: Maybe<Scalars['ISO8601Date']>;
};

export type PagedBundles = PagedInterface & {
  __typename?: 'PagedBundles';
  data: Array<Bundle>;
  page: Scalars['Int'];
  perPage: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type CurrentUser = UserInterface & {
  __typename?: 'CurrentUser';
  accessToken: Maybe<Scalars['String']>;
  accessUntil: Maybe<Scalars['String']>;
  accountActivatedAt: Maybe<Scalars['ISO8601DateTime']>;
  address: Maybe<Scalars['String']>;
  assets: Maybe<Assets>;
  challengeParticipations: Array<Maybe<ChallengeParticipant>>;
  city: Maybe<Scalars['String']>;
  completedAt: Maybe<Scalars['ISO8601DateTime']>;
  country: Maybe<Scalars['String']>;
  courseAccesses: Array<Maybe<CourseAccess>>;
  dateOfBirth: Maybe<Scalars['Int']>;
  eligibleForDelete: Maybe<Scalars['Boolean']>;
  eligibleForTrial: Maybe<Scalars['Boolean']>;
  eligibleForTrialReclaim: Maybe<EligibleForTrialReclaimKind>;
  email: Maybe<Scalars['String']>;
  emailLanguage: Maybe<Scalars['String']>;
  extraPayments: Maybe<Array<Maybe<ExtraPayment>>>;
  favorites: Maybe<Favorites>;
  firstName: Maybe<Scalars['String']>;
  gender: Maybe<Scalars['String']>;
  group: Scalars['String'];
  hasWebPayments: Maybe<Scalars['Boolean']>;
  hasWellness: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  interests: Maybe<Array<Interest>>;
  isEmailActivated: Maybe<Scalars['Boolean']>;
  isNoneTrialPremium: Maybe<Scalars['Boolean']>;
  isPremium: Maybe<Scalars['Boolean']>;
  isPublic: Maybe<Scalars['Boolean']>;
  kind: Maybe<Scalars['String']>;
  lastName: Maybe<Scalars['String']>;
  liveEventsAccess: Maybe<Array<Maybe<LiveEventAccess>>>;
  locale: Maybe<Scalars['String']>;
  nextBillingCycle: Maybe<NextBillingCycle>;
  onboardingCompleted: Scalars['Boolean'];
  onboardingInterestsSkipped: Scalars['Boolean'];
  onboardingSkipped: Scalars['Boolean'];
  onboardingTopicsSkipped: Scalars['Boolean'];
  paymentFailedAt: Maybe<Scalars['String']>;
  paymentType: Maybe<Scalars['String']>;
  paymentTypeRenews: Maybe<Scalars['Boolean']>;
  phone: Maybe<Scalars['String']>;
  playlists: Array<Maybe<Playlist>>;
  preferences: Maybe<Preferences>;
  previousEmail: Maybe<Scalars['String']>;
  privacySettings: Maybe<PrivacySettings>;
  profession: Maybe<Scalars['String']>;
  profile: Maybe<Profile>;
  programAccess: Array<Maybe<ProgramAccess>>;
  programs: Maybe<Array<Maybe<Page>>>;
  provider: Provider;
  receipts: Array<Maybe<Payment>>;
  referralCode: Maybe<Scalars['String']>;
  registrationDetail: RegistrationDetail;
  signUpPlatform: Maybe<Scalars['String']>;
  slug: Maybe<Scalars['String']>;
  statistics: Maybe<Statistics>;
  stories: Array<Story>;
  subscription: Subscription;
  subscriptionPlanSelected: Scalars['Boolean'];
  topics: Maybe<Array<Topic>>;
  trialPeriod: Maybe<Scalars['Int']>;
  url: Scalars['String'];
  videoNotes: Maybe<VideoNote>;
  zipcode: Maybe<Scalars['String']>;
};


export type CurrentUserEligibleForTrialReclaimArgs = {
  promotionName: UserDecisionKind;
};

export type Email = {
  __typename?: 'Email';
  email: Maybe<Scalars['String']>;
  errors: Maybe<Array<Error>>;
  exists: Maybe<Scalars['Boolean']>;
};

/** A user-readable error */
export type Error = {
  __typename?: 'Error';
  /** A description of the error */
  message: Maybe<Scalars['String']>;
  /** Which input value this error came from, if error is validation error */
  path: Maybe<Array<Scalars['String']>>;
};

export type EmailPreference = {
  __typename?: 'EmailPreference';
  description: Scalars['String'];
  id: Scalars['ID'];
  isMuted: Scalars['Boolean'];
  key: Scalars['String'];
  mutable: Scalars['Boolean'];
  name: Scalars['String'];
};

export enum PlaylistSortAttribute {
  Alphabetical = 'alphabetical',
  NewestFirst = 'newest_first'
}

export type PagedPlaylists = PagedInterface & {
  __typename?: 'PagedPlaylists';
  data: Array<Playlist>;
  page: Scalars['Int'];
  perPage: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export enum VideoSortAttribute {
  Alphabetical = 'alphabetical',
  Duration = 'duration',
  Instructor = 'instructor',
  NewestFirst = 'newest_first'
}

export type FlipperFlag = {
  __typename?: 'FlipperFlag';
  name: Scalars['String'];
  value: Scalars['Boolean'];
};

export enum GenericProgramSortAttribute {
  Alphabetical = 'alphabetical',
  Duration = 'duration',
  NewestFirst = 'newest_first'
}

export type PagedGenericPrograms = PagedInterface & {
  __typename?: 'PagedGenericPrograms';
  data: Array<GenericProgram>;
  page: Scalars['Int'];
  perPage: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type GenericProgramWithCode = {
  __typename?: 'GenericProgramWithCode';
  code: Maybe<Scalars['String']>;
  codeStatus: Maybe<CodeStatusKind>;
  price: Maybe<Price>;
};

export enum CodeStatusKind {
  Invalid = 'invalid',
  Mismatch = 'mismatch',
  Valid = 'valid'
}

export type InstructorInGenre = {
  __typename?: 'InstructorInGenre';
  instructor: Maybe<Instructor>;
  videosCountInGenres: Maybe<Array<Maybe<VideosCountByGenre>>>;
};

export type VideosCountByGenre = {
  __typename?: 'VideosCountByGenre';
  channel: Maybe<Scalars['String']>;
  count: Maybe<Scalars['Int']>;
  slug: Maybe<Scalars['String']>;
};

export enum Option {
  All = 'all',
  CourseInstructorsOnly = 'course_instructors_only',
  LiveEventsInstructorsOnly = 'live_events_instructors_only',
  ProgramInstructorsOnly = 'program_instructors_only'
}

export enum SortAttribute {
  Name = 'name'
}

export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type PagedInstructors = PagedInterface & {
  __typename?: 'PagedInstructors';
  data: Array<Instructor>;
  page: Scalars['Int'];
  perPage: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type LiveEventCodes = {
  __typename?: 'LiveEventCodes';
  trial: Array<PromotionCode>;
  wellness: Array<PromotionCode>;
};

export type PromotionCode = {
  __typename?: 'PromotionCode';
  code: Scalars['String'];
  creationDate: Scalars['ISO8601DateTime'];
  expirationDate: Maybe<Scalars['ISO8601Date']>;
  matchingResources: Array<PromotionCodeResource>;
  provider: Maybe<Scalars['String']>;
  usageLimit: Maybe<Scalars['Int']>;
  usedIn: Array<PromotionCodeUser>;
};

export type PromotionCodeResource = Bundle | GenericProgram | LiveEvent;

export type PromotionCodeUser = {
  __typename?: 'PromotionCodeUser';
  live: Maybe<LiveEvent>;
  usageDate: Scalars['ISO8601DateTime'];
};

export enum LiveEventSortAttribute {
  AmountCents = 'amount_cents',
  FirstEventDate = 'first_event_date'
}

export type PagedLiveEvents = PagedInterface & {
  __typename?: 'PagedLiveEvents';
  availableKinds: Array<LiveEventKind>;
  data: Array<LiveEvent>;
  page: Scalars['Int'];
  perPage: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type OnboardingChoices = {
  __typename?: 'OnboardingChoices';
  interests: Array<Interest>;
  topics: Array<Topic>;
};

export type Order = GenericProgramPayment | LiveEventPayment | SubscriptionPayment;

export type GenericProgramPayment = OrderPaymentInterface & {
  __typename?: 'GenericProgramPayment';
  amountCents: Scalars['Int'];
  amountCurrency: CurrencyKind;
  orderId: Scalars['String'];
  originalAmountCents: Maybe<Scalars['Int']>;
  paymentProvider: PaymentProviderKind;
  program: GenericProgram;
  success: Scalars['Boolean'];
  voucher: Maybe<Scalars['Boolean']>;
};

export type OrderPaymentInterface = {
  amountCents: Scalars['Int'];
  amountCurrency: CurrencyKind;
  orderId: Scalars['String'];
  originalAmountCents: Maybe<Scalars['Int']>;
  paymentProvider: PaymentProviderKind;
  success: Scalars['Boolean'];
};

export enum CurrencyKind {
  Eur = 'EUR',
  Sek = 'SEK'
}

export enum PaymentProviderKind {
  Adyen = 'adyen',
  AdyenDibs = 'adyen_dibs',
  Apple = 'apple',
  Free = 'free',
  Google = 'google',
  Trustly = 'trustly',
  Wellness = 'wellness'
}

export type LiveEventPayment = OrderPaymentInterface & {
  __typename?: 'LiveEventPayment';
  amountCents: Scalars['Int'];
  amountCurrency: CurrencyKind;
  live: LiveEvent;
  orderId: Scalars['String'];
  originalAmountCents: Maybe<Scalars['Int']>;
  paymentProvider: PaymentProviderKind;
  success: Scalars['Boolean'];
};

export type SubscriptionPayment = OrderPaymentInterface & {
  __typename?: 'SubscriptionPayment';
  amountCents: Scalars['Int'];
  amountCurrency: CurrencyKind;
  months: Scalars['Int'];
  orderId: Scalars['String'];
  originalAmountCents: Maybe<Scalars['Int']>;
  paymentProvider: PaymentProviderKind;
  recurringAmountCents: Maybe<Scalars['Int']>;
  recurringDate: Maybe<Scalars['ISO8601Date']>;
  success: Scalars['Boolean'];
};

export type OverviewPlaylist = {
  __typename?: 'OverviewPlaylist';
  name: Scalars['String'];
  playlistId: Scalars['ID'];
  term: Scalars['String'];
};

export type PagedPages = PagedInterface & {
  __typename?: 'PagedPages';
  data: Array<Page>;
  page: Scalars['Int'];
  perPage: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type PaymentResponse = {
  __typename?: 'PaymentResponse';
  formFields: Maybe<FormFields>;
  url: Scalars['String'];
};

export type FormFields = {
  __typename?: 'FormFields';
  accepturl: Scalars['String'];
  amount: Scalars['Int'];
  billingAddress: Maybe<Scalars['String']>;
  billingFirstName: Maybe<Scalars['String']>;
  callbackurl: Scalars['String'];
  currency: Scalars['String'];
  decorator: Maybe<Scalars['String']>;
  email: Maybe<Scalars['String']>;
  lang: Maybe<Scalars['String']>;
  md5key: Maybe<Scalars['String']>;
  merchant: Scalars['Int'];
  orderid: Scalars['String'];
  ordline0_0: Maybe<Scalars['String']>;
  ordline0_1: Maybe<Scalars['String']>;
  ordline1_0: Maybe<Scalars['String']>;
  ordline1_1: Maybe<Scalars['String']>;
  ordline2_0: Maybe<Scalars['String']>;
  ordline2_1: Maybe<Scalars['String']>;
  preauth: Maybe<Scalars['Int']>;
  test: Maybe<Scalars['Int']>;
};

export type PhasedProgram = {
  __typename?: 'PhasedProgram';
  currentElement: Maybe<CurrentElement>;
  id: Scalars['ID'];
  instructors: Maybe<Array<Maybe<Instructor>>>;
  intro: Maybe<SpecialSection>;
  language: Maybe<Scalars['String']>;
  outro: Maybe<SpecialSection>;
  phases: Maybe<Array<Maybe<ProgramPhase>>>;
  phasesCount: Maybe<Scalars['Int']>;
  progress: Maybe<Scalars['Float']>;
  slug: Scalars['String'];
  title: Maybe<Scalars['String']>;
  videosCount: Maybe<Scalars['Int']>;
  weeksCount: Maybe<Scalars['Int']>;
};

export type CurrentElement = {
  __typename?: 'CurrentElement';
  path: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
};

export type SpecialSection = {
  __typename?: 'SpecialSection';
  assetUrl: Maybe<Scalars['String']>;
  content: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  label: Scalars['String'];
  slug: Scalars['String'];
  videos: Maybe<Array<Maybe<ProgramVideo>>>;
};

export type ProgramVideo = {
  __typename?: 'ProgramVideo';
  customDescription: Maybe<Scalars['String']>;
  customTitle: Maybe<Scalars['String']>;
  finished: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  locked: Scalars['Boolean'];
  position: Scalars['Int'];
  positionLabel: Scalars['String'];
  postMoodTracker: Maybe<MoodTracker>;
  preMoodTracker: Maybe<MoodTracker>;
  progressIsCurrent: Scalars['Boolean'];
  repeatRecomendation: Maybe<Scalars['Int']>;
  slug: Scalars['String'];
  subheader: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
  video: Video;
  videoKind: Maybe<VideoKind>;
  watched: Maybe<Scalars['Boolean']>;
};

export type MoodTracker = {
  __typename?: 'MoodTracker';
  finished: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  kind: MoodTrackerKind;
};

export enum MoodTrackerKind {
  Post = 'post',
  Pre = 'pre'
}

export enum VideoKind {
  Bonus = 'bonus',
  Exercise = 'exercise',
  Introduction = 'introduction',
  Lecture = 'lecture',
  Question = 'question',
  Skills = 'skills',
  Talk = 'talk',
  Workshop = 'workshop'
}

export type ProgramPhase = {
  __typename?: 'ProgramPhase';
  description: Maybe<Scalars['String']>;
  finished: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  label: Maybe<Scalars['String']>;
  locked: Scalars['Boolean'];
  progress: Maybe<Scalars['Float']>;
  slug: Scalars['String'];
  videosCount: Maybe<Scalars['Int']>;
  videosDuration: Maybe<Scalars['String']>;
  weeks: Maybe<Array<Maybe<ProgramWeek>>>;
  weeksRange: Maybe<Scalars['String']>;
};

export type ProgramWeek = {
  __typename?: 'ProgramWeek';
  description: Maybe<Scalars['String']>;
  duration: Maybe<Scalars['String']>;
  elements: Array<ProgramElement>;
  finished: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  indexInProgram: Maybe<Scalars['Int']>;
  label: Scalars['String'];
  locked: Scalars['Boolean'];
  progress: Maybe<Scalars['Float']>;
  slug: Scalars['String'];
  videos: Array<ProgramVideo>;
  videosCount: Maybe<Scalars['Int']>;
};

export type ProgramElement = ProgramDocument | ProgramPartElement | ProgramSurveyElement | ProgramVideo;

export type ProgramDocument = {
  __typename?: 'ProgramDocument';
  description: Maybe<Scalars['String']>;
  document: Document;
  finished: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  kind: Maybe<Scalars['String']>;
  locked: Scalars['Boolean'];
  position: Scalars['Int'];
  positionLabel: Scalars['String'];
  progressIsCurrent: Scalars['Boolean'];
  slug: Scalars['String'];
  subheader: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
};

export type ProgramPartElement = {
  __typename?: 'ProgramPartElement';
  description: Maybe<Scalars['String']>;
  finished: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  kind: Maybe<Scalars['String']>;
  locked: Scalars['Boolean'];
  position: Scalars['Int'];
  positionLabel: Scalars['String'];
  progressIsCurrent: Scalars['Boolean'];
  slug: Scalars['String'];
  subheader: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
};

export type ProgramSurveyElement = {
  __typename?: 'ProgramSurveyElement';
  description: Maybe<Scalars['String']>;
  finished: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  lastSubmittedAt: Maybe<Scalars['ISO8601Date']>;
  locked: Scalars['Boolean'];
  position: Scalars['Int'];
  positionLabel: Scalars['String'];
  progressIsCurrent: Scalars['Boolean'];
  slug: Scalars['String'];
  subheader: Maybe<Scalars['String']>;
  survey: Survey;
  surveysAnswer: Maybe<SurveyAnswer>;
  title: Maybe<Scalars['String']>;
};

export type Survey = {
  __typename?: 'Survey';
  content: SurveyContent;
  description: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  questions: Maybe<Array<Maybe<SurveyQuestion>>>;
  slug: Maybe<Scalars['String']>;
};

export type SurveyContent = {
  __typename?: 'SurveyContent';
  page1Description: Maybe<Scalars['String']>;
  page1Title: Maybe<Scalars['String']>;
  page2Description: Maybe<Scalars['String']>;
  page2Title: Maybe<Scalars['String']>;
  page3ButtonText: Maybe<Scalars['String']>;
  page3ButtonUrl: Maybe<Scalars['String']>;
  page3Description: Maybe<Scalars['String']>;
  page3Title: Maybe<Scalars['String']>;
};

export type SurveyQuestion = {
  __typename?: 'SurveyQuestion';
  answers: Maybe<Array<Scalars['String']>>;
  id: Scalars['String'];
  options: Maybe<SurveyOptions>;
  question: Maybe<Scalars['String']>;
};

export type SurveyOptions = {
  __typename?: 'SurveyOptions';
  default: Maybe<Scalars['String']>;
  hint: Maybe<Scalars['String']>;
  leftLabel: Maybe<Scalars['String']>;
  maxValue: Maybe<Scalars['Int']>;
  minValue: Maybe<Scalars['Int']>;
  required: Scalars['Boolean'];
  rightLabel: Maybe<Scalars['String']>;
  type: SurveyTypeKind;
  useForNps: Maybe<Scalars['Boolean']>;
};

export enum SurveyTypeKind {
  CheckBoxes = 'check_boxes',
  DropDown = 'drop_down',
  DropDownMulti = 'drop_down_multi',
  EmojiSlider = 'emoji_slider',
  Input = 'input',
  MoodSlider = 'mood_slider',
  NumericalSlider = 'numerical_slider',
  RadioButtons = 'radio_buttons',
  RadioSlider = 'radio_slider',
  RadioSlider2 = 'radio_slider2',
  StarRating = 'star_rating',
  TextArea = 'text_area'
}

export type SurveyAnswer = {
  __typename?: 'SurveyAnswer';
  content: Array<ContentAnswer>;
  contextableType: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  state: Maybe<State>;
  userId: Scalars['ID'];
};

export type ContentAnswer = {
  __typename?: 'ContentAnswer';
  key: Scalars['String'];
  value: Array<Scalars['String']>;
};

export enum State {
  Draft = 'draft',
  Finished = 'finished'
}

export type PlayOverview = {
  __typename?: 'PlayOverview';
  challenges: Maybe<Array<GenericProgram>>;
  liveEvents: Maybe<Array<LiveEvent>>;
  needs: Maybe<Array<Need>>;
  playlists: Maybe<Array<Playlist>>;
  programs: Maybe<Array<GenericProgram>>;
  videos: Maybe<Array<Video>>;
  videoSettings: Scalars['JSON'];
};

export type Need = {
  __typename?: 'Need';
  imageUrl: Scalars['String'];
  index: Scalars['Int'];
  name: Scalars['String'];
  settings: Scalars['JSON'];
  slug: Scalars['String'];
};

export type PagedBlogPosts = PagedInterface & {
  __typename?: 'PagedBlogPosts';
  data: Array<BlogPost>;
  page: Scalars['Int'];
  perPage: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type AppleSubscriptionPrecheck = {
  __typename?: 'AppleSubscriptionPrecheck';
  /** User to which this original_transaction_id is bounded */
  existingUser: Maybe<CurrentUser>;
  /** Shows whether this original_transaction_id is already bounded to some user or not */
  exists: Maybe<Scalars['Boolean']>;
};

export type ProgramActiveState = {
  __typename?: 'ProgramActiveState';
  day: Maybe<Program>;
  phase: Maybe<Program>;
  sequence: Maybe<Program>;
};

export type ProgramSurveyCompletion = {
  __typename?: 'ProgramSurveyCompletion';
  programAccessId: Scalars['ID'];
  programSurveyId: Scalars['ID'];
};

export type Recommendations = {
  __typename?: 'Recommendations';
  courses: Maybe<Array<Course>>;
  playlists: Maybe<Array<Playlist>>;
  videos: Maybe<Array<Video>>;
};

export type Search = {
  __typename?: 'Search';
  blogPosts: Maybe<SearchResults>;
  challenges: Maybe<SearchResults>;
  courses: Maybe<SearchResults>;
  events: Maybe<SearchResults>;
  genericPrograms: Maybe<SearchResults>;
  instructors: Maybe<SearchResults>;
  landingPages: Maybe<SearchResults>;
  liveEvents: Maybe<SearchResults>;
  playlists: Maybe<SearchResults>;
  query: Maybe<Scalars['String']>;
  suggestions: Maybe<Array<Scalars['String']>>;
  videos: Maybe<SearchResults>;
};

export type SearchResults = PagedInterface & {
  __typename?: 'SearchResults';
  page: Scalars['Int'];
  perPage: Scalars['Int'];
  results: Maybe<Array<SearchResult>>;
  totalCount: Scalars['Int'];
};

export type SearchResult = SearchBlogPost | SearchEvent | SearchGenericProgram | SearchInstructor | SearchLandingPage | SearchLiveEvent | SearchPlaylist | SearchVideo;

export type SearchBlogPost = {
  __typename?: 'SearchBlogPost';
  featuredImageUrl: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  slug: Scalars['String'];
  title: Scalars['String'];
};

export type SearchEvent = {
  __typename?: 'SearchEvent';
  description: Maybe<Scalars['String']>;
  endsAt: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  instructor: Maybe<Scalars['String']>;
  location: Maybe<Scalars['String']>;
  name: Scalars['String'];
  slug: Maybe<Scalars['String']>;
  startsAt: Maybe<Scalars['ISO8601DateTime']>;
  titleImageUrl: Maybe<Scalars['String']>;
};

export type SearchGenericProgram = {
  __typename?: 'SearchGenericProgram';
  accessPeriod: Maybe<AccessPeriod>;
  category: Maybe<Scalars['String']>;
  description: Scalars['String'];
  durationUnit: Maybe<Scalars['String']>;
  durationValue: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  instructorName: Maybe<Scalars['String']>;
  instructorSlug: Maybe<Scalars['String']>;
  price: Maybe<Price>;
  priceType: Maybe<PriceTypeKind>;
  slug: Maybe<Scalars['String']>;
  themes: Maybe<Array<ThemeKind>>;
  title: Scalars['String'];
  titleImageUrl: Maybe<Scalars['String']>;
};

export type SearchInstructor = {
  __typename?: 'SearchInstructor';
  description: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Maybe<Scalars['String']>;
  slug: Maybe<Scalars['String']>;
  squareImageUrl: Maybe<Scalars['String']>;
};

export type SearchLandingPage = {
  __typename?: 'SearchLandingPage';
  id: Scalars['ID'];
  lede: Maybe<Scalars['String']>;
  locale: Maybe<Scalars['String']>;
  slug: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
};

export type SearchLiveEvent = {
  __typename?: 'SearchLiveEvent';
  availableSpots: Maybe<Scalars['Int']>;
  bookingAvailable: Maybe<Scalars['Boolean']>;
  /** duration in minutes. Should step by 15 minutes, so 0, 15, 30, etc. */
  duration: Scalars['Int'];
  eventDates: Array<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  instructorName: Maybe<Scalars['String']>;
  instructorSlug: Maybe<Scalars['String']>;
  isComingSoon: Maybe<Scalars['Boolean']>;
  isExpired: Maybe<Scalars['Boolean']>;
  kind: LiveEventKind;
  maximumParticipants: Maybe<Scalars['Int']>;
  price: Maybe<Price>;
  registrationEndDate: Maybe<Scalars['ISO8601DateTime']>;
  registrationStartDate: Maybe<Scalars['ISO8601DateTime']>;
  slug: Maybe<Scalars['String']>;
  theme: Maybe<Scalars['String']>;
  thumbnailUrl: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type SearchPlaylist = {
  __typename?: 'SearchPlaylist';
  description: Scalars['String'];
  id: Scalars['ID'];
  identifier: Scalars['String'];
  minutes: Maybe<Scalars['String']>;
  ownerId: Maybe<Scalars['String']>;
  thumbnailUrl: Maybe<Scalars['String']>;
  title: Scalars['String'];
  videoCount: Maybe<Scalars['String']>;
  visibility: Maybe<Scalars['String']>;
};

export type SearchVideo = {
  __typename?: 'SearchVideo';
  id: Scalars['ID'];
  identifier: Scalars['String'];
  instructorName: Maybe<Scalars['String']>;
  instructorSlug: Maybe<Scalars['String']>;
  kind: Scalars['String'];
  longDescription: Scalars['String'];
  minutes: Scalars['String'];
  primaryStyleName: Maybe<Scalars['String']>;
  primaryStyleSlug: Maybe<Scalars['String']>;
  shortDescription: Scalars['String'];
  thumbnailUrl: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export enum ModelNameKind {
  BlogPosts = 'blog_posts',
  Challenges = 'challenges',
  Courses = 'courses',
  Events = 'events',
  GenericPrograms = 'generic_programs',
  Instructors = 'instructors',
  LandingPages = 'landing_pages',
  LiveEvents = 'live_events',
  Playlists = 'playlists',
  Videos = 'videos'
}

export type SpecificSearch = {
  __typename?: 'SpecificSearch';
  blogPosts: Maybe<SearchResults>;
  challenges: Maybe<SearchResults>;
  courses: Maybe<SearchResults>;
  events: Maybe<SearchResults>;
  genericPrograms: Maybe<SearchResults>;
  instructors: Maybe<SearchResults>;
  landingPages: Maybe<SearchResults>;
  liveEvents: Maybe<SearchResults>;
  playlists: Maybe<SearchResults>;
  query: Maybe<Scalars['String']>;
  suggestions: Maybe<Array<Scalars['String']>>;
  videos: Maybe<SearchResults>;
};

export type StartOverview = {
  __typename?: 'StartOverview';
  campaignSection: Maybe<CampaignSection>;
  coursesSection: Maybe<CoursesSection>;
  ctaSection: Maybe<CtaSection>;
  featuresSection: Maybe<FeaturesSection>;
  genresSection: Maybe<GenresSection>;
  heroSection: Maybe<HeroSection>;
  metaSection: Maybe<MetaSection>;
  mobileAppSection: Maybe<MobileAppSection>;
  otherFeaturesSection: Maybe<OtherFeaturesSection>;
  videoLibrarySection: Maybe<VideosLibrarySection>;
};

export type CampaignSection = {
  __typename?: 'CampaignSection';
  active: Maybe<Scalars['Boolean']>;
  buttonLink: Maybe<Scalars['String']>;
  buttonText: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  imageUrl: Maybe<Scalars['String']>;
  markets: Maybe<Array<Scalars['String']>>;
  tag: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
};

export type CoursesSection = {
  __typename?: 'CoursesSection';
  description: Maybe<Scalars['String']>;
  group1ButtonLink: Maybe<Scalars['String']>;
  group1ButtonText: Maybe<Scalars['String']>;
  group1Description: Maybe<Scalars['String']>;
  group1ImageUrl: Maybe<Scalars['String']>;
  group1Title: Maybe<Scalars['String']>;
  group2ButtonLink: Maybe<Scalars['String']>;
  group2ButtonText: Maybe<Scalars['String']>;
  group2Description: Maybe<Scalars['String']>;
  group2ImageUrl: Maybe<Scalars['String']>;
  group2Title: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
};

export type CtaSection = {
  __typename?: 'CtaSection';
  description: Maybe<Scalars['String']>;
  imageUrl: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
};

export type FeaturesSection = {
  __typename?: 'FeaturesSection';
  description: Maybe<Scalars['String']>;
  featureBullets: Maybe<Array<Scalars['String']>>;
  imageUrl: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
};

export type GenresSection = {
  __typename?: 'GenresSection';
  description: Maybe<Scalars['String']>;
  genre: Maybe<Array<PageSection>>;
  title: Maybe<Scalars['String']>;
};

export type PageSection = {
  __typename?: 'PageSection';
  description: Maybe<Scalars['String']>;
  imageUrl: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  otherType: Maybe<OtherTypeKind>;
  sectionType: Maybe<Scalars['String']>;
  slug: Maybe<SlugTypeKind>;
  title: Maybe<Scalars['String']>;
  url: Maybe<Scalars['String']>;
};

export enum OtherTypeKind {
  Challenges = 'challenges',
  Live = 'live',
  Playlists = 'playlists',
  Programs = 'programs',
  Videos = 'videos'
}

export enum SlugTypeKind {
  Breath = 'breath',
  Grow = 'grow',
  Meditate = 'meditate',
  Move = 'move',
  Yoga = 'yoga'
}

export type HeroSection = {
  __typename?: 'HeroSection';
  description: Maybe<Scalars['String']>;
  imageUrl: Maybe<Scalars['String']>;
  smallNote: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
};

export type MetaSection = {
  __typename?: 'MetaSection';
  description: Maybe<Scalars['String']>;
  imageUrl: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
};

export type MobileAppSection = {
  __typename?: 'MobileAppSection';
  description: Maybe<Scalars['String']>;
  imageUrl: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
};

export type OtherFeaturesSection = {
  __typename?: 'OtherFeaturesSection';
  description: Maybe<Scalars['String']>;
  otherFeatures: Maybe<Array<PageSection>>;
  title: Maybe<Scalars['String']>;
};

export type VideosLibrarySection = {
  __typename?: 'VideosLibrarySection';
  description: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
  videosLibrary: Maybe<Array<PageSection>>;
};

export type PagedSurveys = PagedInterface & {
  __typename?: 'PagedSurveys';
  data: Array<Survey>;
  page: Scalars['Int'];
  perPage: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type TaxonomyItem = {
  __typename?: 'TaxonomyItem';
  genres: Maybe<Array<Scalars['String']>>;
  hasPrio: Maybe<Scalars['Boolean']>;
  hierarchical: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  languages: Maybe<Array<Scalars['String']>>;
  name: Maybe<Scalars['String']>;
  slug: Maybe<Scalars['String']>;
  terms: Maybe<Array<Term>>;
  types: Maybe<Array<Scalars['String']>>;
};

export type Options = {
  __typename?: 'Options';
  professionLabels: Maybe<Array<Scalars['String']>>;
  professions: Maybe<Array<Scalars['String']>>;
};

export type PagedUsers = PagedInterface & {
  __typename?: 'PagedUsers';
  data: Array<UserInterface>;
  page: Scalars['Int'];
  perPage: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export enum StatsPeriodKind {
  SevenDays = 'sevenDays',
  ThirtyDays = 'thirtyDays'
}

export type Stats = {
  __typename?: 'Stats';
  numberOfChallengesStarted: Scalars['Int'];
  numberOfCoursesStarted: Scalars['Int'];
  numberOfLiveEventsBooked: Scalars['Int'];
  numberOfProgramsStarted: Scalars['Int'];
  playlistsCreated: Scalars['Int'];
  sessionsCompleted: Scalars['Int'];
  sessionsFavorited: Maybe<Scalars['Int']>;
  threeMostWatchedInstructors: Array<Instructor>;
  threeMostWatchedStyles: Array<Term>;
  totalWatchTime: Maybe<Scalars['Int']>;
};

export type ValidateCode = {
  __typename?: 'ValidateCode';
  code: Maybe<Scalars['String']>;
  codeDetails: Maybe<CodeDetails>;
  message: Maybe<Scalars['String']>;
  status: Maybe<CodeStatusKind>;
};

export type CodeDetails = {
  __typename?: 'CodeDetails';
  provider: Maybe<WellnessProviderKind>;
  type: PromotionCodeTypeKind;
};

export enum WellnessProviderKind {
  Actiway = 'Actiway',
  Benefits = 'Benefits',
  Benify = 'Benify',
  Epassi = 'Epassi',
  Wellnet = 'Wellnet'
}

export enum PromotionCodeTypeKind {
  Trial = 'trial',
  Wellness = 'wellness'
}

export type ValidateTransfer = {
  __typename?: 'ValidateTransfer';
  errors: Maybe<Scalars['String']>;
  valid: Maybe<Scalars['Boolean']>;
};

export enum VideoKindInput {
  Audio = 'audio',
  Video = 'video'
}

export enum VideoOrderBy {
  Alphabetical = 'alphabetical',
  Duration = 'duration',
  DurationAscending = 'duration_ascending',
  DurationDescending = 'duration_descending',
  Instructor = 'instructor',
  NewestFirst = 'newest_first',
  None = 'none',
  PublishedDescending = 'published_descending'
}

export type TaxonomyInput = {
  taxonomy: InputMaybe<Scalars['String']>;
  values: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WeeklyProgram = {
  __typename?: 'WeeklyProgram';
  currentElement: Maybe<CurrentElement>;
  description: Maybe<Scalars['String']>;
  finished: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  instructors: Maybe<Array<Maybe<Instructor>>>;
  intro: Maybe<SpecialSection>;
  outro: Maybe<SpecialSection>;
  progress: Maybe<Scalars['Float']>;
  recomendation: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  tags: Array<Scalars['String']>;
  videosCount: Maybe<Scalars['Int']>;
  weeks: Maybe<Array<Maybe<ProgramWeek>>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  accessTokensActivate: Maybe<ActivatePayload>;
  accessTokensValidate: Maybe<ValidatePayload>;
  /** legacy registration access code activate */
  activateAccessCode: Maybe<ActivateAccessCodePayload>;
  /** Activate bundle by access code */
  activateBundle: Maybe<ActivateBundlePayload>;
  /** Activate challenge by access code */
  activateChallenge: Maybe<ActivateChallengePayload>;
  /** Activate access code after checking it in availableSubscriptions query */
  activateFullAccessCode: Maybe<ActivateFullAccessCodePayload>;
  /** Activate generic program if user has access */
  activateGenericProgram: Maybe<ActivateGenericProgramPayload>;
  activateLegacyPausaSmart: Maybe<ActivateLegacyPausaSmartPayload>;
  activateLiveEvent: Maybe<ActivateLiveEventPayload>;
  /** Activate one time code after checking it in availableSubscriptions query */
  activateOneTimeCode: Maybe<ActivateOneTimeCodePayload>;
  activatePausaSmart: Maybe<ActivatePausaSmartPayload>;
  /** Set trial days to extend the access_until, but do not extend yet */
  activateTrialExtension: Maybe<ActivateTrialExtensionPayload>;
  addComment: Maybe<AddCommentPayload>;
  addFavoritePlaylist: Maybe<AddFavoritePlaylistPayload>;
  addFavoriteVideo: Maybe<AddFavoriteVideoPayload>;
  addMoodTrackerAnswer: Maybe<AddMoodTrackerAnswerPayload>;
  addPlaylist: Maybe<AddPlaylistPayload>;
  addSearchResult: Maybe<AddSearchResultPayload>;
  addStory: Maybe<AddStoryPayload>;
  addUserFeedback: Maybe<AddUserFeedbackPayload>;
  addUserSchedule: Maybe<AddUserSchedulePayload>;
  addVideoToPlaylist: Maybe<AddVideoToPlaylistPayload>;
  addWaitingItem: Maybe<AddWaitingItemPayload>;
  answerSurvey: Maybe<AnswerSurveyPayload>;
  assignMobileDevice: Maybe<AssignMobileDevicePayload>;
  authenticateUser: Maybe<AuthenticateUserPayload>;
  cancelSubscription: Maybe<CancelSubscriptionPayload>;
  changeEmailPreference: Maybe<ChangeEmailPreferencePayload>;
  changePassword: Maybe<ChangePasswordPayload>;
  changePreferences: Maybe<ChangePreferencesPayload>;
  changeProductEmailPreference: Maybe<ChangeProductEmailPreferencePayload>;
  changeProfileData: Maybe<ChangeProfileDataPayload>;
  changeProfileInfo: Maybe<ChangeProfileInfoPayload>;
  changeProfilePrivacy: Maybe<ChangeProfilePrivacyPayload>;
  completeProfile: Maybe<CompleteProfilePayload>;
  /** Confirms email and extends current user access_until (whatever it is) by default 14 days given during registration or by trialPeriod set previously in activateTrialExtension mutation */
  confirmEmail: Maybe<ConfirmEmailPayload>;
  createNewPassword: Maybe<CreateNewPasswordPayload>;
  deleteAccount: Maybe<DeleteAccountPayload>;
  deleteAvatar: Maybe<DeleteAvatarPayload>;
  deleteFavoritePlaylist: Maybe<DeleteFavoritePlaylistPayload>;
  deleteFavoriteVideo: Maybe<DeleteFavoriteVideoPayload>;
  deletePlaylist: Maybe<DeletePlaylistPayload>;
  eventProxy: Maybe<EventProxyPayload>;
  login: Maybe<LoginPayload>;
  logout: Maybe<LogoutPayload>;
  participateInAnEvent: Maybe<ParticipateInAnEventPayload>;
  patchPlaylist: Maybe<PatchPlaylistPayload>;
  patchStory: Maybe<PatchStoryPayload>;
  patchUser: Maybe<ChangePreferencesPayload>;
  payForItem: Maybe<PayForItemPayload>;
  payForVoucher: Maybe<PayForVoucherPayload>;
  paymentsStoreAdyenDropin: Maybe<StoreAdyenDropinPayload>;
  paymentsStorePaymentDetails: Maybe<StorePaymentDetailsPayload>;
  paymentsStoreTrustly: Maybe<StoreTrustlyPayload>;
  reclaimTrial: Maybe<ReclaimTrialPayload>;
  removeVideoFromPlaylist: Maybe<RemoveVideoFromPlaylistPayload>;
  resendConfirmationEmail: Maybe<ResendConfirmationEmailPayload>;
  resetEmailConfirmation: Maybe<ResetEmailConfirmationPayload>;
  resetPassword: Maybe<ResetPasswordPayload>;
  resetSummerCampaign: Maybe<ResetSummerCampaignPayload>;
  /** Restore the subscription foruser that has another Yogobe account on his mobile account (appstore/playstore) */
  restoreMobileSubscription: Maybe<RestoreMobileSubscriptionPayload>;
  saveOnboardingChoices: Maybe<SaveOnboardingChoicesPayload>;
  savePhasedProgramProgress: Maybe<SavePhasedProgramProgressPayload>;
  saveProgramProgress: Maybe<SaveProgramProgressPayload>;
  signUp: Maybe<RegistrationPayload>;
  signUpV2: Maybe<RegistrationV2Payload>;
  socialSignIn: Maybe<SignInPayload>;
  socialSignUp: Maybe<SignUpPayload>;
  storeTransactionId: Maybe<StoreTransactionIdPayload>;
  storeUserDecision: Maybe<StoreUserDecisionPayload>;
  submitInterestForm: Maybe<SubmitInterestFormPayload>;
  /** Validate challenge access code */
  validateChallengeToken: Maybe<ValidateTokenPayload>;
  validateProgramCode: Maybe<ValidateProgramCodePayload>;
  videoFavorite: Maybe<FavoritePayload>;
  videoWatch: Maybe<WatchPayload>;
  videoWatchCompleted: Maybe<WatchCompletedPayload>;
};


export type MutationAccessTokensActivateArgs = {
  accessToken: Scalars['String'];
};


export type MutationAccessTokensValidateArgs = {
  accessToken: Scalars['String'];
};


export type MutationActivateAccessCodeArgs = {
  accessCode: Scalars['String'];
  userId: Scalars['ID'];
};


export type MutationActivateBundleArgs = {
  client: Scalars['String'];
  code: InputMaybe<Scalars['String']>;
  slug: Scalars['String'];
};


export type MutationActivateChallengeArgs = {
  accessCode: InputMaybe<Scalars['String']>;
  challenge: InputMaybe<Scalars['String']>;
};


export type MutationActivateFullAccessCodeArgs = {
  code: Scalars['String'];
  promotionName: Scalars['String'];
};


export type MutationActivateGenericProgramArgs = {
  accessCode: InputMaybe<Scalars['String']>;
  slug: Scalars['String'];
};


export type MutationActivateLegacyPausaSmartArgs = {
  accessCode: Scalars['String'];
  email: Scalars['String'];
  fullName: Scalars['String'];
};


export type MutationActivateLiveEventArgs = {
  code: Scalars['String'];
  slug: Scalars['String'];
};


export type MutationActivateOneTimeCodeArgs = {
  code: Scalars['String'];
  promotionName: Scalars['String'];
};


export type MutationActivateTrialExtensionArgs = {
  code: Scalars['String'];
  platform: DevicePlatformKind;
  promotionName: Scalars['String'];
};


export type MutationAddCommentArgs = {
  description: Scalars['String'];
  resourceClass: InputMaybe<Scalars['String']>;
  resourceId: Scalars['ID'];
};


export type MutationAddFavoritePlaylistArgs = {
  playlistId: Scalars['ID'];
};


export type MutationAddFavoriteVideoArgs = {
  videoId: Scalars['ID'];
};


export type MutationAddMoodTrackerAnswerArgs = {
  answer1: Scalars['Int'];
  answer2: Scalars['Int'];
  answer3: Scalars['Int'];
  answer4: Scalars['Int'];
  kind: SurveyKind;
  moodTrackerId: Scalars['ID'];
};


export type MutationAddPlaylistArgs = {
  description?: InputMaybe<Scalars['String']>;
  publishedAt: InputMaybe<Scalars['ISO8601DateTime']>;
  publishedState?: InputMaybe<Scalars['String']>;
  title: InputMaybe<Scalars['String']>;
  videos: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  visibility: InputMaybe<Scalars['String']>;
};


export type MutationAddSearchResultArgs = {
  documentId: Scalars['String'];
  modelType: ModelNameKind;
  query: Scalars['String'];
};


export type MutationAddStoryArgs = {
  resourceClass: InputMaybe<Scalars['String']>;
  resourceId: Scalars['ID'];
};


export type MutationAddUserFeedbackArgs = {
  bugs: InputMaybe<Scalars['String']>;
  message: Scalars['String'];
  rating: InputMaybe<Scalars['Int']>;
  url: Scalars['String'];
};


export type MutationAddUserScheduleArgs = {
  datetime: Scalars['ISO8601DateTime'];
  resourceId: Scalars['ID'];
  returnFormat: Scalars['String'];
};


export type MutationAddVideoToPlaylistArgs = {
  playlistId: Scalars['ID'];
  videoId: Scalars['ID'];
};


export type MutationAddWaitingItemArgs = {
  itemId: Scalars['ID'];
  itemType: ItemTypeKind;
};


export type MutationAnswerSurveyArgs = {
  answers: InputMaybe<Array<AnswerInput>>;
  surveyAction: ActionInput;
  surveyAnswerId: InputMaybe<Scalars['ID']>;
  surveyPartId: Scalars['ID'];
};


export type MutationAssignMobileDeviceArgs = {
  appLabel: InputMaybe<Scalars['String']>;
  appVersion: InputMaybe<Scalars['String']>;
  platform: DevicePlatformKind;
  token: Scalars['String'];
};


export type MutationAuthenticateUserArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};


export type MutationChangeEmailPreferenceArgs = {
  email: InputMaybe<Scalars['String']>;
  key: Scalars['String'];
  mute: Scalars['Boolean'];
  token: InputMaybe<Scalars['String']>;
};


export type MutationChangePasswordArgs = {
  password: Scalars['String'];
};


export type MutationChangePreferencesArgs = {
  contentLanguages: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  excludeTerms: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  videoLevels: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type MutationChangeProductEmailPreferenceArgs = {
  email: InputMaybe<Scalars['String']>;
  key: Scalars['String'];
  mute: Scalars['Boolean'];
  productName: ClassName;
  token: InputMaybe<Scalars['String']>;
};


export type MutationChangeProfileDataArgs = {
  avatar: InputMaybe<Scalars['Upload']>;
  displayName: InputMaybe<Scalars['String']>;
  facebookUrl: InputMaybe<Scalars['String']>;
  instagramUrl: InputMaybe<Scalars['String']>;
  linkedinUrl: InputMaybe<Scalars['String']>;
  shortBio: InputMaybe<Scalars['String']>;
  timezone: InputMaybe<Scalars['String']>;
};


export type MutationChangeProfileInfoArgs = {
  address: InputMaybe<Scalars['String']>;
  city: InputMaybe<Scalars['String']>;
  dateOfBirth: InputMaybe<Scalars['String']>;
  email: InputMaybe<Scalars['String']>;
  firstName: InputMaybe<Scalars['String']>;
  lastName: InputMaybe<Scalars['String']>;
  phone: InputMaybe<Scalars['String']>;
  profession: InputMaybe<Scalars['String']>;
  zipcode: InputMaybe<Scalars['String']>;
};


export type MutationChangeProfilePrivacyArgs = {
  isPrivateFavorites: InputMaybe<Scalars['Boolean']>;
  isPrivateProfile: InputMaybe<Scalars['Boolean']>;
  isPrivateStats: InputMaybe<Scalars['Boolean']>;
};


export type MutationCompleteProfileArgs = {
  address: InputMaybe<Scalars['String']>;
  campaign: InputMaybe<Scalars['String']>;
  city: InputMaybe<Scalars['String']>;
  country: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  gender: InputMaybe<GenderKind>;
  oneTimeCode: InputMaybe<Scalars['String']>;
  phone: InputMaybe<Scalars['String']>;
  platform: DevicePlatformKind;
  postalCode: InputMaybe<Scalars['String']>;
  trialExtensionCode: InputMaybe<Scalars['String']>;
};


export type MutationConfirmEmailArgs = {
  token: Scalars['String'];
};


export type MutationCreateNewPasswordArgs = {
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
  passwordToken: Scalars['String'];
};


export type MutationDeleteAccountArgs = {
  deletionReason: Scalars['String'];
};


export type MutationDeleteFavoritePlaylistArgs = {
  playlistId: Scalars['ID'];
};


export type MutationDeleteFavoriteVideoArgs = {
  videoId: Scalars['ID'];
};


export type MutationDeletePlaylistArgs = {
  id: Scalars['ID'];
};


export type MutationEventProxyArgs = {
  event: ProxyEventKind;
  properties?: InputMaybe<Array<EventPropertyInput>>;
};


export type MutationLoginArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};


export type MutationParticipateInAnEventArgs = {
  slug: Scalars['String'];
};


export type MutationPatchPlaylistArgs = {
  description: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  title: InputMaybe<Scalars['String']>;
  videos: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  visibility: InputMaybe<Scalars['String']>;
};


export type MutationPatchStoryArgs = {
  id: Scalars['ID'];
  progress: Scalars['Int'];
  resourceClass: InputMaybe<Scalars['String']>;
  resourceId: Scalars['ID'];
};


export type MutationPatchUserArgs = {
  contentLanguages: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  excludeTerms: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  videoLevels: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type MutationPayForItemArgs = {
  browserInfo: InputMaybe<BrowserInfoInput>;
  discountCode: InputMaybe<Scalars['String']>;
  itemKind: ItemKind;
  paymentMethod: PaymentMethodInput;
  redirectToFailed: InputMaybe<Scalars['String']>;
  redirectToSuccess: InputMaybe<Scalars['String']>;
  riskData: InputMaybe<RiskDataInput>;
  slug: Scalars['String'];
};


export type MutationPayForVoucherArgs = {
  browserInfo: InputMaybe<BrowserInfoInput>;
  customMessage: InputMaybe<Scalars['String']>;
  discountCode: InputMaybe<Scalars['String']>;
  itemKind: ItemKind;
  paymentMethod: PaymentMethodInput;
  recipientEmail: Scalars['String'];
  recipientName: Scalars['String'];
  redirectToFailed: InputMaybe<Scalars['String']>;
  redirectToSuccess: InputMaybe<Scalars['String']>;
  riskData: InputMaybe<RiskDataInput>;
  senderName: Scalars['String'];
  sendGiftEmail: Scalars['Boolean'];
  slug: Scalars['String'];
};


export type MutationPaymentsStoreAdyenDropinArgs = {
  browserInfo: InputMaybe<BrowserInfoInput>;
  paymentMethod: PaymentMethodInput;
  paymentType: Scalars['String'];
  redirectTo: InputMaybe<Scalars['String']>;
  riskData: InputMaybe<RiskDataInput>;
  storePaymentMethod: InputMaybe<Scalars['Boolean']>;
};


export type MutationPaymentsStorePaymentDetailsArgs = {
  detailsMd: InputMaybe<Scalars['String']>;
  detailsPaRes: InputMaybe<Scalars['String']>;
  detailsReturnUrlQueryString: InputMaybe<Scalars['String']>;
  orderId: Scalars['String'];
  paymentData: InputMaybe<Scalars['String']>;
  threeds2ChallengeResult: InputMaybe<Scalars['String']>;
  threeds2Fingerprint: InputMaybe<Scalars['String']>;
};


export type MutationPaymentsStoreTrustlyArgs = {
  paymentType: Scalars['String'];
  redirectTo: InputMaybe<Scalars['String']>;
};


export type MutationReclaimTrialArgs = {
  code: Scalars['String'];
  source: Scalars['String'];
};


export type MutationRemoveVideoFromPlaylistArgs = {
  playlistId: Scalars['ID'];
  videoId: Scalars['ID'];
};


export type MutationResendConfirmationEmailArgs = {
  email: Scalars['String'];
};


export type MutationResetEmailConfirmationArgs = {
  token: Scalars['String'];
};


export type MutationResetPasswordArgs = {
  email: Scalars['String'];
};


export type MutationResetSummerCampaignArgs = {
  programId: Scalars['ID'];
};


export type MutationRestoreMobileSubscriptionArgs = {
  platform: DevicePlatformKind;
  purchaseIdentifier: InputMaybe<Scalars['String']>;
};


export type MutationSaveOnboardingChoicesArgs = {
  interestSlugs?: InputMaybe<Array<Scalars['String']>>;
  topicSlugs?: InputMaybe<Array<Scalars['String']>>;
};


export type MutationSavePhasedProgramProgressArgs = {
  documentPartId: InputMaybe<Scalars['ID']>;
  programPartElementId: InputMaybe<Scalars['ID']>;
  videoPartId: InputMaybe<Scalars['ID']>;
};


export type MutationSaveProgramProgressArgs = {
  programId: Scalars['ID'];
};


export type MutationSignUpArgs = {
  address: Scalars['String'];
  campaign: InputMaybe<Scalars['String']>;
  campaignCode: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  country: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  gender: InputMaybe<GenderKind>;
  lastName: Scalars['String'];
  oneTimeCode: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  paymentType: InputMaybe<Scalars['String']>;
  phone: InputMaybe<Scalars['String']>;
  platform: DevicePlatformKind;
  postalCode: Scalars['String'];
  redirectTo: InputMaybe<Scalars['String']>;
  trialExtensionCode: InputMaybe<Scalars['String']>;
  utmCampaign: InputMaybe<Scalars['String']>;
  utmMedium: InputMaybe<Scalars['String']>;
  utmSource: InputMaybe<Scalars['String']>;
};


export type MutationSignUpV2Args = {
  campaign: InputMaybe<Scalars['String']>;
  campaignCode: InputMaybe<Scalars['String']>;
  country: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  paymentType: InputMaybe<Scalars['String']>;
  platform: DevicePlatformKind;
  redirectTo: InputMaybe<Scalars['String']>;
  utmCampaign: InputMaybe<Scalars['String']>;
  utmMedium: InputMaybe<Scalars['String']>;
  utmSource: InputMaybe<Scalars['String']>;
};


export type MutationSocialSignInArgs = {
  accessToken: InputMaybe<Scalars['String']>;
  code: InputMaybe<Scalars['String']>;
  identityToken: InputMaybe<Scalars['String']>;
  method: MethodTypes;
  platform: DevicePlatformKind;
  provider: ProviderTypes;
};


export type MutationSocialSignUpArgs = {
  accessToken: InputMaybe<Scalars['String']>;
  avatarFromUrl: InputMaybe<Scalars['String']>;
  campaignCode: InputMaybe<Scalars['String']>;
  code: InputMaybe<Scalars['String']>;
  firstName: InputMaybe<Scalars['String']>;
  identityToken: InputMaybe<Scalars['String']>;
  lastName: InputMaybe<Scalars['String']>;
  method: MethodTypes;
  paymentType: InputMaybe<Scalars['String']>;
  platform: DevicePlatformKind;
  provider: ProviderTypes;
  redirectTo: InputMaybe<Scalars['String']>;
  utmCampaign: InputMaybe<Scalars['String']>;
  utmMedium: InputMaybe<Scalars['String']>;
  utmSource: InputMaybe<Scalars['String']>;
};


export type MutationStoreTransactionIdArgs = {
  transactionId: Scalars['String'];
};


export type MutationStoreUserDecisionArgs = {
  decision: UserDecisionKind;
  value: InputMaybe<Scalars['Boolean']>;
};


export type MutationSubmitInterestFormArgs = {
  comment: InputMaybe<Scalars['String']>;
  companyName: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  fullName: Scalars['String'];
  page: Scalars['String'];
};


export type MutationValidateChallengeTokenArgs = {
  accessToken: Scalars['String'];
};


export type MutationValidateProgramCodeArgs = {
  code: InputMaybe<Scalars['String']>;
  slug: Scalars['String'];
};


export type MutationVideoFavoriteArgs = {
  videoId: Scalars['String'];
};


export type MutationVideoWatchArgs = {
  cursorAt: Scalars['Int'];
  seconds: Scalars['Int'];
  videoId: Scalars['String'];
};


export type MutationVideoWatchCompletedArgs = {
  cursorAt: Scalars['Int'];
  seconds: Scalars['Int'];
  videoId: Scalars['String'];
};

/** Autogenerated return type of Activate */
export type ActivatePayload = {
  __typename?: 'ActivatePayload';
  accessToken: Maybe<AccessToken>;
  errors: Array<ProcessingError>;
  genericProgram: Maybe<GenericProgram>;
};

export type AccessToken = {
  __typename?: 'AccessToken';
  accessUntil: Maybe<Scalars['String']>;
  code: Scalars['String'];
  id: Scalars['ID'];
};

/** The usual errors like 404, 403 etc. */
export type ProcessingError = {
  __typename?: 'ProcessingError';
  /** A description of the error */
  message: Maybe<Scalars['String']>;
  /** The error class */
  status: Maybe<ErrorValue>;
};

export enum ErrorValue {
  /** Current access is longer than given from access token */
  AccessShorter = 'AccessShorter',
  /** New Access Until is missing */
  AccessUntilMissing = 'AccessUntilMissing',
  /** User already has active program access */
  AlreadyAccessed = 'AlreadyAccessed',
  /** Not allowed */
  AlreadyUsed = 'AlreadyUsed',
  /** Answers are invalid */
  AnswersInvalid = 'AnswersInvalid',
  /** Answers have not been saved */
  AnswersNotSaved = 'AnswersNotSaved',
  /** User does not have access to this program */
  NoAccess = 'NoAccess',
  /** No appropriate program */
  NoActiveProgram = 'NoActiveProgram',
  /** 403 Forbidden */
  NotAuthorized = 'NotAuthorized',
  /** Survey has not been marked as completed */
  NotCompleted = 'NotCompleted',
  /** 404 Not found */
  NotFound = 'NotFound',
  /** Program has not been unlocked */
  NotUnlocked = 'NotUnlocked',
  /** ProgramProgress not created successfully */
  ProgramProgressNotCreated = 'ProgramProgressNotCreated',
  /** Survey part has not been found */
  SurveyNotFound = 'SurveyNotFound',
  /** User is missing */
  UserMissing = 'UserMissing'
}

/** Autogenerated return type of Validate */
export type ValidatePayload = {
  __typename?: 'ValidatePayload';
  errors: Array<ProcessingError>;
  program: Maybe<GenericProgram>;
  status: Scalars['String'];
  url: Maybe<Scalars['String']>;
};

/** Autogenerated return type of ActivateAccessCode */
export type ActivateAccessCodePayload = {
  __typename?: 'ActivateAccessCodePayload';
  accessToken: Maybe<AccessToken>;
  errors: Maybe<Array<Maybe<ProcessingError>>>;
};

/** Autogenerated return type of ActivateBundle */
export type ActivateBundlePayload = {
  __typename?: 'ActivateBundlePayload';
  errors: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of ActivateChallenge */
export type ActivateChallengePayload = {
  __typename?: 'ActivateChallengePayload';
  challengeParticipation: Maybe<ChallengeParticipant>;
  challengePass: Maybe<ChallengePass>;
  errors: Maybe<Array<Error>>;
};

export type ChallengePass = {
  __typename?: 'ChallengePass';
  challenge: Challenge;
  code: Maybe<Scalars['String']>;
  days: Maybe<Scalars['Int']>;
};

/** Autogenerated return type of ActivateFullAccessCode */
export type ActivateFullAccessCodePayload = {
  __typename?: 'ActivateFullAccessCodePayload';
  errors: Maybe<Array<Error>>;
  success: Maybe<Scalars['Boolean']>;
  user: Maybe<CurrentUser>;
};

/** Autogenerated return type of ActivateGenericProgram */
export type ActivateGenericProgramPayload = {
  __typename?: 'ActivateGenericProgramPayload';
  errors: Maybe<Array<Error>>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of ActivateLegacyPausaSmart */
export type ActivateLegacyPausaSmartPayload = {
  __typename?: 'ActivateLegacyPausaSmartPayload';
  accessDays: Maybe<Scalars['Int']>;
  accessUntil: Maybe<Scalars['ISO8601Date']>;
  action: Maybe<Scalars['String']>;
  errors: Maybe<Array<Maybe<ProcessingError>>>;
};

/** Autogenerated return type of ActivateLiveEvent */
export type ActivateLiveEventPayload = {
  __typename?: 'ActivateLiveEventPayload';
  errors: Maybe<Scalars['String']>;
  liveEventAccess: Maybe<UserAccess>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of ActivateOneTimeCode */
export type ActivateOneTimeCodePayload = {
  __typename?: 'ActivateOneTimeCodePayload';
  errors: Maybe<Array<Error>>;
  success: Maybe<Scalars['Boolean']>;
  user: Maybe<CurrentUser>;
};

/** Autogenerated return type of ActivatePausaSmart */
export type ActivatePausaSmartPayload = {
  __typename?: 'ActivatePausaSmartPayload';
  success: Scalars['Boolean'];
};

/** Autogenerated return type of ActivateTrialExtension */
export type ActivateTrialExtensionPayload = {
  __typename?: 'ActivateTrialExtensionPayload';
  errors: Maybe<Array<Error>>;
  success: Maybe<Scalars['Boolean']>;
  user: Maybe<CurrentUser>;
};

/** Autogenerated return type of AddComment */
export type AddCommentPayload = {
  __typename?: 'AddCommentPayload';
  comment: Maybe<Comment>;
};

export type Comment = {
  __typename?: 'Comment';
  description: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  resourceClass: Maybe<Scalars['String']>;
  resourceId: Scalars['ID'];
  userId: Scalars['ID'];
};

/** Autogenerated return type of AddFavoritePlaylist */
export type AddFavoritePlaylistPayload = {
  __typename?: 'AddFavoritePlaylistPayload';
  playlist: Maybe<Playlist>;
};

/** Autogenerated return type of AddFavoriteVideo */
export type AddFavoriteVideoPayload = {
  __typename?: 'AddFavoriteVideoPayload';
  video: Maybe<Video>;
};

/** Autogenerated return type of AddMoodTrackerAnswer */
export type AddMoodTrackerAnswerPayload = {
  __typename?: 'AddMoodTrackerAnswerPayload';
  errors: Array<Scalars['String']>;
  status: Scalars['Boolean'];
};

/** Autogenerated return type of AddPlaylist */
export type AddPlaylistPayload = {
  __typename?: 'AddPlaylistPayload';
  playlist: Maybe<Playlist>;
};

/** Autogenerated return type of AddSearchResult */
export type AddSearchResultPayload = {
  __typename?: 'AddSearchResultPayload';
  documentId: Maybe<Scalars['String']>;
};

/** Autogenerated return type of AddStory */
export type AddStoryPayload = {
  __typename?: 'AddStoryPayload';
  story: Maybe<Story>;
};

/** Autogenerated return type of AddUserFeedback */
export type AddUserFeedbackPayload = {
  __typename?: 'AddUserFeedbackPayload';
  success: Scalars['Boolean'];
};

/** Autogenerated return type of AddUserSchedule */
export type AddUserSchedulePayload = {
  __typename?: 'AddUserSchedulePayload';
  filename: Maybe<Scalars['String']>;
  result: Maybe<Scalars['String']>;
};

/** Autogenerated return type of AddVideoToPlaylist */
export type AddVideoToPlaylistPayload = {
  __typename?: 'AddVideoToPlaylistPayload';
  playlist: Maybe<Playlist>;
};

export enum ItemTypeKind {
  Bundle = 'Bundle'
}

/** Autogenerated return type of AddWaitingItem */
export type AddWaitingItemPayload = {
  __typename?: 'AddWaitingItemPayload';
  errors: Maybe<Array<Scalars['String']>>;
  success: Scalars['Boolean'];
};

export type AnswerInput = {
  id: Scalars['ID'];
  values: InputMaybe<Array<Scalars['String']>>;
};

export enum ActionInput {
  Complete = 'COMPLETE',
  Draft = 'DRAFT'
}

/** Autogenerated return type of AnswerSurvey */
export type AnswerSurveyPayload = {
  __typename?: 'AnswerSurveyPayload';
  errors: Array<ProcessingError>;
};

/** Autogenerated return type of AssignMobileDevice */
export type AssignMobileDevicePayload = {
  __typename?: 'AssignMobileDevicePayload';
  errors: Maybe<Array<Error>>;
  user: Maybe<CurrentUser>;
};

/** Autogenerated return type of AuthenticateUser */
export type AuthenticateUserPayload = {
  __typename?: 'AuthenticateUserPayload';
  token: Maybe<Scalars['String']>;
  user: Maybe<UserInterface>;
};

/** Autogenerated return type of CancelSubscription */
export type CancelSubscriptionPayload = {
  __typename?: 'CancelSubscriptionPayload';
  success: Scalars['Boolean'];
};

/** Autogenerated return type of ChangeEmailPreference */
export type ChangeEmailPreferencePayload = {
  __typename?: 'ChangeEmailPreferencePayload';
  errors: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of ChangePassword */
export type ChangePasswordPayload = {
  __typename?: 'ChangePasswordPayload';
  user: User;
};

/** Autogenerated return type of ChangePreferences */
export type ChangePreferencesPayload = {
  __typename?: 'ChangePreferencesPayload';
  user: UserInterface;
};

export enum ClassName {
  EmailPreference = 'EmailPreference',
  GenericProgram = 'GenericProgram',
  LiveEvent = 'LiveEvent'
}

/** Autogenerated return type of ChangeProductEmailPreference */
export type ChangeProductEmailPreferencePayload = {
  __typename?: 'ChangeProductEmailPreferencePayload';
  errors: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of ChangeProfileData */
export type ChangeProfileDataPayload = {
  __typename?: 'ChangeProfileDataPayload';
  user: UserInterface;
};

/** Autogenerated return type of ChangeProfileInfo */
export type ChangeProfileInfoPayload = {
  __typename?: 'ChangeProfileInfoPayload';
  user: UserInterface;
};

/** Autogenerated return type of ChangeProfilePrivacy */
export type ChangeProfilePrivacyPayload = {
  __typename?: 'ChangeProfilePrivacyPayload';
  user: UserInterface;
};

export enum GenderKind {
  Female = 'Female',
  Male = 'Male',
  Other = 'Other'
}

/** Autogenerated return type of CompleteProfile */
export type CompleteProfilePayload = {
  __typename?: 'CompleteProfilePayload';
  errors: Maybe<Array<Error>>;
  user: Maybe<CurrentUser>;
};

/** Autogenerated return type of ConfirmEmail */
export type ConfirmEmailPayload = {
  __typename?: 'ConfirmEmailPayload';
  errors: Maybe<Array<Error>>;
  user: Maybe<CurrentUser>;
};

/** Autogenerated return type of CreateNewPassword */
export type CreateNewPasswordPayload = {
  __typename?: 'CreateNewPasswordPayload';
  success: Scalars['Boolean'];
};

/** Autogenerated return type of DeleteAccount */
export type DeleteAccountPayload = {
  __typename?: 'DeleteAccountPayload';
  errors: Maybe<Array<Error>>;
  user: Maybe<UserInterface>;
};

/** Autogenerated return type of DeleteAvatar */
export type DeleteAvatarPayload = {
  __typename?: 'DeleteAvatarPayload';
  user: Maybe<UserInterface>;
};

/** Autogenerated return type of DeleteFavoritePlaylist */
export type DeleteFavoritePlaylistPayload = {
  __typename?: 'DeleteFavoritePlaylistPayload';
  playlist: Maybe<Playlist>;
};

/** Autogenerated return type of DeleteFavoriteVideo */
export type DeleteFavoriteVideoPayload = {
  __typename?: 'DeleteFavoriteVideoPayload';
  video: Maybe<Video>;
};

/** Autogenerated return type of DeletePlaylist */
export type DeletePlaylistPayload = {
  __typename?: 'DeletePlaylistPayload';
  status: Maybe<PlaylistStatus>;
};

export type PlaylistStatus = {
  __typename?: 'PlaylistStatus';
  destroyed: Maybe<Scalars['Boolean']>;
};

export enum ProxyEventKind {
  SurveyStarted = 'SURVEY_STARTED',
  TrialPeriodStarted = 'TRIAL_PERIOD_STARTED'
}

export type EventPropertyInput = {
  property: InputMaybe<Scalars['String']>;
  value: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of EventProxy */
export type EventProxyPayload = {
  __typename?: 'EventProxyPayload';
  errors: Maybe<Array<Error>>;
};

/** Autogenerated return type of Login */
export type LoginPayload = {
  __typename?: 'LoginPayload';
  user: Maybe<UserInterface>;
};

/** Autogenerated return type of Logout */
export type LogoutPayload = {
  __typename?: 'LogoutPayload';
  status: Maybe<Scalars['String']>;
};

/** Autogenerated return type of ParticipateInAnEvent */
export type ParticipateInAnEventPayload = {
  __typename?: 'ParticipateInAnEventPayload';
  amountCents: Maybe<Scalars['Int']>;
  amountCurrency: Maybe<Scalars['String']>;
  errors: Maybe<Array<Error>>;
  liveEvent: Maybe<LiveEvent>;
  message: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
  user: Maybe<CurrentUser>;
};

/** Autogenerated return type of PatchPlaylist */
export type PatchPlaylistPayload = {
  __typename?: 'PatchPlaylistPayload';
  playlist: Maybe<Playlist>;
};

/** Autogenerated return type of PatchStory */
export type PatchStoryPayload = {
  __typename?: 'PatchStoryPayload';
  story: Maybe<Story>;
};

export type BrowserInfoInput = {
  acceptHeader: InputMaybe<Scalars['String']>;
  colorDepth: InputMaybe<Scalars['Int']>;
  javaEnabled: InputMaybe<Scalars['Boolean']>;
  language: InputMaybe<Scalars['String']>;
  screenHeight: InputMaybe<Scalars['Int']>;
  screenWidth: InputMaybe<Scalars['Int']>;
  timeZoneOffset: InputMaybe<Scalars['Int']>;
  userAgent: InputMaybe<Scalars['String']>;
};

export enum ItemKind {
  Course = 'Course',
  GenericProgram = 'GenericProgram',
  LiveEvent = 'LiveEvent'
}

export type PaymentMethodInput = {
  brand: InputMaybe<Scalars['String']>;
  encryptedCardNumber: InputMaybe<Scalars['String']>;
  encryptedExpiryMonth: InputMaybe<Scalars['String']>;
  encryptedExpiryYear: InputMaybe<Scalars['String']>;
  encryptedSecurityCode: InputMaybe<Scalars['String']>;
  holderName: InputMaybe<Scalars['String']>;
  providerType: InputMaybe<Scalars['String']>;
};

export type RiskDataInput = {
  clientData: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of PayForItem */
export type PayForItemPayload = {
  __typename?: 'PayForItemPayload';
  errors: Maybe<Array<Error>>;
  orderId: Maybe<Scalars['String']>;
  resultAction: Maybe<AdyenAction>;
  resultCode: Maybe<Scalars['String']>;
  transaction: Maybe<Scalars['String']>;
};

export type AdyenAction = {
  __typename?: 'AdyenAction';
  actionType: Scalars['String'];
  httpMethod: Maybe<Scalars['String']>;
  paymentData: Scalars['String'];
  paymentMethodType: Scalars['String'];
  redirectData: Maybe<Scalars['String']>;
  token: Maybe<Scalars['String']>;
  url: Maybe<Scalars['String']>;
};

/** Autogenerated return type of PayForVoucher */
export type PayForVoucherPayload = {
  __typename?: 'PayForVoucherPayload';
  errors: Maybe<Array<Error>>;
  orderId: Maybe<Scalars['String']>;
  resultAction: Maybe<AdyenAction>;
  resultCode: Maybe<Scalars['String']>;
  transaction: Maybe<Scalars['String']>;
};

/** Autogenerated return type of StoreAdyenDropin */
export type StoreAdyenDropinPayload = {
  __typename?: 'StoreAdyenDropinPayload';
  errors: Maybe<Array<Error>>;
  orderId: Maybe<Scalars['String']>;
  recurringDate: Maybe<Scalars['String']>;
  recurringPaymentAmount: Maybe<Scalars['String']>;
  recurringPaymentCurrency: Maybe<Scalars['String']>;
  resultAction: Maybe<AdyenAction>;
  resultCode: Maybe<Scalars['String']>;
  transaction: Maybe<Scalars['String']>;
};

/** Autogenerated return type of StorePaymentDetails */
export type StorePaymentDetailsPayload = {
  __typename?: 'StorePaymentDetailsPayload';
  action: Maybe<Scalars['String']>;
  errors: Maybe<Array<Error>>;
  orderId: Maybe<Scalars['String']>;
  resultAction: Maybe<Scalars['String']>;
  resultCode: Maybe<Scalars['String']>;
  transaction: Maybe<Scalars['String']>;
};

/** Autogenerated return type of StoreTrustly */
export type StoreTrustlyPayload = {
  __typename?: 'StoreTrustlyPayload';
  errors: Maybe<Array<Error>>;
  orderId: Maybe<Scalars['String']>;
  recurringDate: Maybe<Scalars['String']>;
  recurringPaymentAmount: Maybe<Scalars['String']>;
  recurringPaymentCurrency: Maybe<Scalars['String']>;
  resultUrl: Maybe<Scalars['String']>;
  transaction: Maybe<Scalars['String']>;
};

/** Autogenerated return type of ReclaimTrial */
export type ReclaimTrialPayload = {
  __typename?: 'ReclaimTrialPayload';
  errors: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of RemoveVideoFromPlaylist */
export type RemoveVideoFromPlaylistPayload = {
  __typename?: 'RemoveVideoFromPlaylistPayload';
  playlist: Maybe<Playlist>;
};

/** Autogenerated return type of ResendConfirmationEmail */
export type ResendConfirmationEmailPayload = {
  __typename?: 'ResendConfirmationEmailPayload';
  success: Scalars['Boolean'];
};

/** Autogenerated return type of ResetEmailConfirmation */
export type ResetEmailConfirmationPayload = {
  __typename?: 'ResetEmailConfirmationPayload';
  success: Scalars['Boolean'];
};

/** Autogenerated return type of ResetPassword */
export type ResetPasswordPayload = {
  __typename?: 'ResetPasswordPayload';
  success: Scalars['Boolean'];
};

/** Autogenerated return type of ResetSummerCampaign */
export type ResetSummerCampaignPayload = {
  __typename?: 'ResetSummerCampaignPayload';
  action: Maybe<Scalars['String']>;
  errors: Maybe<Array<ProcessingError>>;
};

/** Autogenerated return type of RestoreMobileSubscription */
export type RestoreMobileSubscriptionPayload = {
  __typename?: 'RestoreMobileSubscriptionPayload';
  errors: Maybe<Array<Error>>;
  user: Maybe<CurrentUser>;
};

/** Autogenerated return type of SaveOnboardingChoices */
export type SaveOnboardingChoicesPayload = {
  __typename?: 'SaveOnboardingChoicesPayload';
  errors: Maybe<Array<Error>>;
  success: Scalars['Boolean'];
  user: Maybe<User>;
};

/** Autogenerated return type of SavePhasedProgramProgress */
export type SavePhasedProgramProgressPayload = {
  __typename?: 'SavePhasedProgramProgressPayload';
  errors: Array<Scalars['String']>;
};

/** Autogenerated return type of SaveProgramProgress */
export type SaveProgramProgressPayload = {
  __typename?: 'SaveProgramProgressPayload';
  errors: Array<Scalars['String']>;
};

/** Autogenerated return type of Registration */
export type RegistrationPayload = {
  __typename?: 'RegistrationPayload';
  errors: Maybe<Array<Error>>;
  user: Maybe<CurrentUser>;
};

/** Autogenerated return type of RegistrationV2 */
export type RegistrationV2Payload = {
  __typename?: 'RegistrationV2Payload';
  errors: Maybe<Array<Error>>;
  user: Maybe<CurrentUser>;
};

export enum MethodTypes {
  Code = 'code',
  Token = 'token'
}

export enum ProviderTypes {
  Apple = 'Apple',
  Facebook = 'Facebook',
  Google = 'Google'
}

/** Autogenerated return type of SignIn */
export type SignInPayload = {
  __typename?: 'SignInPayload';
  success: Maybe<Scalars['Boolean']>;
  user: Maybe<UserInterface>;
};

/** Autogenerated return type of SignUp */
export type SignUpPayload = {
  __typename?: 'SignUpPayload';
  success: Maybe<Scalars['Boolean']>;
  user: Maybe<UserInterface>;
};

/** Autogenerated return type of StoreTransactionId */
export type StoreTransactionIdPayload = {
  __typename?: 'StoreTransactionIdPayload';
  /** Apple service error message */
  errors: Maybe<Array<Error>>;
  /** Apple service error status code */
  statusCode: Maybe<Scalars['Int']>;
  /** Yogobe backend receipt validation message */
  validationMessage: Maybe<Scalars['String']>;
};

/** Autogenerated return type of StoreUserDecision */
export type StoreUserDecisionPayload = {
  __typename?: 'StoreUserDecisionPayload';
  user: User;
};

/** Autogenerated return type of SubmitInterestForm */
export type SubmitInterestFormPayload = {
  __typename?: 'SubmitInterestFormPayload';
  errors: Array<ProcessingError>;
};

/** Autogenerated return type of ValidateToken */
export type ValidateTokenPayload = {
  __typename?: 'ValidateTokenPayload';
  errors: Maybe<Array<ProcessingError>>;
  status: Scalars['String'];
};

/** Autogenerated return type of ValidateProgramCode */
export type ValidateProgramCodePayload = {
  __typename?: 'ValidateProgramCodePayload';
  code: Maybe<Scalars['String']>;
  codeSource: Maybe<CodeSourceKind>;
  codeStatus: Maybe<CodeStatusKind>;
  codeType: Maybe<CodeTypeKind>;
  error: Maybe<Scalars['String']>;
  price: Maybe<Price>;
  program: Maybe<GenericProgram>;
};

export enum CodeSourceKind {
  App = 'app',
  Voucher = 'voucher'
}

export enum CodeTypeKind {
  AccessCode = 'access_code',
  AccessToken = 'access_token',
  ChallengePass = 'challenge_pass',
  DiscountCode = 'discount_code'
}

/** Autogenerated return type of Favorite */
export type FavoritePayload = {
  __typename?: 'FavoritePayload';
  errors: Maybe<Array<Error>>;
};

/** Autogenerated return type of Watch */
export type WatchPayload = {
  __typename?: 'WatchPayload';
  errors: Maybe<Array<Error>>;
};

/** Autogenerated return type of WatchCompleted */
export type WatchCompletedPayload = {
  __typename?: 'WatchCompletedPayload';
  errors: Maybe<Array<Error>>;
};

export type CancelSubscriptionMutationVariables = Exact<{ [key: string]: never; }>;


export type CancelSubscriptionMutation = { __typename?: 'Mutation', cancelSubscription: { __typename?: 'CancelSubscriptionPayload', success: boolean } | null | undefined };

export type AuthenticateUserMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type AuthenticateUserMutation = { __typename?: 'Mutation', authenticateUser: { __typename?: 'AuthenticateUserPayload', user: { __typename?: 'User', id: string, firstName: string | null | undefined, lastName: string | null | undefined, email: string | null | undefined } | { __typename?: 'CurrentUser', id: string, firstName: string | null | undefined, lastName: string | null | undefined, email: string | null | undefined } | null | undefined } | null | undefined };

export type AvailableOneTimeCodeQueryVariables = Exact<{
  code: InputMaybe<Scalars['String']>;
}>;


export type AvailableOneTimeCodeQuery = { __typename?: 'Query', availableOneTimeCode: { __typename?: 'AvailableSubscriptionPlan', isCodeValid: boolean | null | undefined, code: string | null | undefined, codeType: Code | null | undefined, validationMessage: string | null | undefined, oneTimeCodes: Array<{ __typename?: 'UserSubscription', title: string | null | undefined, description: string | null | undefined, shortDescription: string | null | undefined, amount: number | null | undefined, discountedAmount: number | null | undefined, currency: string | null | undefined, months: number | null | undefined, days: number | null | undefined, subscriptionName: string, subscriptionPlan: string | null | undefined, promotionKind: string | null | undefined, promotionName: string | null | undefined, recurringPromotion: boolean | null | undefined }> | null | undefined } };

export type PricingSubscriptionFieldsFragment = { __typename?: 'UserSubscription', title: string | null | undefined, description: string | null | undefined, shortDescription: string | null | undefined, amount: number | null | undefined, discountedAmount: number | null | undefined, currency: string | null | undefined, months: number | null | undefined, days: number | null | undefined, subscriptionName: string, subscriptionPlan: string | null | undefined, promotionKind: string | null | undefined, promotionName: string | null | undefined, recurringPromotion: boolean | null | undefined };

export type PricingSubscriptionPlansQueryVariables = Exact<{
  code: InputMaybe<Scalars['String']>;
}>;


export type PricingSubscriptionPlansQuery = { __typename?: 'Query', availableSubscriptionPlans: { __typename?: 'AvailableSubscriptionPlan', code: string | null | undefined, isCodeValid: boolean | null | undefined, subscriptions: Array<{ __typename?: 'UserSubscription', title: string | null | undefined, description: string | null | undefined, shortDescription: string | null | undefined, amount: number | null | undefined, discountedAmount: number | null | undefined, currency: string | null | undefined, months: number | null | undefined, days: number | null | undefined, subscriptionName: string, subscriptionPlan: string | null | undefined, promotionKind: string | null | undefined, promotionName: string | null | undefined, recurringPromotion: boolean | null | undefined }> } };

export type FullAvailableSubscriptionPlansQueryVariables = Exact<{
  code: InputMaybe<Scalars['String']>;
}>;


export type FullAvailableSubscriptionPlansQuery = { __typename?: 'Query', availableSubscriptionPlans: { __typename?: 'AvailableSubscriptionPlan', code: string | null | undefined, codeType: Code | null | undefined, isCodeValid: boolean | null | undefined, validationMessage: string | null | undefined, subscriptions: Array<{ __typename?: 'UserSubscription', title: string | null | undefined, description: string | null | undefined, shortDescription: string | null | undefined, amount: number | null | undefined, discountedAmount: number | null | undefined, currency: string | null | undefined, months: number | null | undefined, days: number | null | undefined, subscriptionName: string, subscriptionPlan: string | null | undefined, promotionKind: string | null | undefined, promotionName: string | null | undefined, recurringPromotion: boolean | null | undefined }>, fullAccesses: Array<{ __typename?: 'UserSubscription', title: string | null | undefined, description: string | null | undefined, shortDescription: string | null | undefined, currency: string | null | undefined, promotionKind: string | null | undefined, promotionName: string | null | undefined, extraPromotion: boolean, subscriptionName: string, subscriptionPlan: string | null | undefined }> | null | undefined, oneTimeCodes: Array<{ __typename?: 'UserSubscription', title: string | null | undefined, description: string | null | undefined, shortDescription: string | null | undefined, promotionKind: string | null | undefined, promotionName: string | null | undefined }> | null | undefined } };

export type AvailableTrialExtensionsQueryVariables = Exact<{
  code: InputMaybe<Scalars['String']>;
}>;


export type AvailableTrialExtensionsQuery = { __typename?: 'Query', availableTrialExtensions: { __typename?: 'AvailableSubscriptionPlan', code: string | null | undefined, codeType: Code | null | undefined, isCodeValid: boolean | null | undefined, validationMessage: string | null | undefined, trials: Array<{ __typename?: 'UserSubscription', months: number | null | undefined, days: number | null | undefined, subscriptionPlan: string | null | undefined, promotionKind: string | null | undefined, promotionName: string | null | undefined }> | null | undefined, trialReferralCodes: Array<{ __typename?: 'UserSubscription', months: number | null | undefined, days: number | null | undefined, subscriptionPlan: string | null | undefined, promotionKind: string | null | undefined, promotionName: string | null | undefined }> | null | undefined, oneTimeCodes: Array<{ __typename?: 'UserSubscription', accessUntil: any | null | undefined, months: number | null | undefined, days: number | null | undefined, subscriptionPlan: string | null | undefined, promotionKind: string | null | undefined, promotionName: string | null | undefined }> | null | undefined } };

export type BundleEssentialFieldsFragment = { __typename?: 'Bundle', id: string, title: string, slug: string, heroImage: string | null | undefined, heroMobileImage: string | null | undefined, active: boolean, kind: BundleKind, accessStrategy: BundleAccessStrategyKind, isUserEligible: boolean, bundleCategory: BundleCategoryKind | null | undefined, hiddenInListing: boolean, metaDescription: string, metaImage: string | null | undefined, publishedAt: any | null | undefined, shortDescription: string, promotionalImage: string | null | undefined, tags: Array<string | null | undefined>, userAccess: { __typename?: 'UserAccess', active: boolean, accessUntil: any | null | undefined } | null | undefined, client: { __typename?: 'Client', id: string, logo: string | null | undefined, name: string, slug: string } | null | undefined };

export type BlogPostFieldsFragment = { __typename?: 'BlogPost', id: string, slug: string, tags: Array<string | null | undefined>, title: string, body: string, authors: Array<string>, categories: Array<string>, featuredImage: string, language: string, market: Array<string>, publishedAt: any };

export type BasicBundleQueryVariables = Exact<{
  slug: Scalars['String'];
  client: Scalars['String'];
}>;


export type BasicBundleQuery = { __typename?: 'Query', basicBundle: { __typename?: 'Bundle', id: string, title: string, slug: string, heroImage: string | null | undefined, heroMobileImage: string | null | undefined, active: boolean, kind: BundleKind, accessStrategy: BundleAccessStrategyKind, isUserEligible: boolean, bundleCategory: BundleCategoryKind | null | undefined, hiddenInListing: boolean, metaDescription: string, metaImage: string | null | undefined, publishedAt: any | null | undefined, shortDescription: string, promotionalImage: string | null | undefined, tags: Array<string | null | undefined>, userAccess: { __typename?: 'UserAccess', active: boolean, accessUntil: any | null | undefined } | null | undefined, client: { __typename?: 'Client', id: string, logo: string | null | undefined, name: string, slug: string } | null | undefined } | null | undefined };

export type BundleQueryVariables = Exact<{
  slug: Scalars['String'];
  client: Scalars['String'];
}>;


export type BundleQuery = { __typename?: 'Query', bundle: { __typename?: 'Bundle', sections: Array<BundleSectionKind>, id: string, title: string, slug: string, heroImage: string | null | undefined, heroMobileImage: string | null | undefined, active: boolean, kind: BundleKind, accessStrategy: BundleAccessStrategyKind, isUserEligible: boolean, bundleCategory: BundleCategoryKind | null | undefined, hiddenInListing: boolean, metaDescription: string, metaImage: string | null | undefined, publishedAt: any | null | undefined, shortDescription: string, promotionalImage: string | null | undefined, tags: Array<string | null | undefined>, trailer: { __typename?: 'Video', identifier: string, minutes: number, thumbnailUrl: string | null | undefined, hls: string, player: { __typename?: 'VideoInfo', assets: Array<{ __typename?: 'VideoFileAsset', resolution: number | null | undefined, src: string | null | undefined } | null | undefined> | null | undefined } | null | undefined } | null | undefined, infoPanel: { __typename?: 'BundleInfoPanel', title: string | null | undefined, description: string | null | undefined, image: string | null | undefined } | null | undefined, infoPanel2: { __typename?: 'BundleInfoPanel2', title: string | null | undefined, image: string | null | undefined, longText: string | null | undefined, previewText: string | null | undefined } | null | undefined, bundleItems: { __typename: 'BundleItem', videos: Array<{ __typename?: 'BlogPost' } | { __typename?: 'Document' } | { __typename?: 'GenericProgram' } | { __typename?: 'LiveEvent' } | { __typename?: 'Playlist' } | { __typename?: 'Video', id: string, identifier: string, kind: string, cursorAt: number | null | undefined, content: { __typename?: 'VideoContent', title: string | null | undefined, shortDescription: string | null | undefined, longDescription: string | null | undefined } | null | undefined, meta: { __typename?: 'VideoMeta', minutes: number | null | undefined, publishedAt: number | null | undefined } | null | undefined, primaryStyle: { __typename?: 'Term', name: string | null | undefined, slug: string | null | undefined } | null | undefined, taxonomies: { __typename?: 'Taxonomy', flavor: { __typename?: 'Term', id: string, name: string | null | undefined } | null | undefined, needs: Array<{ __typename?: 'Term', id: string, name: string | null | undefined } | null | undefined> | null | undefined, instructors: Array<{ __typename?: 'Instructor', id: string, name: string | null | undefined, slug: string | null | undefined } | null | undefined> | null | undefined, genre: { __typename?: 'Term', id: string, name: string | null | undefined, slug: string | null | undefined } | null | undefined }, assets: { __typename?: 'VideoAssets', thumbnailUrl: string | null | undefined } | null | undefined }>, challenges: Array<{ __typename?: 'BlogPost' } | { __typename?: 'Document' } | { __typename?: 'GenericProgram', id: string, title: string | null | undefined, slug: string, promotionalImageUrl: string | null | undefined, category: ProgramCategory, priceType: PriceTypeKind | null | undefined, kind: ProgramKind, language: LanguageKind | null | undefined, titleImageUrl: string | null | undefined, shortDescription: string | null | undefined, description: string | null | undefined, themes: Array<ThemeKind> | null | undefined, accessStatus: ProgramAccessStatus, price: { __typename?: 'Price', originalPrice: number | null | undefined, discountedPrice: number | null | undefined, discountApplied: boolean, currency: string | null | undefined } | null | undefined, accessPeriod: { __typename?: 'AccessPeriod', unit: AccessPeriodUnitKind | null | undefined, value: number | null | undefined }, duration: { __typename?: 'Duration', unit: DurationUnitKind | null | undefined, value: number | null | undefined } | null | undefined, instructors: Array<{ __typename?: 'Instructor', id: string, name: string | null | undefined, slug: string | null | undefined, assets: { __typename?: 'InstructorAssets', squareImage: string | null | undefined } | null | undefined } | null | undefined> | null | undefined } | { __typename?: 'LiveEvent' } | { __typename?: 'Playlist' } | { __typename?: 'Video' }>, programs: Array<{ __typename?: 'BlogPost' } | { __typename?: 'Document' } | { __typename?: 'GenericProgram', id: string, title: string | null | undefined, slug: string, promotionalImageUrl: string | null | undefined, category: ProgramCategory, priceType: PriceTypeKind | null | undefined, kind: ProgramKind, language: LanguageKind | null | undefined, titleImageUrl: string | null | undefined, shortDescription: string | null | undefined, description: string | null | undefined, themes: Array<ThemeKind> | null | undefined, accessStatus: ProgramAccessStatus, price: { __typename?: 'Price', originalPrice: number | null | undefined, discountedPrice: number | null | undefined, discountApplied: boolean, currency: string | null | undefined } | null | undefined, accessPeriod: { __typename?: 'AccessPeriod', unit: AccessPeriodUnitKind | null | undefined, value: number | null | undefined }, duration: { __typename?: 'Duration', unit: DurationUnitKind | null | undefined, value: number | null | undefined } | null | undefined, instructors: Array<{ __typename?: 'Instructor', id: string, name: string | null | undefined, slug: string | null | undefined, assets: { __typename?: 'InstructorAssets', squareImage: string | null | undefined } | null | undefined } | null | undefined> | null | undefined } | { __typename?: 'LiveEvent' } | { __typename?: 'Playlist' } | { __typename?: 'Video' }>, playlists: Array<{ __typename?: 'BlogPost' } | { __typename?: 'Document' } | { __typename?: 'GenericProgram' } | { __typename?: 'LiveEvent' } | { __typename?: 'Playlist', id: string, identifier: string | null | undefined, visibility: string | null | undefined, title: string, description: string | null | undefined, owner: { __typename?: 'User', id: string, firstName: string | null | undefined } | { __typename?: 'CurrentUser', id: string, firstName: string | null | undefined } | null | undefined, meta: { __typename?: 'Meta', videoCount: number | null | undefined, minutes: number | null | undefined } | null | undefined, assets: { __typename?: 'PlaylistAssets', thumbnailUrl: string | null | undefined } | null | undefined } | { __typename?: 'Video' }>, liveEvents: Array<{ __typename?: 'BlogPost' } | { __typename?: 'Document' } | { __typename?: 'GenericProgram' } | { __typename?: 'LiveEvent', id: string, title: string, slug: string, thumbnail: string, duration: number, eventDates: Array<any>, kind: LiveEventKind, language: LanguageKind, level: LiveEventLevel, theme: string, availableSpots: number, maximumParticipants: number, bookingAvailable: boolean, descriptionLong: string, registrationEndDate: any, registrationStartDate: any, isExpired: boolean | null | undefined, isComingSoon: boolean | null | undefined, price: { __typename?: 'Price', originalPrice: number | null | undefined, discountApplied: boolean, discountedPrice: number | null | undefined, currency: string | null | undefined } | null | undefined, primaryInstructor: { __typename?: 'Instructor', id: string, name: string | null | undefined, slug: string | null | undefined, assets: { __typename?: 'InstructorAssets', squareImage: string | null | undefined } | null | undefined } | null | undefined, instructors: Array<{ __typename?: 'Instructor', id: string, name: string | null | undefined, slug: string | null | undefined, assets: { __typename?: 'InstructorAssets', squareImage: string | null | undefined } | null | undefined } | null | undefined> | null | undefined } | { __typename?: 'Playlist' } | { __typename?: 'Video' }>, blogPosts: Array<{ __typename?: 'BlogPost', id: string, slug: string, tags: Array<string | null | undefined>, title: string, body: string, authors: Array<string>, categories: Array<string>, featuredImage: string, language: string, market: Array<string>, publishedAt: any } | { __typename?: 'Document' } | { __typename?: 'GenericProgram' } | { __typename?: 'LiveEvent' } | { __typename?: 'Playlist' } | { __typename?: 'Video' }>, documents: Array<{ __typename?: 'BlogPost' } | { __typename?: 'Document', contentType: string | null | undefined, id: string, name: string, url: string | null | undefined } | { __typename?: 'GenericProgram' } | { __typename?: 'LiveEvent' } | { __typename?: 'Playlist' } | { __typename?: 'Video' }> }, userAccess: { __typename?: 'UserAccess', active: boolean, accessUntil: any | null | undefined } | null | undefined, client: { __typename?: 'Client', id: string, logo: string | null | undefined, name: string, slug: string } | null | undefined } | null | undefined };

export type ActivateBundleMutationVariables = Exact<{
  slug: Scalars['String'];
  client: Scalars['String'];
  code: Scalars['String'];
}>;


export type ActivateBundleMutation = { __typename?: 'Mutation', activateBundle: { __typename?: 'ActivateBundlePayload', success: boolean, errors: string | null | undefined } | null | undefined };

export type ValidateBundleCodeQueryVariables = Exact<{
  slug: Scalars['String'];
  code: Scalars['String'];
  client: Scalars['String'];
}>;


export type ValidateBundleCodeQuery = { __typename?: 'Query', validateBundleCode: { __typename?: 'ValidateCode', code: string | null | undefined, message: string | null | undefined, status: CodeStatusKind | null | undefined } | null | undefined };

export type BundlesQueryVariables = Exact<{
  page: InputMaybe<Scalars['Int']>;
  perPage: InputMaybe<Scalars['Int']>;
}>;


export type BundlesQuery = { __typename?: 'Query', bundles: { __typename?: 'PagedBundles', page: number, perPage: number, totalCount: number, data: Array<{ __typename?: 'Bundle', slug: string, client: { __typename?: 'Client', slug: string } | null | undefined }> } | null | undefined };

export type MyBundlesQueryVariables = Exact<{
  page: InputMaybe<Scalars['Int']>;
  perPage: InputMaybe<Scalars['Int']>;
}>;


export type MyBundlesQuery = { __typename?: 'Query', myBundles: { __typename?: 'PagedBundles', page: number, perPage: number, totalCount: number, data: Array<{ __typename?: 'Bundle', id: string, title: string, slug: string, heroImage: string | null | undefined, heroMobileImage: string | null | undefined, active: boolean, kind: BundleKind, accessStrategy: BundleAccessStrategyKind, isUserEligible: boolean, bundleCategory: BundleCategoryKind | null | undefined, hiddenInListing: boolean, metaDescription: string, metaImage: string | null | undefined, publishedAt: any | null | undefined, shortDescription: string, promotionalImage: string | null | undefined, tags: Array<string | null | undefined>, userAccess: { __typename?: 'UserAccess', active: boolean, accessUntil: any | null | undefined } | null | undefined, client: { __typename?: 'Client', id: string, logo: string | null | undefined, name: string, slug: string } | null | undefined }> } | null | undefined };

export type ChangeProfileDataMutationVariables = Exact<{
  displayName: InputMaybe<Scalars['String']>;
  shortBio: InputMaybe<Scalars['String']>;
  instagramUrl: InputMaybe<Scalars['String']>;
  facebookUrl: InputMaybe<Scalars['String']>;
  linkedinUrl: InputMaybe<Scalars['String']>;
  timezone: InputMaybe<Scalars['String']>;
  avatar: InputMaybe<Scalars['Upload']>;
}>;


export type ChangeProfileDataMutation = { __typename?: 'Mutation', changeProfileData: { __typename?: 'ChangeProfileDataPayload', user: { __typename?: 'User', id: string } | { __typename?: 'CurrentUser', id: string } } | null | undefined };

export type CompleteProfileMutationVariables = Exact<{
  phone: InputMaybe<Scalars['String']>;
  address: InputMaybe<Scalars['String']>;
  postalCode: InputMaybe<Scalars['String']>;
  city: InputMaybe<Scalars['String']>;
  gender: InputMaybe<GenderKind>;
  country: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  trialExtensionCode: InputMaybe<Scalars['String']>;
  oneTimeCode: InputMaybe<Scalars['String']>;
}>;


export type CompleteProfileMutation = { __typename?: 'Mutation', completeProfile: { __typename?: 'CompleteProfilePayload', errors: Array<{ __typename?: 'Error', message: string | null | undefined }> | null | undefined, user: { __typename?: 'CurrentUser', id: string } | null | undefined } | null | undefined };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { __typename?: 'Query', currentUser: { __typename?: 'CurrentUser', id: string, firstName: string | null | undefined, lastName: string | null | undefined, email: string | null | undefined, accessToken: string | null | undefined, accessUntil: string | null | undefined, completedAt: any | null | undefined, eligibleForTrialReclaim: EligibleForTrialReclaimKind | null | undefined, isPremium: boolean | null | undefined, isNoneTrialPremium: boolean | null | undefined, hasWellness: boolean | null | undefined, group: string, isEmailActivated: boolean | null | undefined, accountActivatedAt: any | null | undefined, isPublic: boolean | null | undefined, kind: string | null | undefined, locale: string | null | undefined, slug: string | null | undefined, previousEmail: string | null | undefined, trialPeriod: number | null | undefined, country: string | null | undefined, zipcode: string | null | undefined, city: string | null | undefined, phone: string | null | undefined, address: string | null | undefined, referralCode: string | null | undefined, subscriptionPlanSelected: boolean, onboardingCompleted: boolean, onboardingSkipped: boolean, onboardingInterestsSkipped: boolean, onboardingTopicsSkipped: boolean, profile: { __typename?: 'Profile', displayName: string | null | undefined, shortBio: string | null | undefined, instagramURL: string | null | undefined, linkedinURL: string | null | undefined, facebookURL: string | null | undefined, timezone: string | null | undefined } | null | undefined, assets: { __typename?: 'Assets', avatar: string | null | undefined } | null | undefined, preferences: { __typename?: 'Preferences', contentLanguages: Array<string | null | undefined> | null | undefined, preferTerms: Array<string | null | undefined> | null | undefined, excludeTerms: Array<string | null | undefined> | null | undefined, videoLevels: Array<string | null | undefined> | null | undefined } | null | undefined, subscription: { __typename?: 'Subscription', provider: string | null | undefined, status: SubscriptionStatus, inTrialPeriod: boolean, currentSubscriptionPlan: { __typename?: 'SubscriptionPlan', platform: DevicePlatformKind | null | undefined, planType: string, productId: string | null | undefined } } } | null | undefined };

export type CurrentUser2QueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUser2Query = { __typename?: 'Query', currentUser: { __typename?: 'CurrentUser', id: string, accessUntil: string | null | undefined, paymentTypeRenews: boolean | null | undefined, paymentFailedAt: string | null | undefined, gender: string | null | undefined, dateOfBirth: number | null | undefined, profession: string | null | undefined, nextBillingCycle: { __typename?: 'NextBillingCycle', paymentStatus: PaymentStatusKind | null | undefined, amount: string | null | undefined, billingDate: any | null | undefined, planName: string | null | undefined } | null | undefined, topics: Array<{ __typename?: 'Topic', name: string, slug: string }> | null | undefined, interests: Array<{ __typename?: 'Interest', name: string, slug: string }> | null | undefined, favorites: { __typename?: 'Favorites', videos: Array<string | null | undefined>, playlists: Array<string | null | undefined> } | null | undefined, privacySettings: { __typename?: 'PrivacySettings', isPrivateFavorites: boolean | null | undefined, isPrivateHistory: boolean | null | undefined, isPrivatePlaylists: boolean | null | undefined, isPrivateProfile: boolean | null | undefined, isPrivateStats: boolean | null | undefined } | null | undefined, statistics: { __typename?: 'Statistics', sessionsLastWeek: number, sessionsCompleted: number, totalTime: number, averageDuration: number | null | undefined } | null | undefined, receipts: Array<{ __typename?: 'Payment', date: string, number: string, paymentType: string, paymentProvider: string, amount: string, currency: string, transact: string | null | undefined, downloadUrl: string | null | undefined } | null | undefined>, extraPayments: Array<{ __typename?: 'ExtraPayment', date: string | null | undefined, number: string | null | undefined, paymentType: string | null | undefined, amount: string | null | undefined, currency: string | null | undefined, transact: string | null | undefined, downloadUrl: string | null | undefined } | null | undefined> | null | undefined, liveEventsAccess: Array<{ __typename?: 'LiveEventAccess', zoomLink: string, zoomPassword: string, liveEvent: { __typename?: 'LiveEvent', id: string, duration: number, eventDates: Array<any>, kind: LiveEventKind, language: LanguageKind, level: LiveEventLevel, theme: string, slug: string, title: string, thumbnail: string, accessories: Array<string>, registrationEndDate: any, registrationStartDate: any, descriptionLong: string, availableSpots: number, bookingAvailable: boolean, price: { __typename?: 'Price', originalPrice: number | null | undefined, discountApplied: boolean, discountedPrice: number | null | undefined, currency: string | null | undefined } | null | undefined, primaryInstructor: { __typename?: 'Instructor', id: string, name: string | null | undefined, slug: string | null | undefined, assets: { __typename?: 'InstructorAssets', squareImage: string | null | undefined } | null | undefined } | null | undefined, otherInstructors: Array<{ __typename?: 'Instructor', id: string, name: string | null | undefined, slug: string | null | undefined, assets: { __typename?: 'InstructorAssets', squareImage: string | null | undefined } | null | undefined }>, instructors: Array<{ __typename?: 'Instructor', id: string, name: string | null | undefined, slug: string | null | undefined, assets: { __typename?: 'InstructorAssets', squareImage: string | null | undefined } | null | undefined } | null | undefined> | null | undefined } | null | undefined } | null | undefined> | null | undefined, programAccess: Array<{ __typename?: 'ProgramAccess', accessStatus: ProgramAccessStatus, accessUntil: any | null | undefined, program: { __typename?: 'Program', id: string, name: string, slug: string | null | undefined, lede: string | null | undefined, shortDescription: string | null | undefined, themes: Array<ThemeKind> | null | undefined, legacy: boolean, language: string | null | undefined, titleImageUrl: string | null | undefined, tags: Array<string>, title: string, duration: { __typename?: 'Duration', value: number | null | undefined, unit: DurationUnitKind | null | undefined }, instructors: Array<{ __typename?: 'Instructor', id: string, name: string | null | undefined, slug: string | null | undefined, assets: { __typename?: 'InstructorAssets', squareImage: string | null | undefined } | null | undefined } | null | undefined> | null | undefined } | null | undefined } | null | undefined>, courseAccesses: Array<{ __typename?: 'CourseAccess', accessUntil: number | null | undefined, accessStatus: ProgramAccessStatus, course: { __typename?: 'Course', id: string, name: string | null | undefined, titleImageUrl: string | null | undefined, slug: string | null | undefined, path: string | null | undefined, themes: Array<ThemeKind> | null | undefined, legacy: boolean, content: { __typename?: 'Content', lede: string | null | undefined } } | null | undefined } | null | undefined>, challengeParticipations: Array<{ __typename?: 'ChallengeParticipant', accessUntil: any, challenge: { __typename?: 'Challenge', name: string } } | null | undefined> } | null | undefined };

export type DashboardRecentVideosQueryVariables = Exact<{ [key: string]: never; }>;


export type DashboardRecentVideosQuery = { __typename?: 'Query', recentVideos: Array<{ __typename?: 'Video', id: string, identifier: string, content: { __typename?: 'VideoContent', title: string | null | undefined, shortDescription: string | null | undefined } | null | undefined, meta: { __typename?: 'VideoMeta', minutes: number | null | undefined, publishedAt: number | null | undefined } | null | undefined, taxonomies: { __typename?: 'Taxonomy', flavor: { __typename?: 'Term', name: string | null | undefined } | null | undefined, instructors: Array<{ __typename?: 'Instructor', name: string | null | undefined, slug: string | null | undefined } | null | undefined> | null | undefined, genre: { __typename?: 'Term', name: string | null | undefined, slug: string | null | undefined } | null | undefined }, assets: { __typename?: 'VideoAssets', thumbnailUrl: string | null | undefined } | null | undefined } | null | undefined> | null | undefined };

export type DashboardTaxonomiesQueryVariables = Exact<{
  filter: InputMaybe<Scalars['String']>;
}>;


export type DashboardTaxonomiesQuery = { __typename?: 'Query', playlists: Array<{ __typename?: 'TaxonomyItem', terms: Array<{ __typename?: 'Term', id: string, name: string | null | undefined, titleImageUrl: string | null | undefined, slug: string | null | undefined }> | null | undefined } | null | undefined> | null | undefined };

export type EmailPreferencesQueryVariables = Exact<{
  email: InputMaybe<Scalars['String']>;
  token: InputMaybe<Scalars['String']>;
}>;


export type EmailPreferencesQuery = { __typename?: 'Query', emailPreferences: Array<{ __typename?: 'EmailPreference', id: string, isMuted: boolean, key: string, name: string, description: string }> | null | undefined };

export type ChangeEmailPreferenceMutationVariables = Exact<{
  mute: Scalars['Boolean'];
  key: Scalars['String'];
  email: InputMaybe<Scalars['String']>;
  token: InputMaybe<Scalars['String']>;
}>;


export type ChangeEmailPreferenceMutation = { __typename?: 'Mutation', changeEmailPreference: { __typename?: 'ChangeEmailPreferencePayload', errors: string | null | undefined, success: boolean } | null | undefined };

export type EventProxyMutationVariables = Exact<{
  event: ProxyEventKind;
  properties: InputMaybe<Array<EventPropertyInput> | EventPropertyInput>;
}>;


export type EventProxyMutation = { __typename?: 'Mutation', eventProxy: { __typename?: 'EventProxyPayload', errors: Array<{ __typename?: 'Error', message: string | null | undefined }> | null | undefined } | null | undefined };

export type ProgramInstructorsFragment = { __typename?: 'Instructor', id: string, name: string | null | undefined, slug: string | null | undefined, assets: { __typename?: 'InstructorAssets', squareImage: string | null | undefined } | null | undefined };

export type EssentialGenericFieldsFragment = { __typename?: 'GenericProgram', id: string, title: string | null | undefined, slug: string, promotionalImageUrl: string | null | undefined, category: ProgramCategory, priceType: PriceTypeKind | null | undefined, kind: ProgramKind, language: LanguageKind | null | undefined, titleImageUrl: string | null | undefined, shortDescription: string | null | undefined, description: string | null | undefined, themes: Array<ThemeKind> | null | undefined, accessStatus: ProgramAccessStatus, price: { __typename?: 'Price', originalPrice: number | null | undefined, discountedPrice: number | null | undefined, discountApplied: boolean, currency: string | null | undefined } | null | undefined, accessPeriod: { __typename?: 'AccessPeriod', unit: AccessPeriodUnitKind | null | undefined, value: number | null | undefined }, duration: { __typename?: 'Duration', unit: DurationUnitKind | null | undefined, value: number | null | undefined } | null | undefined, instructors: Array<{ __typename?: 'Instructor', id: string, name: string | null | undefined, slug: string | null | undefined, assets: { __typename?: 'InstructorAssets', squareImage: string | null | undefined } | null | undefined } | null | undefined> | null | undefined };

export type ProgramIntroFieldsFragment = { __typename?: 'SpecialSection', description: string | null | undefined, label: string, assetUrl: string | null | undefined, slug: string };

export type ProgramOutroFieldsFragment = { __typename?: 'SpecialSection', description: string | null | undefined, label: string, slug: string, videos: Array<{ __typename?: 'ProgramVideo', id: string, slug: string, title: string | null | undefined, subheader: string | null | undefined, customTitle: string | null | undefined, locked: boolean, watched: boolean | null | undefined, finished: boolean | null | undefined, position: number, positionLabel: string, videoKind: VideoKind | null | undefined, progressIsCurrent: boolean, repeatRecomendation: number | null | undefined, customDescription: string | null | undefined, preMoodTracker: { __typename?: 'MoodTracker', id: string, finished: boolean | null | undefined, kind: MoodTrackerKind } | null | undefined, postMoodTracker: { __typename?: 'MoodTracker', id: string, finished: boolean | null | undefined, kind: MoodTrackerKind } | null | undefined, video: { __typename?: 'Video', id: string, title: string, kind: string, identifier: string, hasAccess: boolean, cursorAt: number | null | undefined, hls: string, content: { __typename?: 'VideoContent', title: string | null | undefined, shortDescription: string | null | undefined, longDescription: string | null | undefined } | null | undefined, player: { __typename?: 'VideoInfo', assets: Array<{ __typename?: 'VideoFileAsset', src: string | null | undefined, size: number | null | undefined, resolution: number | null | undefined } | null | undefined> | null | undefined } | null | undefined, meta: { __typename?: 'VideoMeta', publishedAt: number | null | undefined, minutes: number | null | undefined } | null | undefined, taxonomies: { __typename?: 'Taxonomy', flavor: { __typename?: 'Term', name: string | null | undefined } | null | undefined, instructors: Array<{ __typename?: 'Instructor', name: string | null | undefined, slug: string | null | undefined } | null | undefined> | null | undefined, genre: { __typename?: 'Term', name: string | null | undefined, slug: string | null | undefined } | null | undefined }, assets: { __typename?: 'VideoAssets', thumbnailUrl: string | null | undefined } | null | undefined } } | null | undefined> | null | undefined };

export type GetBasicGenericProgramQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type GetBasicGenericProgramQuery = { __typename?: 'Query', genericProgram: { __typename?: 'GenericProgram', id: string, title: string | null | undefined, slug: string, promotionalImageUrl: string | null | undefined, category: ProgramCategory, priceType: PriceTypeKind | null | undefined, kind: ProgramKind, language: LanguageKind | null | undefined, titleImageUrl: string | null | undefined, shortDescription: string | null | undefined, description: string | null | undefined, themes: Array<ThemeKind> | null | undefined, accessStatus: ProgramAccessStatus, price: { __typename?: 'Price', originalPrice: number | null | undefined, discountedPrice: number | null | undefined, discountApplied: boolean, currency: string | null | undefined } | null | undefined, accessPeriod: { __typename?: 'AccessPeriod', unit: AccessPeriodUnitKind | null | undefined, value: number | null | undefined }, duration: { __typename?: 'Duration', unit: DurationUnitKind | null | undefined, value: number | null | undefined } | null | undefined, instructors: Array<{ __typename?: 'Instructor', id: string, name: string | null | undefined, slug: string | null | undefined, assets: { __typename?: 'InstructorAssets', squareImage: string | null | undefined } | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type FullGenericProgramFieldsFragment = { __typename?: 'GenericProgram', id: string, progress: number | null | undefined, summaryAsset: string | null | undefined, title: string | null | undefined, slug: string, promotionalImageUrl: string | null | undefined, category: ProgramCategory, priceType: PriceTypeKind | null | undefined, kind: ProgramKind, language: LanguageKind | null | undefined, titleImageUrl: string | null | undefined, shortDescription: string | null | undefined, description: string | null | undefined, themes: Array<ThemeKind> | null | undefined, accessStatus: ProgramAccessStatus, meta: { __typename?: 'ProgramMeta', title: string | null | undefined, description: string | null | undefined, imageUrl: string | null | undefined } | null | undefined, discount: { __typename?: 'Discount', discountType: DiscountTypeKind, discountValue: number | null | undefined, discountedPrice: number | null | undefined, endDate: any | null | undefined, identifier: PriceTypeKind | null | undefined, startDate: any | null | undefined } | null | undefined, postSurvey: { __typename?: 'ProgramSurvey', id: string, label: string, kind: SurveyKind, link: string, finished: boolean | null | undefined, locked: boolean } | null | undefined, preSurvey: { __typename?: 'ProgramSurvey', id: string, label: string, kind: SurveyKind, link: string, finished: boolean | null | undefined, locked: boolean } | null | undefined, trailer: { __typename?: 'Video', minutes: number, thumbnailUrl: string | null | undefined, hls: string, content: { __typename?: 'VideoContent', title: string | null | undefined } | null | undefined, player: { __typename?: 'VideoInfo', assets: Array<{ __typename?: 'VideoFileAsset', resolution: number | null | undefined, src: string | null | undefined } | null | undefined> | null | undefined } | null | undefined } | null | undefined, price: { __typename?: 'Price', originalPrice: number | null | undefined, discountedPrice: number | null | undefined, discountApplied: boolean, currency: string | null | undefined } | null | undefined, accessPeriod: { __typename?: 'AccessPeriod', unit: AccessPeriodUnitKind | null | undefined, value: number | null | undefined }, duration: { __typename?: 'Duration', unit: DurationUnitKind | null | undefined, value: number | null | undefined } | null | undefined, instructors: Array<{ __typename?: 'Instructor', id: string, name: string | null | undefined, slug: string | null | undefined, assets: { __typename?: 'InstructorAssets', squareImage: string | null | undefined } | null | undefined } | null | undefined> | null | undefined };

export type GetFullGenericProgramQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type GetFullGenericProgramQuery = { __typename?: 'Query', genericProgram: { __typename?: 'GenericProgram', id: string, progress: number | null | undefined, summaryAsset: string | null | undefined, title: string | null | undefined, slug: string, promotionalImageUrl: string | null | undefined, category: ProgramCategory, priceType: PriceTypeKind | null | undefined, kind: ProgramKind, language: LanguageKind | null | undefined, titleImageUrl: string | null | undefined, shortDescription: string | null | undefined, description: string | null | undefined, themes: Array<ThemeKind> | null | undefined, accessStatus: ProgramAccessStatus, meta: { __typename?: 'ProgramMeta', title: string | null | undefined, description: string | null | undefined, imageUrl: string | null | undefined } | null | undefined, discount: { __typename?: 'Discount', discountType: DiscountTypeKind, discountValue: number | null | undefined, discountedPrice: number | null | undefined, endDate: any | null | undefined, identifier: PriceTypeKind | null | undefined, startDate: any | null | undefined } | null | undefined, postSurvey: { __typename?: 'ProgramSurvey', id: string, label: string, kind: SurveyKind, link: string, finished: boolean | null | undefined, locked: boolean } | null | undefined, preSurvey: { __typename?: 'ProgramSurvey', id: string, label: string, kind: SurveyKind, link: string, finished: boolean | null | undefined, locked: boolean } | null | undefined, trailer: { __typename?: 'Video', minutes: number, thumbnailUrl: string | null | undefined, hls: string, content: { __typename?: 'VideoContent', title: string | null | undefined } | null | undefined, player: { __typename?: 'VideoInfo', assets: Array<{ __typename?: 'VideoFileAsset', resolution: number | null | undefined, src: string | null | undefined } | null | undefined> | null | undefined } | null | undefined } | null | undefined, price: { __typename?: 'Price', originalPrice: number | null | undefined, discountedPrice: number | null | undefined, discountApplied: boolean, currency: string | null | undefined } | null | undefined, accessPeriod: { __typename?: 'AccessPeriod', unit: AccessPeriodUnitKind | null | undefined, value: number | null | undefined }, duration: { __typename?: 'Duration', unit: DurationUnitKind | null | undefined, value: number | null | undefined } | null | undefined, instructors: Array<{ __typename?: 'Instructor', id: string, name: string | null | undefined, slug: string | null | undefined, assets: { __typename?: 'InstructorAssets', squareImage: string | null | undefined } | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type GenericProgramsQueryVariables = Exact<{
  perPage?: InputMaybe<Scalars['Int']>;
  page: InputMaybe<Scalars['Int']>;
  search: InputMaybe<Scalars['String']>;
  languages: InputMaybe<Array<LanguageKind> | LanguageKind>;
  instructor: InputMaybe<Scalars['String']>;
  sortBy: InputMaybe<GenericProgramSortAttribute>;
  theme: InputMaybe<Scalars['String']>;
  category: InputMaybe<ProgramCategory>;
  tags: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GenericProgramsQuery = { __typename?: 'Query', genericPrograms: { __typename?: 'PagedGenericPrograms', page: number, totalCount: number, data: Array<{ __typename?: 'GenericProgram', id: string, title: string | null | undefined, slug: string, promotionalImageUrl: string | null | undefined, category: ProgramCategory, priceType: PriceTypeKind | null | undefined, kind: ProgramKind, language: LanguageKind | null | undefined, titleImageUrl: string | null | undefined, shortDescription: string | null | undefined, description: string | null | undefined, themes: Array<ThemeKind> | null | undefined, accessStatus: ProgramAccessStatus, discount: { __typename?: 'Discount', discountType: DiscountTypeKind, discountValue: number | null | undefined, discountedPrice: number | null | undefined, endDate: any | null | undefined, identifier: PriceTypeKind | null | undefined, startDate: any | null | undefined } | null | undefined, price: { __typename?: 'Price', originalPrice: number | null | undefined, discountedPrice: number | null | undefined, discountApplied: boolean, currency: string | null | undefined } | null | undefined, accessPeriod: { __typename?: 'AccessPeriod', unit: AccessPeriodUnitKind | null | undefined, value: number | null | undefined }, duration: { __typename?: 'Duration', unit: DurationUnitKind | null | undefined, value: number | null | undefined } | null | undefined, instructors: Array<{ __typename?: 'Instructor', id: string, name: string | null | undefined, slug: string | null | undefined, assets: { __typename?: 'InstructorAssets', squareImage: string | null | undefined } | null | undefined } | null | undefined> | null | undefined }> } | null | undefined };

export type PlaylistEssentialFieldsFragment = { __typename?: 'Playlist', id: string, identifier: string | null | undefined, visibility: string | null | undefined, title: string, description: string | null | undefined, owner: { __typename?: 'User', id: string, firstName: string | null | undefined } | { __typename?: 'CurrentUser', id: string, firstName: string | null | undefined } | null | undefined, meta: { __typename?: 'Meta', videoCount: number | null | undefined, minutes: number | null | undefined } | null | undefined, assets: { __typename?: 'PlaylistAssets', thumbnailUrl: string | null | undefined } | null | undefined, videos: Array<{ __typename?: 'Video', id: string, identifier: string, kind: string, hls: string, hasAccess: boolean, cursorAt: number | null | undefined, assets: { __typename?: 'VideoAssets', thumbnailUrl: string | null | undefined } | null | undefined, player: { __typename?: 'VideoInfo', assets: Array<{ __typename?: 'VideoFileAsset', src: string | null | undefined, resolution: number | null | undefined } | null | undefined> | null | undefined } | null | undefined, meta: { __typename?: 'VideoMeta', minutes: number | null | undefined } | null | undefined, content: { __typename?: 'VideoContent', title: string | null | undefined, longDescription: string | null | undefined, shortDescription: string | null | undefined } | null | undefined, taxonomies: { __typename?: 'Taxonomy', instructors: Array<{ __typename?: 'Instructor', id: string, name: string | null | undefined, slug: string | null | undefined } | null | undefined> | null | undefined, needs: Array<{ __typename?: 'Term', id: string, name: string | null | undefined } | null | undefined> | null | undefined, bodyparts: Array<{ __typename?: 'Term', id: string, name: string | null | undefined } | null | undefined> | null | undefined, styles: Array<{ __typename?: 'Term', id: string, name: string | null | undefined } | null | undefined> | null | undefined, genre: { __typename?: 'Term', id: string, name: string | null | undefined, slug: string | null | undefined } | null | undefined } } | null | undefined> | null | undefined };

export type PlaylistCardFieldsFragment = { __typename?: 'Playlist', id: string, identifier: string | null | undefined, visibility: string | null | undefined, title: string, description: string | null | undefined, owner: { __typename?: 'User', id: string, firstName: string | null | undefined } | { __typename?: 'CurrentUser', id: string, firstName: string | null | undefined } | null | undefined, meta: { __typename?: 'Meta', videoCount: number | null | undefined, minutes: number | null | undefined } | null | undefined, assets: { __typename?: 'PlaylistAssets', thumbnailUrl: string | null | undefined } | null | undefined };

export type PlaylistQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PlaylistQuery = { __typename?: 'Query', playlist: { __typename?: 'Playlist', id: string, identifier: string | null | undefined, visibility: string | null | undefined, title: string, description: string | null | undefined, owner: { __typename?: 'User', id: string, firstName: string | null | undefined } | { __typename?: 'CurrentUser', id: string, firstName: string | null | undefined } | null | undefined, meta: { __typename?: 'Meta', videoCount: number | null | undefined, minutes: number | null | undefined } | null | undefined, assets: { __typename?: 'PlaylistAssets', thumbnailUrl: string | null | undefined } | null | undefined, videos: Array<{ __typename?: 'Video', id: string, identifier: string, kind: string, hls: string, hasAccess: boolean, cursorAt: number | null | undefined, assets: { __typename?: 'VideoAssets', thumbnailUrl: string | null | undefined } | null | undefined, player: { __typename?: 'VideoInfo', assets: Array<{ __typename?: 'VideoFileAsset', src: string | null | undefined, resolution: number | null | undefined } | null | undefined> | null | undefined } | null | undefined, meta: { __typename?: 'VideoMeta', minutes: number | null | undefined } | null | undefined, content: { __typename?: 'VideoContent', title: string | null | undefined, longDescription: string | null | undefined, shortDescription: string | null | undefined } | null | undefined, taxonomies: { __typename?: 'Taxonomy', instructors: Array<{ __typename?: 'Instructor', id: string, name: string | null | undefined, slug: string | null | undefined } | null | undefined> | null | undefined, needs: Array<{ __typename?: 'Term', id: string, name: string | null | undefined } | null | undefined> | null | undefined, bodyparts: Array<{ __typename?: 'Term', id: string, name: string | null | undefined } | null | undefined> | null | undefined, styles: Array<{ __typename?: 'Term', id: string, name: string | null | undefined } | null | undefined> | null | undefined, genre: { __typename?: 'Term', id: string, name: string | null | undefined, slug: string | null | undefined } | null | undefined } } | null | undefined> | null | undefined } | null | undefined };

export type VideoFieldsFragment = { __typename?: 'Video', id: string, identifier: string, kind: string, cursorAt: number | null | undefined, content: { __typename?: 'VideoContent', title: string | null | undefined, shortDescription: string | null | undefined, longDescription: string | null | undefined } | null | undefined, meta: { __typename?: 'VideoMeta', minutes: number | null | undefined, publishedAt: number | null | undefined } | null | undefined, primaryStyle: { __typename?: 'Term', name: string | null | undefined, slug: string | null | undefined } | null | undefined, taxonomies: { __typename?: 'Taxonomy', flavor: { __typename?: 'Term', id: string, name: string | null | undefined } | null | undefined, needs: Array<{ __typename?: 'Term', id: string, name: string | null | undefined } | null | undefined> | null | undefined, instructors: Array<{ __typename?: 'Instructor', id: string, name: string | null | undefined, slug: string | null | undefined } | null | undefined> | null | undefined, genre: { __typename?: 'Term', id: string, name: string | null | undefined, slug: string | null | undefined } | null | undefined }, assets: { __typename?: 'VideoAssets', thumbnailUrl: string | null | undefined } | null | undefined };

export type VideosQueryVariables = Exact<{
  taxonomies: InputMaybe<Array<TaxonomyInput> | TaxonomyInput>;
  page: InputMaybe<Scalars['Int']>;
  perPage: InputMaybe<Scalars['Int']>;
  genre: InputMaybe<Scalars['String']>;
  query: InputMaybe<Scalars['String']>;
  useLocale: InputMaybe<Scalars['Boolean']>;
  contentLanguages: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  excludeTerms: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  videoLevels: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  orderBy: InputMaybe<VideoOrderBy>;
}>;


export type VideosQuery = { __typename?: 'Query', videos: { __typename?: 'PagedVideos', page: number, perPage: number, totalCount: number, data: Array<{ __typename?: 'Video', id: string, identifier: string, kind: string, cursorAt: number | null | undefined, content: { __typename?: 'VideoContent', title: string | null | undefined, shortDescription: string | null | undefined, longDescription: string | null | undefined } | null | undefined, meta: { __typename?: 'VideoMeta', minutes: number | null | undefined, publishedAt: number | null | undefined } | null | undefined, primaryStyle: { __typename?: 'Term', name: string | null | undefined, slug: string | null | undefined } | null | undefined, taxonomies: { __typename?: 'Taxonomy', flavor: { __typename?: 'Term', id: string, name: string | null | undefined } | null | undefined, needs: Array<{ __typename?: 'Term', id: string, name: string | null | undefined } | null | undefined> | null | undefined, instructors: Array<{ __typename?: 'Instructor', id: string, name: string | null | undefined, slug: string | null | undefined } | null | undefined> | null | undefined, genre: { __typename?: 'Term', id: string, name: string | null | undefined, slug: string | null | undefined } | null | undefined }, assets: { __typename?: 'VideoAssets', thumbnailUrl: string | null | undefined } | null | undefined }> } };

export type LastWatchedSessionsQueryVariables = Exact<{ [key: string]: never; }>;


export type LastWatchedSessionsQuery = { __typename?: 'Query', lastWatchedSessions: Array<{ __typename?: 'Video', id: string, identifier: string, kind: string, cursorAt: number | null | undefined, content: { __typename?: 'VideoContent', title: string | null | undefined, shortDescription: string | null | undefined, longDescription: string | null | undefined } | null | undefined, meta: { __typename?: 'VideoMeta', minutes: number | null | undefined, publishedAt: number | null | undefined } | null | undefined, primaryStyle: { __typename?: 'Term', name: string | null | undefined, slug: string | null | undefined } | null | undefined, taxonomies: { __typename?: 'Taxonomy', flavor: { __typename?: 'Term', id: string, name: string | null | undefined } | null | undefined, needs: Array<{ __typename?: 'Term', id: string, name: string | null | undefined } | null | undefined> | null | undefined, instructors: Array<{ __typename?: 'Instructor', id: string, name: string | null | undefined, slug: string | null | undefined } | null | undefined> | null | undefined, genre: { __typename?: 'Term', id: string, name: string | null | undefined, slug: string | null | undefined } | null | undefined }, assets: { __typename?: 'VideoAssets', thumbnailUrl: string | null | undefined } | null | undefined }> };

export type LiveCodeDataFieldsFragment = { __typename?: 'PromotionCode', code: string, expirationDate: any | null | undefined, usageLimit: number | null | undefined, creationDate: any, provider: string | null | undefined, matchingResources: Array<{ __typename?: 'Bundle' } | { __typename?: 'GenericProgram' } | { __typename?: 'LiveEvent', id: string, title: string, slug: string, thumbnail: string, duration: number, eventDates: Array<any>, kind: LiveEventKind, language: LanguageKind, level: LiveEventLevel, theme: string, availableSpots: number, maximumParticipants: number, bookingAvailable: boolean, descriptionLong: string, registrationEndDate: any, registrationStartDate: any, isExpired: boolean | null | undefined, isComingSoon: boolean | null | undefined, price: { __typename?: 'Price', originalPrice: number | null | undefined, discountApplied: boolean, discountedPrice: number | null | undefined, currency: string | null | undefined } | null | undefined, primaryInstructor: { __typename?: 'Instructor', id: string, name: string | null | undefined, slug: string | null | undefined, assets: { __typename?: 'InstructorAssets', squareImage: string | null | undefined } | null | undefined } | null | undefined, instructors: Array<{ __typename?: 'Instructor', id: string, name: string | null | undefined, slug: string | null | undefined, assets: { __typename?: 'InstructorAssets', squareImage: string | null | undefined } | null | undefined } | null | undefined> | null | undefined }>, usedIn: Array<{ __typename?: 'PromotionCodeUser', usageDate: any, live: { __typename?: 'LiveEvent', id: string, title: string, slug: string, thumbnail: string, duration: number, eventDates: Array<any>, kind: LiveEventKind, language: LanguageKind, level: LiveEventLevel, theme: string, availableSpots: number, maximumParticipants: number, bookingAvailable: boolean, descriptionLong: string, registrationEndDate: any, registrationStartDate: any, isExpired: boolean | null | undefined, isComingSoon: boolean | null | undefined, price: { __typename?: 'Price', originalPrice: number | null | undefined, discountApplied: boolean, discountedPrice: number | null | undefined, currency: string | null | undefined } | null | undefined, primaryInstructor: { __typename?: 'Instructor', id: string, name: string | null | undefined, slug: string | null | undefined, assets: { __typename?: 'InstructorAssets', squareImage: string | null | undefined } | null | undefined } | null | undefined, instructors: Array<{ __typename?: 'Instructor', id: string, name: string | null | undefined, slug: string | null | undefined, assets: { __typename?: 'InstructorAssets', squareImage: string | null | undefined } | null | undefined } | null | undefined> | null | undefined } | null | undefined }> };

export type LiveEventCodesQueryVariables = Exact<{ [key: string]: never; }>;


export type LiveEventCodesQuery = { __typename?: 'Query', liveEventCodes: { __typename?: 'LiveEventCodes', trial: Array<{ __typename?: 'PromotionCode', code: string, expirationDate: any | null | undefined, usageLimit: number | null | undefined, creationDate: any, provider: string | null | undefined, matchingResources: Array<{ __typename?: 'Bundle' } | { __typename?: 'GenericProgram' } | { __typename?: 'LiveEvent', id: string, title: string, slug: string, thumbnail: string, duration: number, eventDates: Array<any>, kind: LiveEventKind, language: LanguageKind, level: LiveEventLevel, theme: string, availableSpots: number, maximumParticipants: number, bookingAvailable: boolean, descriptionLong: string, registrationEndDate: any, registrationStartDate: any, isExpired: boolean | null | undefined, isComingSoon: boolean | null | undefined, price: { __typename?: 'Price', originalPrice: number | null | undefined, discountApplied: boolean, discountedPrice: number | null | undefined, currency: string | null | undefined } | null | undefined, primaryInstructor: { __typename?: 'Instructor', id: string, name: string | null | undefined, slug: string | null | undefined, assets: { __typename?: 'InstructorAssets', squareImage: string | null | undefined } | null | undefined } | null | undefined, instructors: Array<{ __typename?: 'Instructor', id: string, name: string | null | undefined, slug: string | null | undefined, assets: { __typename?: 'InstructorAssets', squareImage: string | null | undefined } | null | undefined } | null | undefined> | null | undefined }>, usedIn: Array<{ __typename?: 'PromotionCodeUser', usageDate: any, live: { __typename?: 'LiveEvent', id: string, title: string, slug: string, thumbnail: string, duration: number, eventDates: Array<any>, kind: LiveEventKind, language: LanguageKind, level: LiveEventLevel, theme: string, availableSpots: number, maximumParticipants: number, bookingAvailable: boolean, descriptionLong: string, registrationEndDate: any, registrationStartDate: any, isExpired: boolean | null | undefined, isComingSoon: boolean | null | undefined, price: { __typename?: 'Price', originalPrice: number | null | undefined, discountApplied: boolean, discountedPrice: number | null | undefined, currency: string | null | undefined } | null | undefined, primaryInstructor: { __typename?: 'Instructor', id: string, name: string | null | undefined, slug: string | null | undefined, assets: { __typename?: 'InstructorAssets', squareImage: string | null | undefined } | null | undefined } | null | undefined, instructors: Array<{ __typename?: 'Instructor', id: string, name: string | null | undefined, slug: string | null | undefined, assets: { __typename?: 'InstructorAssets', squareImage: string | null | undefined } | null | undefined } | null | undefined> | null | undefined } | null | undefined }> }>, wellness: Array<{ __typename?: 'PromotionCode', code: string, expirationDate: any | null | undefined, usageLimit: number | null | undefined, creationDate: any, provider: string | null | undefined, matchingResources: Array<{ __typename?: 'Bundle' } | { __typename?: 'GenericProgram' } | { __typename?: 'LiveEvent', id: string, title: string, slug: string, thumbnail: string, duration: number, eventDates: Array<any>, kind: LiveEventKind, language: LanguageKind, level: LiveEventLevel, theme: string, availableSpots: number, maximumParticipants: number, bookingAvailable: boolean, descriptionLong: string, registrationEndDate: any, registrationStartDate: any, isExpired: boolean | null | undefined, isComingSoon: boolean | null | undefined, price: { __typename?: 'Price', originalPrice: number | null | undefined, discountApplied: boolean, discountedPrice: number | null | undefined, currency: string | null | undefined } | null | undefined, primaryInstructor: { __typename?: 'Instructor', id: string, name: string | null | undefined, slug: string | null | undefined, assets: { __typename?: 'InstructorAssets', squareImage: string | null | undefined } | null | undefined } | null | undefined, instructors: Array<{ __typename?: 'Instructor', id: string, name: string | null | undefined, slug: string | null | undefined, assets: { __typename?: 'InstructorAssets', squareImage: string | null | undefined } | null | undefined } | null | undefined> | null | undefined }>, usedIn: Array<{ __typename?: 'PromotionCodeUser', usageDate: any, live: { __typename?: 'LiveEvent', id: string, title: string, slug: string, thumbnail: string, duration: number, eventDates: Array<any>, kind: LiveEventKind, language: LanguageKind, level: LiveEventLevel, theme: string, availableSpots: number, maximumParticipants: number, bookingAvailable: boolean, descriptionLong: string, registrationEndDate: any, registrationStartDate: any, isExpired: boolean | null | undefined, isComingSoon: boolean | null | undefined, price: { __typename?: 'Price', originalPrice: number | null | undefined, discountApplied: boolean, discountedPrice: number | null | undefined, currency: string | null | undefined } | null | undefined, primaryInstructor: { __typename?: 'Instructor', id: string, name: string | null | undefined, slug: string | null | undefined, assets: { __typename?: 'InstructorAssets', squareImage: string | null | undefined } | null | undefined } | null | undefined, instructors: Array<{ __typename?: 'Instructor', id: string, name: string | null | undefined, slug: string | null | undefined, assets: { __typename?: 'InstructorAssets', squareImage: string | null | undefined } | null | undefined } | null | undefined> | null | undefined } | null | undefined }> }> } };

export type ParticipateInAnEventMutationVariables = Exact<{
  slug: Scalars['String'];
}>;


export type ParticipateInAnEventMutation = { __typename?: 'Mutation', participateInAnEvent: { __typename?: 'ParticipateInAnEventPayload', success: boolean, errors: Array<{ __typename?: 'Error', message: string | null | undefined }> | null | undefined } | null | undefined };

export type ActivateLiveEventMutationVariables = Exact<{
  slug: Scalars['String'];
  code: Scalars['String'];
}>;


export type ActivateLiveEventMutation = { __typename?: 'Mutation', activateLiveEvent: { __typename?: 'ActivateLiveEventPayload', success: boolean, errors: string | null | undefined } | null | undefined };

export type LiveEventEssentialFieldsFragment = { __typename?: 'LiveEvent', id: string, title: string, slug: string, thumbnail: string, duration: number, eventDates: Array<any>, kind: LiveEventKind, language: LanguageKind, level: LiveEventLevel, theme: string, availableSpots: number, maximumParticipants: number, bookingAvailable: boolean, descriptionLong: string, registrationEndDate: any, registrationStartDate: any, isExpired: boolean | null | undefined, isComingSoon: boolean | null | undefined, price: { __typename?: 'Price', originalPrice: number | null | undefined, discountApplied: boolean, discountedPrice: number | null | undefined, currency: string | null | undefined } | null | undefined, primaryInstructor: { __typename?: 'Instructor', id: string, name: string | null | undefined, slug: string | null | undefined, assets: { __typename?: 'InstructorAssets', squareImage: string | null | undefined } | null | undefined } | null | undefined, instructors: Array<{ __typename?: 'Instructor', id: string, name: string | null | undefined, slug: string | null | undefined, assets: { __typename?: 'InstructorAssets', squareImage: string | null | undefined } | null | undefined } | null | undefined> | null | undefined };

export type FullLiveEventFieldsFragment = { __typename?: 'LiveEvent', accessories: Array<string>, id: string, title: string, slug: string, thumbnail: string, duration: number, eventDates: Array<any>, kind: LiveEventKind, language: LanguageKind, level: LiveEventLevel, theme: string, availableSpots: number, maximumParticipants: number, bookingAvailable: boolean, descriptionLong: string, registrationEndDate: any, registrationStartDate: any, isExpired: boolean | null | undefined, isComingSoon: boolean | null | undefined, otherInstructors: Array<{ __typename?: 'Instructor', id: string, name: string | null | undefined, slug: string | null | undefined, assets: { __typename?: 'InstructorAssets', squareImage: string | null | undefined } | null | undefined }>, linkToRecordings: Array<{ __typename?: 'LinkToRecording', link: string | null | undefined, id: string, eventDate: any }> | null | undefined, price: { __typename?: 'Price', originalPrice: number | null | undefined, discountApplied: boolean, discountedPrice: number | null | undefined, currency: string | null | undefined } | null | undefined, primaryInstructor: { __typename?: 'Instructor', id: string, name: string | null | undefined, slug: string | null | undefined, assets: { __typename?: 'InstructorAssets', squareImage: string | null | undefined } | null | undefined } | null | undefined, instructors: Array<{ __typename?: 'Instructor', id: string, name: string | null | undefined, slug: string | null | undefined, assets: { __typename?: 'InstructorAssets', squareImage: string | null | undefined } | null | undefined } | null | undefined> | null | undefined };

export type LiveEventQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type LiveEventQuery = { __typename?: 'Query', liveEvent: { __typename?: 'LiveEvent', accessories: Array<string>, id: string, title: string, slug: string, thumbnail: string, duration: number, eventDates: Array<any>, kind: LiveEventKind, language: LanguageKind, level: LiveEventLevel, theme: string, availableSpots: number, maximumParticipants: number, bookingAvailable: boolean, descriptionLong: string, registrationEndDate: any, registrationStartDate: any, isExpired: boolean | null | undefined, isComingSoon: boolean | null | undefined, otherInstructors: Array<{ __typename?: 'Instructor', id: string, name: string | null | undefined, slug: string | null | undefined, assets: { __typename?: 'InstructorAssets', squareImage: string | null | undefined } | null | undefined }>, linkToRecordings: Array<{ __typename?: 'LinkToRecording', link: string | null | undefined, id: string, eventDate: any }> | null | undefined, price: { __typename?: 'Price', originalPrice: number | null | undefined, discountApplied: boolean, discountedPrice: number | null | undefined, currency: string | null | undefined } | null | undefined, primaryInstructor: { __typename?: 'Instructor', id: string, name: string | null | undefined, slug: string | null | undefined, assets: { __typename?: 'InstructorAssets', squareImage: string | null | undefined } | null | undefined } | null | undefined, instructors: Array<{ __typename?: 'Instructor', id: string, name: string | null | undefined, slug: string | null | undefined, assets: { __typename?: 'InstructorAssets', squareImage: string | null | undefined } | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type ValidateLiveEventCodeQueryVariables = Exact<{
  slug: Scalars['String'];
  code: Scalars['String'];
}>;


export type ValidateLiveEventCodeQuery = { __typename?: 'Query', validateLiveEventCode: { __typename?: 'ValidateCode', code: string | null | undefined, message: string | null | undefined, status: CodeStatusKind | null | undefined } };

export type LiveEventsQueryVariables = Exact<{
  perPage?: InputMaybe<Scalars['Int']>;
  page: InputMaybe<Scalars['Int']>;
  search: InputMaybe<Scalars['String']>;
  languages: InputMaybe<Array<LanguageKind> | LanguageKind>;
  instructor: InputMaybe<Scalars['String']>;
  sortBy: InputMaybe<LiveEventSortAttribute>;
  kind: InputMaybe<LiveEventKind>;
}>;


export type LiveEventsQuery = { __typename?: 'Query', liveEvents: { __typename?: 'PagedLiveEvents', page: number, totalCount: number, availableKinds: Array<LiveEventKind>, data: Array<{ __typename?: 'LiveEvent', id: string, title: string, slug: string, thumbnail: string, duration: number, eventDates: Array<any>, kind: LiveEventKind, language: LanguageKind, level: LiveEventLevel, theme: string, availableSpots: number, maximumParticipants: number, bookingAvailable: boolean, descriptionLong: string, registrationEndDate: any, registrationStartDate: any, isExpired: boolean | null | undefined, isComingSoon: boolean | null | undefined, price: { __typename?: 'Price', originalPrice: number | null | undefined, discountApplied: boolean, discountedPrice: number | null | undefined, currency: string | null | undefined } | null | undefined, primaryInstructor: { __typename?: 'Instructor', id: string, name: string | null | undefined, slug: string | null | undefined, assets: { __typename?: 'InstructorAssets', squareImage: string | null | undefined } | null | undefined } | null | undefined, instructors: Array<{ __typename?: 'Instructor', id: string, name: string | null | undefined, slug: string | null | undefined, assets: { __typename?: 'InstructorAssets', squareImage: string | null | undefined } | null | undefined } | null | undefined> | null | undefined }> } | null | undefined };

export type OrderQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type OrderQuery = { __typename?: 'Query', order: { __typename?: 'GenericProgramPayment', success: boolean, amountCents: number, amountCurrency: CurrencyKind, orderId: string, originalAmountCents: number | null | undefined, paymentProvider: PaymentProviderKind, voucher: boolean | null | undefined, program: { __typename?: 'GenericProgram', id: string, slug: string, title: string | null | undefined, category: ProgramCategory } } | { __typename?: 'LiveEventPayment', success: boolean, amountCents: number, amountCurrency: CurrencyKind, orderId: string, originalAmountCents: number | null | undefined, paymentProvider: PaymentProviderKind, live: { __typename?: 'LiveEvent', id: string, slug: string, title: string } } | { __typename?: 'SubscriptionPayment', amountCents: number, amountCurrency: CurrencyKind, months: number, orderId: string, originalAmountCents: number | null | undefined, paymentProvider: PaymentProviderKind, recurringAmountCents: number | null | undefined, recurringDate: any | null | undefined, success: boolean } | null | undefined };

export type PayForItemMutationVariables = Exact<{
  slug: Scalars['String'];
  paymentMethod: PaymentMethodInput;
  riskData: InputMaybe<RiskDataInput>;
  redirectToSuccess: InputMaybe<Scalars['String']>;
  redirectToFailed: InputMaybe<Scalars['String']>;
  browserInfo: InputMaybe<BrowserInfoInput>;
  itemKind: ItemKind;
  discountCode: InputMaybe<Scalars['String']>;
}>;


export type PayForItemMutation = { __typename?: 'Mutation', payForItem: { __typename?: 'PayForItemPayload', orderId: string | null | undefined, resultCode: string | null | undefined, transaction: string | null | undefined, resultAction: { __typename?: 'AdyenAction', actionType: string, url: string | null | undefined, httpMethod: string | null | undefined, paymentMethodType: string, paymentData: string, redirectData: string | null | undefined } | null | undefined, errors: Array<{ __typename?: 'Error', message: string | null | undefined }> | null | undefined } | null | undefined };

export type PayForVoucherMutationVariables = Exact<{
  slug: Scalars['String'];
  paymentMethod: PaymentMethodInput;
  itemKind: ItemKind;
  redirectToSuccess: InputMaybe<Scalars['String']>;
  redirectToFailed: InputMaybe<Scalars['String']>;
  riskData: InputMaybe<RiskDataInput>;
  browserInfo: InputMaybe<BrowserInfoInput>;
  discountCode: InputMaybe<Scalars['String']>;
  senderName: Scalars['String'];
  recipientName: Scalars['String'];
  recipientEmail: Scalars['String'];
  sendGiftEmail: Scalars['Boolean'];
  customMessage: InputMaybe<Scalars['String']>;
}>;


export type PayForVoucherMutation = { __typename?: 'Mutation', payForVoucher: { __typename?: 'PayForVoucherPayload', orderId: string | null | undefined, resultCode: string | null | undefined, transaction: string | null | undefined, resultAction: { __typename?: 'AdyenAction', actionType: string, url: string | null | undefined, httpMethod: string | null | undefined, paymentMethodType: string, paymentData: string, redirectData: string | null | undefined } | null | undefined, errors: Array<{ __typename?: 'Error', message: string | null | undefined }> | null | undefined } | null | undefined };

export type PhasedProgramFieldsFragment = { __typename?: 'PhasedProgram', id: string, slug: string, title: string | null | undefined, progress: number | null | undefined, language: string | null | undefined, weeksCount: number | null | undefined, phasesCount: number | null | undefined, videosCount: number | null | undefined, currentElement: { __typename?: 'CurrentElement', path: string | null | undefined, title: string | null | undefined } | null | undefined, instructors: Array<{ __typename?: 'Instructor', id: string, name: string | null | undefined, assets: { __typename?: 'InstructorAssets', squareImage: string | null | undefined } | null | undefined } | null | undefined> | null | undefined, intro: { __typename?: 'SpecialSection', description: string | null | undefined, label: string, assetUrl: string | null | undefined, slug: string } | null | undefined, outro: { __typename?: 'SpecialSection', description: string | null | undefined, label: string, slug: string, videos: Array<{ __typename?: 'ProgramVideo', id: string, slug: string, title: string | null | undefined, subheader: string | null | undefined, customTitle: string | null | undefined, locked: boolean, watched: boolean | null | undefined, finished: boolean | null | undefined, position: number, positionLabel: string, videoKind: VideoKind | null | undefined, progressIsCurrent: boolean, repeatRecomendation: number | null | undefined, customDescription: string | null | undefined, preMoodTracker: { __typename?: 'MoodTracker', id: string, finished: boolean | null | undefined, kind: MoodTrackerKind } | null | undefined, postMoodTracker: { __typename?: 'MoodTracker', id: string, finished: boolean | null | undefined, kind: MoodTrackerKind } | null | undefined, video: { __typename?: 'Video', id: string, title: string, kind: string, identifier: string, hasAccess: boolean, cursorAt: number | null | undefined, hls: string, content: { __typename?: 'VideoContent', title: string | null | undefined, shortDescription: string | null | undefined, longDescription: string | null | undefined } | null | undefined, player: { __typename?: 'VideoInfo', assets: Array<{ __typename?: 'VideoFileAsset', src: string | null | undefined, size: number | null | undefined, resolution: number | null | undefined } | null | undefined> | null | undefined } | null | undefined, meta: { __typename?: 'VideoMeta', publishedAt: number | null | undefined, minutes: number | null | undefined } | null | undefined, taxonomies: { __typename?: 'Taxonomy', flavor: { __typename?: 'Term', name: string | null | undefined } | null | undefined, instructors: Array<{ __typename?: 'Instructor', name: string | null | undefined, slug: string | null | undefined } | null | undefined> | null | undefined, genre: { __typename?: 'Term', name: string | null | undefined, slug: string | null | undefined } | null | undefined }, assets: { __typename?: 'VideoAssets', thumbnailUrl: string | null | undefined } | null | undefined } } | null | undefined> | null | undefined } | null | undefined, phases: Array<{ __typename?: 'ProgramPhase', id: string, description: string | null | undefined, label: string | null | undefined, progress: number | null | undefined, slug: string, finished: boolean | null | undefined, locked: boolean, videosCount: number | null | undefined, videosDuration: string | null | undefined, weeksRange: string | null | undefined, weeks: Array<{ __typename?: 'ProgramWeek', id: string, label: string, slug: string, locked: boolean, finished: boolean | null | undefined, indexInProgram: number | null | undefined, videos: Array<{ __typename?: 'ProgramVideo', id: string, slug: string, title: string | null | undefined, subheader: string | null | undefined, customTitle: string | null | undefined, locked: boolean, watched: boolean | null | undefined, finished: boolean | null | undefined, position: number, positionLabel: string, videoKind: VideoKind | null | undefined, progressIsCurrent: boolean, repeatRecomendation: number | null | undefined, customDescription: string | null | undefined, preMoodTracker: { __typename?: 'MoodTracker', id: string, finished: boolean | null | undefined, kind: MoodTrackerKind } | null | undefined, postMoodTracker: { __typename?: 'MoodTracker', id: string, finished: boolean | null | undefined, kind: MoodTrackerKind } | null | undefined, video: { __typename?: 'Video', id: string, title: string, kind: string, identifier: string, hasAccess: boolean, cursorAt: number | null | undefined, hls: string, content: { __typename?: 'VideoContent', title: string | null | undefined, shortDescription: string | null | undefined, longDescription: string | null | undefined } | null | undefined, player: { __typename?: 'VideoInfo', assets: Array<{ __typename?: 'VideoFileAsset', src: string | null | undefined, size: number | null | undefined, resolution: number | null | undefined } | null | undefined> | null | undefined } | null | undefined, meta: { __typename?: 'VideoMeta', publishedAt: number | null | undefined, minutes: number | null | undefined } | null | undefined, taxonomies: { __typename?: 'Taxonomy', flavor: { __typename?: 'Term', name: string | null | undefined } | null | undefined, instructors: Array<{ __typename?: 'Instructor', name: string | null | undefined, slug: string | null | undefined } | null | undefined> | null | undefined, genre: { __typename?: 'Term', name: string | null | undefined, slug: string | null | undefined } | null | undefined }, assets: { __typename?: 'VideoAssets', thumbnailUrl: string | null | undefined } | null | undefined } }> } | null | undefined> | null | undefined } | null | undefined> | null | undefined };

export type PhasedProgramQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type PhasedProgramQuery = { __typename?: 'Query', phasedProgram: { __typename?: 'PhasedProgram', id: string, slug: string, title: string | null | undefined, progress: number | null | undefined, language: string | null | undefined, weeksCount: number | null | undefined, phasesCount: number | null | undefined, videosCount: number | null | undefined, currentElement: { __typename?: 'CurrentElement', path: string | null | undefined, title: string | null | undefined } | null | undefined, instructors: Array<{ __typename?: 'Instructor', id: string, name: string | null | undefined, assets: { __typename?: 'InstructorAssets', squareImage: string | null | undefined } | null | undefined } | null | undefined> | null | undefined, intro: { __typename?: 'SpecialSection', description: string | null | undefined, label: string, assetUrl: string | null | undefined, slug: string } | null | undefined, outro: { __typename?: 'SpecialSection', description: string | null | undefined, label: string, slug: string, videos: Array<{ __typename?: 'ProgramVideo', id: string, slug: string, title: string | null | undefined, subheader: string | null | undefined, customTitle: string | null | undefined, locked: boolean, watched: boolean | null | undefined, finished: boolean | null | undefined, position: number, positionLabel: string, videoKind: VideoKind | null | undefined, progressIsCurrent: boolean, repeatRecomendation: number | null | undefined, customDescription: string | null | undefined, preMoodTracker: { __typename?: 'MoodTracker', id: string, finished: boolean | null | undefined, kind: MoodTrackerKind } | null | undefined, postMoodTracker: { __typename?: 'MoodTracker', id: string, finished: boolean | null | undefined, kind: MoodTrackerKind } | null | undefined, video: { __typename?: 'Video', id: string, title: string, kind: string, identifier: string, hasAccess: boolean, cursorAt: number | null | undefined, hls: string, content: { __typename?: 'VideoContent', title: string | null | undefined, shortDescription: string | null | undefined, longDescription: string | null | undefined } | null | undefined, player: { __typename?: 'VideoInfo', assets: Array<{ __typename?: 'VideoFileAsset', src: string | null | undefined, size: number | null | undefined, resolution: number | null | undefined } | null | undefined> | null | undefined } | null | undefined, meta: { __typename?: 'VideoMeta', publishedAt: number | null | undefined, minutes: number | null | undefined } | null | undefined, taxonomies: { __typename?: 'Taxonomy', flavor: { __typename?: 'Term', name: string | null | undefined } | null | undefined, instructors: Array<{ __typename?: 'Instructor', name: string | null | undefined, slug: string | null | undefined } | null | undefined> | null | undefined, genre: { __typename?: 'Term', name: string | null | undefined, slug: string | null | undefined } | null | undefined }, assets: { __typename?: 'VideoAssets', thumbnailUrl: string | null | undefined } | null | undefined } } | null | undefined> | null | undefined } | null | undefined, phases: Array<{ __typename?: 'ProgramPhase', id: string, description: string | null | undefined, label: string | null | undefined, progress: number | null | undefined, slug: string, finished: boolean | null | undefined, locked: boolean, videosCount: number | null | undefined, videosDuration: string | null | undefined, weeksRange: string | null | undefined, weeks: Array<{ __typename?: 'ProgramWeek', id: string, label: string, slug: string, locked: boolean, finished: boolean | null | undefined, indexInProgram: number | null | undefined, videos: Array<{ __typename?: 'ProgramVideo', id: string, slug: string, title: string | null | undefined, subheader: string | null | undefined, customTitle: string | null | undefined, locked: boolean, watched: boolean | null | undefined, finished: boolean | null | undefined, position: number, positionLabel: string, videoKind: VideoKind | null | undefined, progressIsCurrent: boolean, repeatRecomendation: number | null | undefined, customDescription: string | null | undefined, preMoodTracker: { __typename?: 'MoodTracker', id: string, finished: boolean | null | undefined, kind: MoodTrackerKind } | null | undefined, postMoodTracker: { __typename?: 'MoodTracker', id: string, finished: boolean | null | undefined, kind: MoodTrackerKind } | null | undefined, video: { __typename?: 'Video', id: string, title: string, kind: string, identifier: string, hasAccess: boolean, cursorAt: number | null | undefined, hls: string, content: { __typename?: 'VideoContent', title: string | null | undefined, shortDescription: string | null | undefined, longDescription: string | null | undefined } | null | undefined, player: { __typename?: 'VideoInfo', assets: Array<{ __typename?: 'VideoFileAsset', src: string | null | undefined, size: number | null | undefined, resolution: number | null | undefined } | null | undefined> | null | undefined } | null | undefined, meta: { __typename?: 'VideoMeta', publishedAt: number | null | undefined, minutes: number | null | undefined } | null | undefined, taxonomies: { __typename?: 'Taxonomy', flavor: { __typename?: 'Term', name: string | null | undefined } | null | undefined, instructors: Array<{ __typename?: 'Instructor', name: string | null | undefined, slug: string | null | undefined } | null | undefined> | null | undefined, genre: { __typename?: 'Term', name: string | null | undefined, slug: string | null | undefined } | null | undefined }, assets: { __typename?: 'VideoAssets', thumbnailUrl: string | null | undefined } | null | undefined } }> } | null | undefined> | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type AddFavoritePlaylistMutationVariables = Exact<{
  playlistId: Scalars['ID'];
}>;


export type AddFavoritePlaylistMutation = { __typename?: 'Mutation', addFavoritePlaylist: { __typename?: 'AddFavoritePlaylistPayload', playlist: { __typename?: 'Playlist', favorited: boolean | null | undefined } | null | undefined } | null | undefined };

export type DeleteFavoritePlaylistMutationVariables = Exact<{
  playlistId: Scalars['ID'];
}>;


export type DeleteFavoritePlaylistMutation = { __typename?: 'Mutation', deleteFavoritePlaylist: { __typename?: 'DeleteFavoritePlaylistPayload', playlist: { __typename?: 'Playlist', favorited: boolean | null | undefined } | null | undefined } | null | undefined };

export type SearchVideoFieldsFragment = { __typename?: 'SearchVideo', id: string, identifier: string, title: string, thumbnailUrl: string | null | undefined, instructorName: string | null | undefined, instructorSlug: string | null | undefined, longDescription: string, kind: string, minutes: string, primaryStyleName: string | null | undefined, primaryStyleSlug: string | null | undefined, shortDescription: string };

export type SearchPlaylistFieldsFragment = { __typename?: 'SearchPlaylist', id: string, identifier: string, title: string, description: string, minutes: string | null | undefined, thumbnailUrl: string | null | undefined, videoCount: string | null | undefined, ownerId: string | null | undefined, visibility: string | null | undefined };

export type SearchGenericProgramFieldsFragment = { __typename?: 'SearchGenericProgram', category: string | null | undefined, description: string, durationUnit: string | null | undefined, durationValue: string | null | undefined, id: string, instructorName: string | null | undefined, instructorSlug: string | null | undefined, priceType: PriceTypeKind | null | undefined, slug: string | null | undefined, themes: Array<ThemeKind> | null | undefined, title: string, titleImageUrl: string | null | undefined, accessPeriod: { __typename?: 'AccessPeriod', unit: AccessPeriodUnitKind | null | undefined, value: number | null | undefined } | null | undefined, price: { __typename?: 'Price', currency: string | null | undefined, discountApplied: boolean, discountedPrice: number | null | undefined, originalPrice: number | null | undefined } | null | undefined };

export type SearchInstructorFieldsFragment = { __typename?: 'SearchInstructor', description: string | null | undefined, id: string, name: string | null | undefined, slug: string | null | undefined, squareImageUrl: string | null | undefined };

export type SearchEventFieldsFragment = { __typename?: 'SearchEvent', id: string, name: string, slug: string | null | undefined, description: string | null | undefined, endsAt: any | null | undefined, instructor: string | null | undefined, startsAt: any | null | undefined, titleImageUrl: string | null | undefined, location: string | null | undefined };

export type SearchLiveEventFieldsFragment = { __typename?: 'SearchLiveEvent', id: string, kind: LiveEventKind, slug: string | null | undefined, theme: string | null | undefined, thumbnailUrl: string | null | undefined, title: string, availableSpots: number | null | undefined, bookingAvailable: boolean | null | undefined, duration: number, eventDates: Array<any>, instructorName: string | null | undefined, instructorSlug: string | null | undefined, maximumParticipants: number | null | undefined, registrationEndDate: any | null | undefined, registrationStartDate: any | null | undefined, isExpired: boolean | null | undefined, isComingSoon: boolean | null | undefined, price: { __typename?: 'Price', currency: string | null | undefined, discountApplied: boolean, discountedPrice: number | null | undefined, originalPrice: number | null | undefined } | null | undefined };

export type SearchLandingPageFieldsFragment = { __typename?: 'SearchLandingPage', id: string, lede: string | null | undefined, locale: string | null | undefined, title: string | null | undefined, slug: string | null | undefined };

export type SearchBlogPostFieldsFragment = { __typename?: 'SearchBlogPost', featuredImageUrl: string | null | undefined, id: string, slug: string, title: string };

export type AutocompleteQueryVariables = Exact<{
  query: Scalars['String'];
}>;


export type AutocompleteQuery = { __typename?: 'Query', autocomplete: { __typename?: 'Autocomplete', query: string | null | undefined, error: string | null | undefined, results: Array<string> } };

export type SpecificSearchQueryVariables = Exact<{
  query: Scalars['String'];
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  modelType: ModelNameKind;
  languages: Array<LanguageKind> | LanguageKind;
}>;


export type SpecificSearchQuery = { __typename?: 'Query', specificSearch: { __typename?: 'SpecificSearch', query: string | null | undefined, blogPosts: { __typename?: 'SearchResults', page: number, perPage: number, totalCount: number, results: Array<{ __typename: 'SearchBlogPost', featuredImageUrl: string | null | undefined, id: string, slug: string, title: string } | { __typename: 'SearchEvent' } | { __typename: 'SearchGenericProgram' } | { __typename: 'SearchInstructor' } | { __typename: 'SearchLandingPage' } | { __typename: 'SearchLiveEvent' } | { __typename: 'SearchPlaylist' } | { __typename: 'SearchVideo' }> | null | undefined } | null | undefined, challenges: { __typename?: 'SearchResults', page: number, perPage: number, totalCount: number, results: Array<{ __typename: 'SearchBlogPost' } | { __typename: 'SearchEvent' } | { __typename: 'SearchGenericProgram', category: string | null | undefined, description: string, durationUnit: string | null | undefined, durationValue: string | null | undefined, id: string, instructorName: string | null | undefined, instructorSlug: string | null | undefined, priceType: PriceTypeKind | null | undefined, slug: string | null | undefined, themes: Array<ThemeKind> | null | undefined, title: string, titleImageUrl: string | null | undefined, accessPeriod: { __typename?: 'AccessPeriod', unit: AccessPeriodUnitKind | null | undefined, value: number | null | undefined } | null | undefined, price: { __typename?: 'Price', currency: string | null | undefined, discountApplied: boolean, discountedPrice: number | null | undefined, originalPrice: number | null | undefined } | null | undefined } | { __typename: 'SearchInstructor' } | { __typename: 'SearchLandingPage' } | { __typename: 'SearchLiveEvent' } | { __typename: 'SearchPlaylist' } | { __typename: 'SearchVideo' }> | null | undefined } | null | undefined, events: { __typename?: 'SearchResults', page: number, perPage: number, totalCount: number, results: Array<{ __typename: 'SearchBlogPost' } | { __typename: 'SearchEvent', id: string, name: string, slug: string | null | undefined, description: string | null | undefined, endsAt: any | null | undefined, instructor: string | null | undefined, startsAt: any | null | undefined, titleImageUrl: string | null | undefined, location: string | null | undefined } | { __typename: 'SearchGenericProgram' } | { __typename: 'SearchInstructor' } | { __typename: 'SearchLandingPage' } | { __typename: 'SearchLiveEvent' } | { __typename: 'SearchPlaylist' } | { __typename: 'SearchVideo' }> | null | undefined } | null | undefined, genericPrograms: { __typename?: 'SearchResults', page: number, perPage: number, totalCount: number, results: Array<{ __typename: 'SearchBlogPost' } | { __typename: 'SearchEvent' } | { __typename: 'SearchGenericProgram', category: string | null | undefined, description: string, durationUnit: string | null | undefined, durationValue: string | null | undefined, id: string, instructorName: string | null | undefined, instructorSlug: string | null | undefined, priceType: PriceTypeKind | null | undefined, slug: string | null | undefined, themes: Array<ThemeKind> | null | undefined, title: string, titleImageUrl: string | null | undefined, accessPeriod: { __typename?: 'AccessPeriod', unit: AccessPeriodUnitKind | null | undefined, value: number | null | undefined } | null | undefined, price: { __typename?: 'Price', currency: string | null | undefined, discountApplied: boolean, discountedPrice: number | null | undefined, originalPrice: number | null | undefined } | null | undefined } | { __typename: 'SearchInstructor' } | { __typename: 'SearchLandingPage' } | { __typename: 'SearchLiveEvent' } | { __typename: 'SearchPlaylist' } | { __typename: 'SearchVideo' }> | null | undefined } | null | undefined, courses: { __typename?: 'SearchResults', page: number, perPage: number, totalCount: number, results: Array<{ __typename: 'SearchBlogPost' } | { __typename: 'SearchEvent' } | { __typename: 'SearchGenericProgram', category: string | null | undefined, description: string, durationUnit: string | null | undefined, durationValue: string | null | undefined, id: string, instructorName: string | null | undefined, instructorSlug: string | null | undefined, priceType: PriceTypeKind | null | undefined, slug: string | null | undefined, themes: Array<ThemeKind> | null | undefined, title: string, titleImageUrl: string | null | undefined, accessPeriod: { __typename?: 'AccessPeriod', unit: AccessPeriodUnitKind | null | undefined, value: number | null | undefined } | null | undefined, price: { __typename?: 'Price', currency: string | null | undefined, discountApplied: boolean, discountedPrice: number | null | undefined, originalPrice: number | null | undefined } | null | undefined } | { __typename: 'SearchInstructor' } | { __typename: 'SearchLandingPage' } | { __typename: 'SearchLiveEvent' } | { __typename: 'SearchPlaylist' } | { __typename: 'SearchVideo' }> | null | undefined } | null | undefined, instructors: { __typename?: 'SearchResults', page: number, perPage: number, totalCount: number, results: Array<{ __typename: 'SearchBlogPost' } | { __typename: 'SearchEvent' } | { __typename: 'SearchGenericProgram' } | { __typename: 'SearchInstructor', description: string | null | undefined, id: string, name: string | null | undefined, slug: string | null | undefined, squareImageUrl: string | null | undefined } | { __typename: 'SearchLandingPage' } | { __typename: 'SearchLiveEvent' } | { __typename: 'SearchPlaylist' } | { __typename: 'SearchVideo' }> | null | undefined } | null | undefined, landingPages: { __typename?: 'SearchResults', page: number, perPage: number, totalCount: number, results: Array<{ __typename: 'SearchBlogPost' } | { __typename: 'SearchEvent' } | { __typename: 'SearchGenericProgram' } | { __typename: 'SearchInstructor' } | { __typename: 'SearchLandingPage', id: string, lede: string | null | undefined, locale: string | null | undefined, title: string | null | undefined, slug: string | null | undefined } | { __typename: 'SearchLiveEvent' } | { __typename: 'SearchPlaylist' } | { __typename: 'SearchVideo' }> | null | undefined } | null | undefined, liveEvents: { __typename?: 'SearchResults', page: number, perPage: number, totalCount: number, results: Array<{ __typename: 'SearchBlogPost' } | { __typename: 'SearchEvent' } | { __typename: 'SearchGenericProgram' } | { __typename: 'SearchInstructor' } | { __typename: 'SearchLandingPage' } | { __typename: 'SearchLiveEvent', id: string, kind: LiveEventKind, slug: string | null | undefined, theme: string | null | undefined, thumbnailUrl: string | null | undefined, title: string, availableSpots: number | null | undefined, bookingAvailable: boolean | null | undefined, duration: number, eventDates: Array<any>, instructorName: string | null | undefined, instructorSlug: string | null | undefined, maximumParticipants: number | null | undefined, registrationEndDate: any | null | undefined, registrationStartDate: any | null | undefined, isExpired: boolean | null | undefined, isComingSoon: boolean | null | undefined, price: { __typename?: 'Price', currency: string | null | undefined, discountApplied: boolean, discountedPrice: number | null | undefined, originalPrice: number | null | undefined } | null | undefined } | { __typename: 'SearchPlaylist' } | { __typename: 'SearchVideo' }> | null | undefined } | null | undefined, playlists: { __typename?: 'SearchResults', page: number, perPage: number, totalCount: number, results: Array<{ __typename: 'SearchBlogPost' } | { __typename: 'SearchEvent' } | { __typename: 'SearchGenericProgram' } | { __typename: 'SearchInstructor' } | { __typename: 'SearchLandingPage' } | { __typename: 'SearchLiveEvent' } | { __typename: 'SearchPlaylist', id: string, identifier: string, title: string, description: string, minutes: string | null | undefined, thumbnailUrl: string | null | undefined, videoCount: string | null | undefined, ownerId: string | null | undefined, visibility: string | null | undefined } | { __typename: 'SearchVideo' }> | null | undefined } | null | undefined, videos: { __typename?: 'SearchResults', page: number, perPage: number, totalCount: number, results: Array<{ __typename: 'SearchBlogPost' } | { __typename: 'SearchEvent' } | { __typename: 'SearchGenericProgram' } | { __typename: 'SearchInstructor' } | { __typename: 'SearchLandingPage' } | { __typename: 'SearchLiveEvent' } | { __typename: 'SearchPlaylist' } | { __typename: 'SearchVideo', id: string, identifier: string, title: string, thumbnailUrl: string | null | undefined, instructorName: string | null | undefined, instructorSlug: string | null | undefined, longDescription: string, kind: string, minutes: string, primaryStyleName: string | null | undefined, primaryStyleSlug: string | null | undefined, shortDescription: string }> | null | undefined } | null | undefined } | null | undefined };

export type SearchQueryVariables = Exact<{
  query: Scalars['String'];
  searchType: GlobalSearch;
  languages: Array<LanguageKind> | LanguageKind;
}>;


export type SearchQuery = { __typename?: 'Query', search: { __typename?: 'Search', query: string | null | undefined, blogPosts: { __typename?: 'SearchResults', page: number, perPage: number, totalCount: number, results: Array<{ __typename: 'SearchBlogPost', featuredImageUrl: string | null | undefined, id: string, slug: string, title: string } | { __typename: 'SearchEvent' } | { __typename: 'SearchGenericProgram' } | { __typename: 'SearchInstructor' } | { __typename: 'SearchLandingPage' } | { __typename: 'SearchLiveEvent' } | { __typename: 'SearchPlaylist' } | { __typename: 'SearchVideo' }> | null | undefined } | null | undefined, challenges: { __typename?: 'SearchResults', page: number, perPage: number, totalCount: number, results: Array<{ __typename: 'SearchBlogPost' } | { __typename: 'SearchEvent' } | { __typename: 'SearchGenericProgram', category: string | null | undefined, description: string, durationUnit: string | null | undefined, durationValue: string | null | undefined, id: string, instructorName: string | null | undefined, instructorSlug: string | null | undefined, priceType: PriceTypeKind | null | undefined, slug: string | null | undefined, themes: Array<ThemeKind> | null | undefined, title: string, titleImageUrl: string | null | undefined, accessPeriod: { __typename?: 'AccessPeriod', unit: AccessPeriodUnitKind | null | undefined, value: number | null | undefined } | null | undefined, price: { __typename?: 'Price', currency: string | null | undefined, discountApplied: boolean, discountedPrice: number | null | undefined, originalPrice: number | null | undefined } | null | undefined } | { __typename: 'SearchInstructor' } | { __typename: 'SearchLandingPage' } | { __typename: 'SearchLiveEvent' } | { __typename: 'SearchPlaylist' } | { __typename: 'SearchVideo' }> | null | undefined } | null | undefined, events: { __typename?: 'SearchResults', page: number, perPage: number, totalCount: number, results: Array<{ __typename: 'SearchBlogPost' } | { __typename: 'SearchEvent', id: string, name: string, slug: string | null | undefined, description: string | null | undefined, endsAt: any | null | undefined, instructor: string | null | undefined, startsAt: any | null | undefined, titleImageUrl: string | null | undefined, location: string | null | undefined } | { __typename: 'SearchGenericProgram' } | { __typename: 'SearchInstructor' } | { __typename: 'SearchLandingPage' } | { __typename: 'SearchLiveEvent' } | { __typename: 'SearchPlaylist' } | { __typename: 'SearchVideo' }> | null | undefined } | null | undefined, genericPrograms: { __typename?: 'SearchResults', page: number, perPage: number, totalCount: number, results: Array<{ __typename: 'SearchBlogPost' } | { __typename: 'SearchEvent' } | { __typename: 'SearchGenericProgram', category: string | null | undefined, description: string, durationUnit: string | null | undefined, durationValue: string | null | undefined, id: string, instructorName: string | null | undefined, instructorSlug: string | null | undefined, priceType: PriceTypeKind | null | undefined, slug: string | null | undefined, themes: Array<ThemeKind> | null | undefined, title: string, titleImageUrl: string | null | undefined, accessPeriod: { __typename?: 'AccessPeriod', unit: AccessPeriodUnitKind | null | undefined, value: number | null | undefined } | null | undefined, price: { __typename?: 'Price', currency: string | null | undefined, discountApplied: boolean, discountedPrice: number | null | undefined, originalPrice: number | null | undefined } | null | undefined } | { __typename: 'SearchInstructor' } | { __typename: 'SearchLandingPage' } | { __typename: 'SearchLiveEvent' } | { __typename: 'SearchPlaylist' } | { __typename: 'SearchVideo' }> | null | undefined } | null | undefined, courses: { __typename?: 'SearchResults', page: number, perPage: number, totalCount: number, results: Array<{ __typename: 'SearchBlogPost' } | { __typename: 'SearchEvent' } | { __typename: 'SearchGenericProgram', category: string | null | undefined, description: string, durationUnit: string | null | undefined, durationValue: string | null | undefined, id: string, instructorName: string | null | undefined, instructorSlug: string | null | undefined, priceType: PriceTypeKind | null | undefined, slug: string | null | undefined, themes: Array<ThemeKind> | null | undefined, title: string, titleImageUrl: string | null | undefined, accessPeriod: { __typename?: 'AccessPeriod', unit: AccessPeriodUnitKind | null | undefined, value: number | null | undefined } | null | undefined, price: { __typename?: 'Price', currency: string | null | undefined, discountApplied: boolean, discountedPrice: number | null | undefined, originalPrice: number | null | undefined } | null | undefined } | { __typename: 'SearchInstructor' } | { __typename: 'SearchLandingPage' } | { __typename: 'SearchLiveEvent' } | { __typename: 'SearchPlaylist' } | { __typename: 'SearchVideo' }> | null | undefined } | null | undefined, instructors: { __typename?: 'SearchResults', page: number, perPage: number, totalCount: number, results: Array<{ __typename: 'SearchBlogPost' } | { __typename: 'SearchEvent' } | { __typename: 'SearchGenericProgram' } | { __typename: 'SearchInstructor', description: string | null | undefined, id: string, name: string | null | undefined, slug: string | null | undefined, squareImageUrl: string | null | undefined } | { __typename: 'SearchLandingPage' } | { __typename: 'SearchLiveEvent' } | { __typename: 'SearchPlaylist' } | { __typename: 'SearchVideo' }> | null | undefined } | null | undefined, landingPages: { __typename?: 'SearchResults', page: number, perPage: number, totalCount: number, results: Array<{ __typename: 'SearchBlogPost' } | { __typename: 'SearchEvent' } | { __typename: 'SearchGenericProgram' } | { __typename: 'SearchInstructor' } | { __typename: 'SearchLandingPage', id: string, lede: string | null | undefined, locale: string | null | undefined, title: string | null | undefined, slug: string | null | undefined } | { __typename: 'SearchLiveEvent' } | { __typename: 'SearchPlaylist' } | { __typename: 'SearchVideo' }> | null | undefined } | null | undefined, liveEvents: { __typename?: 'SearchResults', page: number, perPage: number, totalCount: number, results: Array<{ __typename: 'SearchBlogPost' } | { __typename: 'SearchEvent' } | { __typename: 'SearchGenericProgram' } | { __typename: 'SearchInstructor' } | { __typename: 'SearchLandingPage' } | { __typename: 'SearchLiveEvent', id: string, kind: LiveEventKind, slug: string | null | undefined, theme: string | null | undefined, thumbnailUrl: string | null | undefined, title: string, availableSpots: number | null | undefined, bookingAvailable: boolean | null | undefined, duration: number, eventDates: Array<any>, instructorName: string | null | undefined, instructorSlug: string | null | undefined, maximumParticipants: number | null | undefined, registrationEndDate: any | null | undefined, registrationStartDate: any | null | undefined, isExpired: boolean | null | undefined, isComingSoon: boolean | null | undefined, price: { __typename?: 'Price', currency: string | null | undefined, discountApplied: boolean, discountedPrice: number | null | undefined, originalPrice: number | null | undefined } | null | undefined } | { __typename: 'SearchPlaylist' } | { __typename: 'SearchVideo' }> | null | undefined } | null | undefined, playlists: { __typename?: 'SearchResults', page: number, perPage: number, totalCount: number, results: Array<{ __typename: 'SearchBlogPost' } | { __typename: 'SearchEvent' } | { __typename: 'SearchGenericProgram' } | { __typename: 'SearchInstructor' } | { __typename: 'SearchLandingPage' } | { __typename: 'SearchLiveEvent' } | { __typename: 'SearchPlaylist', id: string, identifier: string, title: string, description: string, minutes: string | null | undefined, thumbnailUrl: string | null | undefined, videoCount: string | null | undefined, ownerId: string | null | undefined, visibility: string | null | undefined } | { __typename: 'SearchVideo' }> | null | undefined } | null | undefined, videos: { __typename?: 'SearchResults', page: number, perPage: number, totalCount: number, results: Array<{ __typename: 'SearchBlogPost' } | { __typename: 'SearchEvent' } | { __typename: 'SearchGenericProgram' } | { __typename: 'SearchInstructor' } | { __typename: 'SearchLandingPage' } | { __typename: 'SearchLiveEvent' } | { __typename: 'SearchPlaylist' } | { __typename: 'SearchVideo', id: string, identifier: string, title: string, thumbnailUrl: string | null | undefined, instructorName: string | null | undefined, instructorSlug: string | null | undefined, longDescription: string, kind: string, minutes: string, primaryStyleName: string | null | undefined, primaryStyleSlug: string | null | undefined, shortDescription: string }> | null | undefined } | null | undefined } | null | undefined };

export type AddSearchResultMutationVariables = Exact<{
  modelType: ModelNameKind;
  documentId: Scalars['String'];
  query: Scalars['String'];
}>;


export type AddSearchResultMutation = { __typename?: 'Mutation', addSearchResult: { __typename?: 'AddSearchResultPayload', documentId: string | null | undefined } | null | undefined };

export type SignUpMutationVariables = Exact<{
  firstName: Scalars['String'];
  email: Scalars['String'];
  password: Scalars['String'];
  country: Scalars['String'];
  lastName: InputMaybe<Scalars['String']>;
  utmSource: InputMaybe<Scalars['String']>;
  utmMedium: InputMaybe<Scalars['String']>;
  utmCampaign: InputMaybe<Scalars['String']>;
  paymentType: InputMaybe<Scalars['String']>;
  campaignCode: InputMaybe<Scalars['String']>;
}>;


export type SignUpMutation = { __typename?: 'Mutation', signUpV2: { __typename?: 'RegistrationV2Payload', user: { __typename?: 'CurrentUser', id: string, email: string | null | undefined, gender: string | null | undefined, country: string | null | undefined, accessUntil: string | null | undefined } | null | undefined, errors: Array<{ __typename?: 'Error', message: string | null | undefined }> | null | undefined } | null | undefined };

export type SocialSignUpMutationVariables = Exact<{
  provider: ProviderTypes;
  method: MethodTypes;
  code: InputMaybe<Scalars['String']>;
  accessToken: InputMaybe<Scalars['String']>;
  identityToken: InputMaybe<Scalars['String']>;
  firstName: InputMaybe<Scalars['String']>;
  lastName: InputMaybe<Scalars['String']>;
  avatarFromUrl: InputMaybe<Scalars['String']>;
  paymentType: InputMaybe<Scalars['String']>;
  campaignCode: InputMaybe<Scalars['String']>;
  utmSource: InputMaybe<Scalars['String']>;
  utmMedium: InputMaybe<Scalars['String']>;
  utmCampaign: InputMaybe<Scalars['String']>;
}>;


export type SocialSignUpMutation = { __typename?: 'Mutation', socialSignUp: { __typename?: 'SignUpPayload', success: boolean | null | undefined, user: { __typename?: 'User', id: string } | { __typename?: 'CurrentUser', id: string } | null | undefined } | null | undefined };

export type SocialSignInMutationVariables = Exact<{
  provider: ProviderTypes;
  method: MethodTypes;
  code: InputMaybe<Scalars['String']>;
  accessToken: InputMaybe<Scalars['String']>;
  identityToken: InputMaybe<Scalars['String']>;
}>;


export type SocialSignInMutation = { __typename?: 'Mutation', socialSignIn: { __typename?: 'SignInPayload', success: boolean | null | undefined, user: { __typename?: 'User', id: string } | { __typename?: 'CurrentUser', id: string } | null | undefined } | null | undefined };

export type StartOverviewQueryVariables = Exact<{ [key: string]: never; }>;


export type StartOverviewQuery = { __typename?: 'Query', startOverview: { __typename?: 'StartOverview', metaSection: { __typename?: 'MetaSection', description: string | null | undefined, imageUrl: string | null | undefined, title: string | null | undefined } | null | undefined, heroSection: { __typename?: 'HeroSection', title: string | null | undefined, description: string | null | undefined, smallNote: string | null | undefined, imageUrl: string | null | undefined } | null | undefined, coursesSection: { __typename?: 'CoursesSection', title: string | null | undefined, description: string | null | undefined, group1Title: string | null | undefined, group1Description: string | null | undefined, group1ButtonLink: string | null | undefined, group1ButtonText: string | null | undefined, group1ImageUrl: string | null | undefined, group2Title: string | null | undefined, group2Description: string | null | undefined, group2ButtonLink: string | null | undefined, group2ButtonText: string | null | undefined, group2ImageUrl: string | null | undefined } | null | undefined, campaignSection: { __typename?: 'CampaignSection', title: string | null | undefined, description: string | null | undefined, buttonLink: string | null | undefined, buttonText: string | null | undefined, imageUrl: string | null | undefined, tag: string | null | undefined } | null | undefined, featuresSection: { __typename?: 'FeaturesSection', description: string | null | undefined, featureBullets: Array<string> | null | undefined, imageUrl: string | null | undefined, title: string | null | undefined } | null | undefined, genresSection: { __typename?: 'GenresSection', title: string | null | undefined, description: string | null | undefined, genre: Array<{ __typename?: 'PageSection', title: string | null | undefined, slug: SlugTypeKind | null | undefined, name: string | null | undefined, description: string | null | undefined, imageUrl: string | null | undefined, otherType: OtherTypeKind | null | undefined, sectionType: string | null | undefined }> | null | undefined } | null | undefined, mobileAppSection: { __typename?: 'MobileAppSection', description: string | null | undefined, imageUrl: string | null | undefined, title: string | null | undefined } | null | undefined, otherFeaturesSection: { __typename?: 'OtherFeaturesSection', description: string | null | undefined, title: string | null | undefined, otherFeatures: Array<{ __typename?: 'PageSection', description: string | null | undefined, imageUrl: string | null | undefined, name: string | null | undefined, url: string | null | undefined, otherType: OtherTypeKind | null | undefined, sectionType: string | null | undefined, slug: SlugTypeKind | null | undefined, title: string | null | undefined }> | null | undefined } | null | undefined, videoLibrarySection: { __typename?: 'VideosLibrarySection', description: string | null | undefined, title: string | null | undefined, videosLibrary: Array<{ __typename?: 'PageSection', slug: SlugTypeKind | null | undefined, title: string | null | undefined, name: string | null | undefined, description: string | null | undefined, url: string | null | undefined, imageUrl: string | null | undefined, otherType: OtherTypeKind | null | undefined, sectionType: string | null | undefined }> | null | undefined } | null | undefined } };

export type VideoWatchMutationVariables = Exact<{
  videoId: Scalars['String'];
  seconds: Scalars['Int'];
  cursorAt: Scalars['Int'];
}>;


export type VideoWatchMutation = { __typename?: 'Mutation', videoWatch: { __typename?: 'WatchPayload', errors: Array<{ __typename?: 'Error', message: string | null | undefined }> | null | undefined } | null | undefined };

export type VideoWatchCompletedMutationVariables = Exact<{
  videoId: Scalars['String'];
  seconds: Scalars['Int'];
  cursorAt: Scalars['Int'];
}>;


export type VideoWatchCompletedMutation = { __typename?: 'Mutation', videoWatchCompleted: { __typename?: 'WatchCompletedPayload', errors: Array<{ __typename?: 'Error', message: string | null | undefined }> | null | undefined } | null | undefined };

export type UserStatsQueryVariables = Exact<{
  period: InputMaybe<StatsPeriodKind>;
}>;


export type UserStatsQuery = { __typename?: 'Query', userStats: { __typename?: 'Stats', numberOfChallengesStarted: number, numberOfCoursesStarted: number, numberOfLiveEventsBooked: number, numberOfProgramsStarted: number, playlistsCreated: number, sessionsCompleted: number, sessionsFavorited: number | null | undefined, totalWatchTime: number | null | undefined, threeMostWatchedInstructors: Array<{ __typename?: 'Instructor', id: string, name: string | null | undefined, assets: { __typename?: 'InstructorAssets', squareImage: string | null | undefined } | null | undefined }>, threeMostWatchedStyles: Array<{ __typename?: 'Term', slug: string | null | undefined, name: string | null | undefined }> } };

export type ActivateFullAccessCodeMutationVariables = Exact<{
  promotionName: Scalars['String'];
  code: Scalars['String'];
}>;


export type ActivateFullAccessCodeMutation = { __typename?: 'Mutation', activateFullAccessCode: { __typename?: 'ActivateFullAccessCodePayload', success: boolean | null | undefined, errors: Array<{ __typename?: 'Error', message: string | null | undefined }> | null | undefined } | null | undefined };

export type ActivateOneTimeCodeMutationVariables = Exact<{
  promotionName: Scalars['String'];
  code: Scalars['String'];
}>;


export type ActivateOneTimeCodeMutation = { __typename?: 'Mutation', activateOneTimeCode: { __typename?: 'ActivateOneTimeCodePayload', success: boolean | null | undefined, errors: Array<{ __typename?: 'Error', message: string | null | undefined }> | null | undefined } | null | undefined };

export type PaymentsStoreAdyenDropinMutationVariables = Exact<{
  redirectTo: InputMaybe<Scalars['String']>;
  paymentType: Scalars['String'];
  riskData: InputMaybe<RiskDataInput>;
  paymentMethod: PaymentMethodInput;
  storePaymentMethod: InputMaybe<Scalars['Boolean']>;
  browserInfo: InputMaybe<BrowserInfoInput>;
}>;


export type PaymentsStoreAdyenDropinMutation = { __typename?: 'Mutation', paymentsStoreAdyenDropin: { __typename?: 'StoreAdyenDropinPayload', orderId: string | null | undefined, transaction: string | null | undefined, recurringDate: string | null | undefined, recurringPaymentAmount: string | null | undefined, resultCode: string | null | undefined, resultAction: { __typename?: 'AdyenAction', actionType: string, url: string | null | undefined, httpMethod: string | null | undefined, paymentMethodType: string, paymentData: string, redirectData: string | null | undefined } | null | undefined, errors: Array<{ __typename?: 'Error', message: string | null | undefined }> | null | undefined } | null | undefined };

export type PaymentsStoreTrustlyMutationVariables = Exact<{
  paymentType: Scalars['String'];
  redirectTo: InputMaybe<Scalars['String']>;
}>;


export type PaymentsStoreTrustlyMutation = { __typename?: 'Mutation', paymentsStoreTrustly: { __typename?: 'StoreTrustlyPayload', resultUrl: string | null | undefined, recurringPaymentAmount: string | null | undefined, recurringPaymentCurrency: string | null | undefined, recurringDate: string | null | undefined, transaction: string | null | undefined, orderId: string | null | undefined, errors: Array<{ __typename?: 'Error', path: Array<string> | null | undefined, message: string | null | undefined }> | null | undefined } | null | undefined };

export type SurveyQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type SurveyQuery = { __typename?: 'Query', survey: { __typename?: 'Survey', id: string, name: string, description: string | null | undefined, content: { __typename?: 'SurveyContent', page1Description: string | null | undefined, page1Title: string | null | undefined, page2Description: string | null | undefined, page2Title: string | null | undefined, page3ButtonUrl: string | null | undefined, page3ButtonText: string | null | undefined, page3Description: string | null | undefined, page3Title: string | null | undefined }, questions: Array<{ __typename?: 'SurveyQuestion', id: string, question: string | null | undefined, answers: Array<string> | null | undefined, options: { __typename?: 'SurveyOptions', default: string | null | undefined, hint: string | null | undefined, leftLabel: string | null | undefined, maxValue: number | null | undefined, minValue: number | null | undefined, required: boolean, rightLabel: string | null | undefined, useForNps: boolean | null | undefined, type: SurveyTypeKind } | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type GetSurveyQueryVariables = Exact<{
  surveyPartId: Scalars['Int'];
}>;


export type GetSurveyQuery = { __typename?: 'Query', surveyPart: { __typename?: 'ProgramSurveyElement', id: string, slug: string, subheader: string | null | undefined, title: string | null | undefined, description: string | null | undefined, locked: boolean, finished: boolean | null | undefined, position: number, positionLabel: string, progressIsCurrent: boolean, lastSubmittedAt: any | null | undefined, surveysAnswer: { __typename?: 'SurveyAnswer', id: string, state: State | null | undefined, contextableType: string | null | undefined, content: Array<{ __typename?: 'ContentAnswer', key: string, value: Array<string> }> } | null | undefined, survey: { __typename?: 'Survey', id: string, name: string, description: string | null | undefined, content: { __typename?: 'SurveyContent', page1Description: string | null | undefined, page1Title: string | null | undefined, page2Description: string | null | undefined, page2Title: string | null | undefined, page3ButtonUrl: string | null | undefined, page3ButtonText: string | null | undefined, page3Description: string | null | undefined, page3Title: string | null | undefined }, questions: Array<{ __typename?: 'SurveyQuestion', id: string, question: string | null | undefined, answers: Array<string> | null | undefined, options: { __typename?: 'SurveyOptions', default: string | null | undefined, hint: string | null | undefined, leftLabel: string | null | undefined, maxValue: number | null | undefined, minValue: number | null | undefined, required: boolean, rightLabel: string | null | undefined, useForNps: boolean | null | undefined, type: SurveyTypeKind } | null | undefined } | null | undefined> | null | undefined } } | null | undefined };

export type UserPlaylistsQueryVariables = Exact<{
  id: InputMaybe<Scalars['ID']>;
  page: InputMaybe<Scalars['Int']>;
  perPage: InputMaybe<Scalars['Int']>;
}>;


export type UserPlaylistsQuery = { __typename?: 'Query', userPlaylists: { __typename?: 'PagedPlaylists', page: number, perPage: number, totalCount: number, data: Array<{ __typename?: 'Playlist', id: string, identifier: string | null | undefined, title: string, visibility: string | null | undefined, description: string | null | undefined, owner: { __typename?: 'User', id: string, firstName: string | null | undefined } | { __typename?: 'CurrentUser', id: string, firstName: string | null | undefined } | null | undefined, meta: { __typename?: 'Meta', videoCount: number | null | undefined, minutes: number | null | undefined } | null | undefined, assets: { __typename?: 'PlaylistAssets', thumbnailUrl: string | null | undefined } | null | undefined, videos: Array<{ __typename?: 'Video', id: string } | null | undefined> | null | undefined }> } | null | undefined };

export type RemoveVideoFromPlaylistMutationVariables = Exact<{
  playlistId: Scalars['ID'];
  videoId: Scalars['ID'];
}>;


export type RemoveVideoFromPlaylistMutation = { __typename?: 'Mutation', removeVideoFromPlaylist: { __typename?: 'RemoveVideoFromPlaylistPayload', playlist: { __typename?: 'Playlist', id: string } | null | undefined } | null | undefined };

export type AddVideoToPlaylistMutationVariables = Exact<{
  playlistId: Scalars['ID'];
  videoId: Scalars['ID'];
}>;


export type AddVideoToPlaylistMutation = { __typename?: 'Mutation', addVideoToPlaylist: { __typename?: 'AddVideoToPlaylistPayload', playlist: { __typename?: 'Playlist', id: string } | null | undefined } | null | undefined };

export type DeleteFavoriteVideoMutationVariables = Exact<{
  videoId: Scalars['ID'];
}>;


export type DeleteFavoriteVideoMutation = { __typename?: 'Mutation', deleteFavoriteVideo: { __typename?: 'DeleteFavoriteVideoPayload', video: { __typename?: 'Video', favorited: boolean } | null | undefined } | null | undefined };

export type AddFavoriteVideoMutationVariables = Exact<{
  videoId: Scalars['ID'];
}>;


export type AddFavoriteVideoMutation = { __typename?: 'Mutation', addFavoriteVideo: { __typename?: 'AddFavoriteVideoPayload', video: { __typename?: 'Video', favorited: boolean } | null | undefined } | null | undefined };

export type TaxonomiesQueryVariables = Exact<{
  genre: InputMaybe<Scalars['String']>;
  languages: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type TaxonomiesQuery = { __typename?: 'Query', taxonomies: Array<{ __typename?: 'TaxonomyItem', id: string, name: string | null | undefined, slug: string | null | undefined, terms: Array<{ __typename?: 'Term', id: string, name: string | null | undefined, slug: string | null | undefined, important: boolean | null | undefined }> | null | undefined } | null | undefined> | null | undefined };

export type VideoQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type VideoQuery = { __typename?: 'Query', video: { __typename?: 'Video', id: string, kind: string, hls: string, identifier: string, hasAccess: boolean, cursorAt: number | null | undefined, categories: Array<string>, player: { __typename?: 'VideoInfo', assets: Array<{ __typename?: 'VideoFileAsset', src: string | null | undefined, resolution: number | null | undefined } | null | undefined> | null | undefined } | null | undefined, crossPromotion: Array<{ __typename?: 'GenericProgram', id: string, slug: string, title: string | null | undefined, category: ProgramCategory, description: string | null | undefined, titleImageUrl: string | null | undefined }> | null | undefined, assets: { __typename?: 'VideoAssets', thumbnailUrl: string | null | undefined, thumbnailUrlMedium: string | null | undefined } | null | undefined, primaryStyle: { __typename?: 'Term', name: string | null | undefined, slug: string | null | undefined } | null | undefined, taxonomies: { __typename?: 'Taxonomy', flavor: { __typename?: 'Term', id: string, name: string | null | undefined } | null | undefined, needs: Array<{ __typename?: 'Term', id: string, name: string | null | undefined } | null | undefined> | null | undefined, instructors: Array<{ __typename?: 'Instructor', id: string, name: string | null | undefined, slug: string | null | undefined, shortDescription: string | null | undefined, assets: { __typename?: 'InstructorAssets', squareImage: string | null | undefined } | null | undefined } | null | undefined> | null | undefined, genre: { __typename?: 'Term', id: string, name: string | null | undefined, slug: string | null | undefined } | null | undefined }, meta: { __typename?: 'VideoMeta', minutes: number | null | undefined } | null | undefined, content: { __typename?: 'VideoContent', title: string | null | undefined, shortDescription: string | null | undefined, longDescription: string | null | undefined } | null | undefined } | null | undefined };

export type InstructorByGenreQueryVariables = Exact<{
  genre: InputMaybe<Scalars['String']>;
  instructor: Scalars['String'];
  languages: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type InstructorByGenreQuery = { __typename?: 'Query', instructorByGenre: { __typename?: 'InstructorInGenre', instructor: { __typename?: 'Instructor', id: string, name: string | null | undefined, assets: { __typename?: 'InstructorAssets', squareImage: string | null | undefined } | null | undefined } | null | undefined, videosCountInGenres: Array<{ __typename?: 'VideosCountByGenre', channel: string | null | undefined, slug: string | null | undefined, count: number | null | undefined } | null | undefined> | null | undefined } };

export type ProgramDocumentFieldsFragment = { __typename?: 'ProgramDocument', id: string, slug: string, title: string | null | undefined, subheader: string | null | undefined, description: string | null | undefined, finished: boolean | null | undefined, kind: string | null | undefined, locked: boolean, position: number, positionLabel: string, progressIsCurrent: boolean, document: { __typename?: 'Document', url: string | null | undefined, name: string } };

export type ProgramVideoFieldsFragment = { __typename?: 'ProgramVideo', id: string, slug: string, title: string | null | undefined, subheader: string | null | undefined, customTitle: string | null | undefined, locked: boolean, watched: boolean | null | undefined, finished: boolean | null | undefined, position: number, positionLabel: string, videoKind: VideoKind | null | undefined, progressIsCurrent: boolean, repeatRecomendation: number | null | undefined, customDescription: string | null | undefined, preMoodTracker: { __typename?: 'MoodTracker', id: string, finished: boolean | null | undefined, kind: MoodTrackerKind } | null | undefined, postMoodTracker: { __typename?: 'MoodTracker', id: string, finished: boolean | null | undefined, kind: MoodTrackerKind } | null | undefined, video: { __typename?: 'Video', id: string, title: string, kind: string, identifier: string, hasAccess: boolean, cursorAt: number | null | undefined, hls: string, content: { __typename?: 'VideoContent', title: string | null | undefined, shortDescription: string | null | undefined, longDescription: string | null | undefined } | null | undefined, player: { __typename?: 'VideoInfo', assets: Array<{ __typename?: 'VideoFileAsset', src: string | null | undefined, size: number | null | undefined, resolution: number | null | undefined } | null | undefined> | null | undefined } | null | undefined, meta: { __typename?: 'VideoMeta', publishedAt: number | null | undefined, minutes: number | null | undefined } | null | undefined, taxonomies: { __typename?: 'Taxonomy', flavor: { __typename?: 'Term', name: string | null | undefined } | null | undefined, instructors: Array<{ __typename?: 'Instructor', name: string | null | undefined, slug: string | null | undefined } | null | undefined> | null | undefined, genre: { __typename?: 'Term', name: string | null | undefined, slug: string | null | undefined } | null | undefined }, assets: { __typename?: 'VideoAssets', thumbnailUrl: string | null | undefined } | null | undefined } };

export type ProgramSurveyFieldsFragment = { __typename?: 'Survey', id: string, name: string, description: string | null | undefined, content: { __typename?: 'SurveyContent', page1Description: string | null | undefined, page1Title: string | null | undefined, page2Description: string | null | undefined, page2Title: string | null | undefined, page3ButtonUrl: string | null | undefined, page3ButtonText: string | null | undefined, page3Description: string | null | undefined, page3Title: string | null | undefined }, questions: Array<{ __typename?: 'SurveyQuestion', id: string, question: string | null | undefined, answers: Array<string> | null | undefined, options: { __typename?: 'SurveyOptions', default: string | null | undefined, hint: string | null | undefined, leftLabel: string | null | undefined, maxValue: number | null | undefined, minValue: number | null | undefined, required: boolean, rightLabel: string | null | undefined, useForNps: boolean | null | undefined, type: SurveyTypeKind } | null | undefined } | null | undefined> | null | undefined };

export type ProgramTextElementFieldsFragment = { __typename?: 'ProgramPartElement', id: string, slug: string, subheader: string | null | undefined, title: string | null | undefined, description: string | null | undefined, locked: boolean, finished: boolean | null | undefined, position: number, positionLabel: string, progressIsCurrent: boolean };

export type ProgramSurveyElementFieldsFragment = { __typename?: 'ProgramSurveyElement', id: string, slug: string, subheader: string | null | undefined, title: string | null | undefined, description: string | null | undefined, locked: boolean, finished: boolean | null | undefined, position: number, positionLabel: string, progressIsCurrent: boolean, lastSubmittedAt: any | null | undefined, surveysAnswer: { __typename?: 'SurveyAnswer', id: string, state: State | null | undefined, contextableType: string | null | undefined, content: Array<{ __typename?: 'ContentAnswer', key: string, value: Array<string> }> } | null | undefined, survey: { __typename?: 'Survey', id: string, name: string, description: string | null | undefined, content: { __typename?: 'SurveyContent', page1Description: string | null | undefined, page1Title: string | null | undefined, page2Description: string | null | undefined, page2Title: string | null | undefined, page3ButtonUrl: string | null | undefined, page3ButtonText: string | null | undefined, page3Description: string | null | undefined, page3Title: string | null | undefined }, questions: Array<{ __typename?: 'SurveyQuestion', id: string, question: string | null | undefined, answers: Array<string> | null | undefined, options: { __typename?: 'SurveyOptions', default: string | null | undefined, hint: string | null | undefined, leftLabel: string | null | undefined, maxValue: number | null | undefined, minValue: number | null | undefined, required: boolean, rightLabel: string | null | undefined, useForNps: boolean | null | undefined, type: SurveyTypeKind } | null | undefined } | null | undefined> | null | undefined } };

export type WeeklyProgramWeekFragmentFragment = { __typename?: 'ProgramWeek', id: string, label: string, slug: string, locked: boolean, finished: boolean | null | undefined, progress: number | null | undefined, description: string | null | undefined, duration: string | null | undefined, videosCount: number | null | undefined, elements: Array<{ __typename: 'ProgramDocument', id: string, slug: string, title: string | null | undefined, subheader: string | null | undefined, description: string | null | undefined, finished: boolean | null | undefined, kind: string | null | undefined, locked: boolean, position: number, positionLabel: string, progressIsCurrent: boolean, document: { __typename?: 'Document', url: string | null | undefined, name: string } } | { __typename: 'ProgramPartElement', id: string, slug: string, subheader: string | null | undefined, title: string | null | undefined, description: string | null | undefined, locked: boolean, finished: boolean | null | undefined, position: number, positionLabel: string, progressIsCurrent: boolean } | { __typename: 'ProgramSurveyElement', id: string, slug: string, subheader: string | null | undefined, title: string | null | undefined, description: string | null | undefined, locked: boolean, finished: boolean | null | undefined, position: number, positionLabel: string, progressIsCurrent: boolean, lastSubmittedAt: any | null | undefined, surveysAnswer: { __typename?: 'SurveyAnswer', id: string, state: State | null | undefined, contextableType: string | null | undefined, content: Array<{ __typename?: 'ContentAnswer', key: string, value: Array<string> }> } | null | undefined, survey: { __typename?: 'Survey', id: string, name: string, description: string | null | undefined, content: { __typename?: 'SurveyContent', page1Description: string | null | undefined, page1Title: string | null | undefined, page2Description: string | null | undefined, page2Title: string | null | undefined, page3ButtonUrl: string | null | undefined, page3ButtonText: string | null | undefined, page3Description: string | null | undefined, page3Title: string | null | undefined }, questions: Array<{ __typename?: 'SurveyQuestion', id: string, question: string | null | undefined, answers: Array<string> | null | undefined, options: { __typename?: 'SurveyOptions', default: string | null | undefined, hint: string | null | undefined, leftLabel: string | null | undefined, maxValue: number | null | undefined, minValue: number | null | undefined, required: boolean, rightLabel: string | null | undefined, useForNps: boolean | null | undefined, type: SurveyTypeKind } | null | undefined } | null | undefined> | null | undefined } } | { __typename: 'ProgramVideo', id: string, slug: string, title: string | null | undefined, subheader: string | null | undefined, customTitle: string | null | undefined, locked: boolean, watched: boolean | null | undefined, finished: boolean | null | undefined, position: number, positionLabel: string, videoKind: VideoKind | null | undefined, progressIsCurrent: boolean, repeatRecomendation: number | null | undefined, customDescription: string | null | undefined, preMoodTracker: { __typename?: 'MoodTracker', id: string, finished: boolean | null | undefined, kind: MoodTrackerKind } | null | undefined, postMoodTracker: { __typename?: 'MoodTracker', id: string, finished: boolean | null | undefined, kind: MoodTrackerKind } | null | undefined, video: { __typename?: 'Video', id: string, title: string, kind: string, identifier: string, hasAccess: boolean, cursorAt: number | null | undefined, hls: string, content: { __typename?: 'VideoContent', title: string | null | undefined, shortDescription: string | null | undefined, longDescription: string | null | undefined } | null | undefined, player: { __typename?: 'VideoInfo', assets: Array<{ __typename?: 'VideoFileAsset', src: string | null | undefined, size: number | null | undefined, resolution: number | null | undefined } | null | undefined> | null | undefined } | null | undefined, meta: { __typename?: 'VideoMeta', publishedAt: number | null | undefined, minutes: number | null | undefined } | null | undefined, taxonomies: { __typename?: 'Taxonomy', flavor: { __typename?: 'Term', name: string | null | undefined } | null | undefined, instructors: Array<{ __typename?: 'Instructor', name: string | null | undefined, slug: string | null | undefined } | null | undefined> | null | undefined, genre: { __typename?: 'Term', name: string | null | undefined, slug: string | null | undefined } | null | undefined }, assets: { __typename?: 'VideoAssets', thumbnailUrl: string | null | undefined } | null | undefined } }> };

export type WeeklyProgramFieldsFragment = { __typename?: 'WeeklyProgram', id: string, slug: string, recomendation: string | null | undefined, progress: number | null | undefined, videosCount: number | null | undefined, currentElement: { __typename?: 'CurrentElement', path: string | null | undefined, title: string | null | undefined } | null | undefined, instructors: Array<{ __typename?: 'Instructor', id: string, name: string | null | undefined, slug: string | null | undefined, assets: { __typename?: 'InstructorAssets', squareImage: string | null | undefined } | null | undefined } | null | undefined> | null | undefined, intro: { __typename?: 'SpecialSection', description: string | null | undefined, label: string, assetUrl: string | null | undefined, slug: string } | null | undefined, outro: { __typename?: 'SpecialSection', description: string | null | undefined, label: string, slug: string, videos: Array<{ __typename?: 'ProgramVideo', id: string, slug: string, title: string | null | undefined, subheader: string | null | undefined, customTitle: string | null | undefined, locked: boolean, watched: boolean | null | undefined, finished: boolean | null | undefined, position: number, positionLabel: string, videoKind: VideoKind | null | undefined, progressIsCurrent: boolean, repeatRecomendation: number | null | undefined, customDescription: string | null | undefined, preMoodTracker: { __typename?: 'MoodTracker', id: string, finished: boolean | null | undefined, kind: MoodTrackerKind } | null | undefined, postMoodTracker: { __typename?: 'MoodTracker', id: string, finished: boolean | null | undefined, kind: MoodTrackerKind } | null | undefined, video: { __typename?: 'Video', id: string, title: string, kind: string, identifier: string, hasAccess: boolean, cursorAt: number | null | undefined, hls: string, content: { __typename?: 'VideoContent', title: string | null | undefined, shortDescription: string | null | undefined, longDescription: string | null | undefined } | null | undefined, player: { __typename?: 'VideoInfo', assets: Array<{ __typename?: 'VideoFileAsset', src: string | null | undefined, size: number | null | undefined, resolution: number | null | undefined } | null | undefined> | null | undefined } | null | undefined, meta: { __typename?: 'VideoMeta', publishedAt: number | null | undefined, minutes: number | null | undefined } | null | undefined, taxonomies: { __typename?: 'Taxonomy', flavor: { __typename?: 'Term', name: string | null | undefined } | null | undefined, instructors: Array<{ __typename?: 'Instructor', name: string | null | undefined, slug: string | null | undefined } | null | undefined> | null | undefined, genre: { __typename?: 'Term', name: string | null | undefined, slug: string | null | undefined } | null | undefined }, assets: { __typename?: 'VideoAssets', thumbnailUrl: string | null | undefined } | null | undefined } } | null | undefined> | null | undefined } | null | undefined, weeks: Array<{ __typename?: 'ProgramWeek', id: string, label: string, slug: string, locked: boolean, finished: boolean | null | undefined, progress: number | null | undefined, description: string | null | undefined, duration: string | null | undefined, videosCount: number | null | undefined, elements: Array<{ __typename: 'ProgramDocument', id: string, slug: string, title: string | null | undefined, subheader: string | null | undefined, description: string | null | undefined, finished: boolean | null | undefined, kind: string | null | undefined, locked: boolean, position: number, positionLabel: string, progressIsCurrent: boolean, document: { __typename?: 'Document', url: string | null | undefined, name: string } } | { __typename: 'ProgramPartElement', id: string, slug: string, subheader: string | null | undefined, title: string | null | undefined, description: string | null | undefined, locked: boolean, finished: boolean | null | undefined, position: number, positionLabel: string, progressIsCurrent: boolean } | { __typename: 'ProgramSurveyElement', id: string, slug: string, subheader: string | null | undefined, title: string | null | undefined, description: string | null | undefined, locked: boolean, finished: boolean | null | undefined, position: number, positionLabel: string, progressIsCurrent: boolean, lastSubmittedAt: any | null | undefined, surveysAnswer: { __typename?: 'SurveyAnswer', id: string, state: State | null | undefined, contextableType: string | null | undefined, content: Array<{ __typename?: 'ContentAnswer', key: string, value: Array<string> }> } | null | undefined, survey: { __typename?: 'Survey', id: string, name: string, description: string | null | undefined, content: { __typename?: 'SurveyContent', page1Description: string | null | undefined, page1Title: string | null | undefined, page2Description: string | null | undefined, page2Title: string | null | undefined, page3ButtonUrl: string | null | undefined, page3ButtonText: string | null | undefined, page3Description: string | null | undefined, page3Title: string | null | undefined }, questions: Array<{ __typename?: 'SurveyQuestion', id: string, question: string | null | undefined, answers: Array<string> | null | undefined, options: { __typename?: 'SurveyOptions', default: string | null | undefined, hint: string | null | undefined, leftLabel: string | null | undefined, maxValue: number | null | undefined, minValue: number | null | undefined, required: boolean, rightLabel: string | null | undefined, useForNps: boolean | null | undefined, type: SurveyTypeKind } | null | undefined } | null | undefined> | null | undefined } } | { __typename: 'ProgramVideo', id: string, slug: string, title: string | null | undefined, subheader: string | null | undefined, customTitle: string | null | undefined, locked: boolean, watched: boolean | null | undefined, finished: boolean | null | undefined, position: number, positionLabel: string, videoKind: VideoKind | null | undefined, progressIsCurrent: boolean, repeatRecomendation: number | null | undefined, customDescription: string | null | undefined, preMoodTracker: { __typename?: 'MoodTracker', id: string, finished: boolean | null | undefined, kind: MoodTrackerKind } | null | undefined, postMoodTracker: { __typename?: 'MoodTracker', id: string, finished: boolean | null | undefined, kind: MoodTrackerKind } | null | undefined, video: { __typename?: 'Video', id: string, title: string, kind: string, identifier: string, hasAccess: boolean, cursorAt: number | null | undefined, hls: string, content: { __typename?: 'VideoContent', title: string | null | undefined, shortDescription: string | null | undefined, longDescription: string | null | undefined } | null | undefined, player: { __typename?: 'VideoInfo', assets: Array<{ __typename?: 'VideoFileAsset', src: string | null | undefined, size: number | null | undefined, resolution: number | null | undefined } | null | undefined> | null | undefined } | null | undefined, meta: { __typename?: 'VideoMeta', publishedAt: number | null | undefined, minutes: number | null | undefined } | null | undefined, taxonomies: { __typename?: 'Taxonomy', flavor: { __typename?: 'Term', name: string | null | undefined } | null | undefined, instructors: Array<{ __typename?: 'Instructor', name: string | null | undefined, slug: string | null | undefined } | null | undefined> | null | undefined, genre: { __typename?: 'Term', name: string | null | undefined, slug: string | null | undefined } | null | undefined }, assets: { __typename?: 'VideoAssets', thumbnailUrl: string | null | undefined } | null | undefined } }> } | null | undefined> | null | undefined };

export type WeeklyProgramQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type WeeklyProgramQuery = { __typename?: 'Query', weeklyProgram: { __typename?: 'WeeklyProgram', id: string, slug: string, recomendation: string | null | undefined, progress: number | null | undefined, videosCount: number | null | undefined, currentElement: { __typename?: 'CurrentElement', path: string | null | undefined, title: string | null | undefined } | null | undefined, instructors: Array<{ __typename?: 'Instructor', id: string, name: string | null | undefined, slug: string | null | undefined, assets: { __typename?: 'InstructorAssets', squareImage: string | null | undefined } | null | undefined } | null | undefined> | null | undefined, intro: { __typename?: 'SpecialSection', description: string | null | undefined, label: string, assetUrl: string | null | undefined, slug: string } | null | undefined, outro: { __typename?: 'SpecialSection', description: string | null | undefined, label: string, slug: string, videos: Array<{ __typename?: 'ProgramVideo', id: string, slug: string, title: string | null | undefined, subheader: string | null | undefined, customTitle: string | null | undefined, locked: boolean, watched: boolean | null | undefined, finished: boolean | null | undefined, position: number, positionLabel: string, videoKind: VideoKind | null | undefined, progressIsCurrent: boolean, repeatRecomendation: number | null | undefined, customDescription: string | null | undefined, preMoodTracker: { __typename?: 'MoodTracker', id: string, finished: boolean | null | undefined, kind: MoodTrackerKind } | null | undefined, postMoodTracker: { __typename?: 'MoodTracker', id: string, finished: boolean | null | undefined, kind: MoodTrackerKind } | null | undefined, video: { __typename?: 'Video', id: string, title: string, kind: string, identifier: string, hasAccess: boolean, cursorAt: number | null | undefined, hls: string, content: { __typename?: 'VideoContent', title: string | null | undefined, shortDescription: string | null | undefined, longDescription: string | null | undefined } | null | undefined, player: { __typename?: 'VideoInfo', assets: Array<{ __typename?: 'VideoFileAsset', src: string | null | undefined, size: number | null | undefined, resolution: number | null | undefined } | null | undefined> | null | undefined } | null | undefined, meta: { __typename?: 'VideoMeta', publishedAt: number | null | undefined, minutes: number | null | undefined } | null | undefined, taxonomies: { __typename?: 'Taxonomy', flavor: { __typename?: 'Term', name: string | null | undefined } | null | undefined, instructors: Array<{ __typename?: 'Instructor', name: string | null | undefined, slug: string | null | undefined } | null | undefined> | null | undefined, genre: { __typename?: 'Term', name: string | null | undefined, slug: string | null | undefined } | null | undefined }, assets: { __typename?: 'VideoAssets', thumbnailUrl: string | null | undefined } | null | undefined } } | null | undefined> | null | undefined } | null | undefined, weeks: Array<{ __typename?: 'ProgramWeek', id: string, label: string, slug: string, locked: boolean, finished: boolean | null | undefined, progress: number | null | undefined, description: string | null | undefined, duration: string | null | undefined, videosCount: number | null | undefined, elements: Array<{ __typename: 'ProgramDocument', id: string, slug: string, title: string | null | undefined, subheader: string | null | undefined, description: string | null | undefined, finished: boolean | null | undefined, kind: string | null | undefined, locked: boolean, position: number, positionLabel: string, progressIsCurrent: boolean, document: { __typename?: 'Document', url: string | null | undefined, name: string } } | { __typename: 'ProgramPartElement', id: string, slug: string, subheader: string | null | undefined, title: string | null | undefined, description: string | null | undefined, locked: boolean, finished: boolean | null | undefined, position: number, positionLabel: string, progressIsCurrent: boolean } | { __typename: 'ProgramSurveyElement', id: string, slug: string, subheader: string | null | undefined, title: string | null | undefined, description: string | null | undefined, locked: boolean, finished: boolean | null | undefined, position: number, positionLabel: string, progressIsCurrent: boolean, lastSubmittedAt: any | null | undefined, surveysAnswer: { __typename?: 'SurveyAnswer', id: string, state: State | null | undefined, contextableType: string | null | undefined, content: Array<{ __typename?: 'ContentAnswer', key: string, value: Array<string> }> } | null | undefined, survey: { __typename?: 'Survey', id: string, name: string, description: string | null | undefined, content: { __typename?: 'SurveyContent', page1Description: string | null | undefined, page1Title: string | null | undefined, page2Description: string | null | undefined, page2Title: string | null | undefined, page3ButtonUrl: string | null | undefined, page3ButtonText: string | null | undefined, page3Description: string | null | undefined, page3Title: string | null | undefined }, questions: Array<{ __typename?: 'SurveyQuestion', id: string, question: string | null | undefined, answers: Array<string> | null | undefined, options: { __typename?: 'SurveyOptions', default: string | null | undefined, hint: string | null | undefined, leftLabel: string | null | undefined, maxValue: number | null | undefined, minValue: number | null | undefined, required: boolean, rightLabel: string | null | undefined, useForNps: boolean | null | undefined, type: SurveyTypeKind } | null | undefined } | null | undefined> | null | undefined } } | { __typename: 'ProgramVideo', id: string, slug: string, title: string | null | undefined, subheader: string | null | undefined, customTitle: string | null | undefined, locked: boolean, watched: boolean | null | undefined, finished: boolean | null | undefined, position: number, positionLabel: string, videoKind: VideoKind | null | undefined, progressIsCurrent: boolean, repeatRecomendation: number | null | undefined, customDescription: string | null | undefined, preMoodTracker: { __typename?: 'MoodTracker', id: string, finished: boolean | null | undefined, kind: MoodTrackerKind } | null | undefined, postMoodTracker: { __typename?: 'MoodTracker', id: string, finished: boolean | null | undefined, kind: MoodTrackerKind } | null | undefined, video: { __typename?: 'Video', id: string, title: string, kind: string, identifier: string, hasAccess: boolean, cursorAt: number | null | undefined, hls: string, content: { __typename?: 'VideoContent', title: string | null | undefined, shortDescription: string | null | undefined, longDescription: string | null | undefined } | null | undefined, player: { __typename?: 'VideoInfo', assets: Array<{ __typename?: 'VideoFileAsset', src: string | null | undefined, size: number | null | undefined, resolution: number | null | undefined } | null | undefined> | null | undefined } | null | undefined, meta: { __typename?: 'VideoMeta', publishedAt: number | null | undefined, minutes: number | null | undefined } | null | undefined, taxonomies: { __typename?: 'Taxonomy', flavor: { __typename?: 'Term', name: string | null | undefined } | null | undefined, instructors: Array<{ __typename?: 'Instructor', name: string | null | undefined, slug: string | null | undefined } | null | undefined> | null | undefined, genre: { __typename?: 'Term', name: string | null | undefined, slug: string | null | undefined } | null | undefined }, assets: { __typename?: 'VideoAssets', thumbnailUrl: string | null | undefined } | null | undefined } }> } | null | undefined> | null | undefined } | null | undefined };

export type YearlyPageQueryVariables = Exact<{ [key: string]: never; }>;


export type YearlyPageQuery = { __typename?: 'Query', startOverview: { __typename?: 'StartOverview', featuresSection: { __typename?: 'FeaturesSection', description: string | null | undefined, featureBullets: Array<string> | null | undefined, imageUrl: string | null | undefined, title: string | null | undefined } | null | undefined } };

export type AnswerSurveyMutationVariables = Exact<{
  surveyPartId: Scalars['ID'];
  surveyAnswerId: InputMaybe<Scalars['ID']>;
  answers: InputMaybe<Array<AnswerInput> | AnswerInput>;
  surveyAction: ActionInput;
}>;


export type AnswerSurveyMutation = { __typename?: 'Mutation', answerSurvey: { __typename?: 'AnswerSurveyPayload', errors: Array<{ __typename?: 'ProcessingError', message: string | null | undefined, status: ErrorValue | null | undefined }> } | null | undefined };

export type GetFavoritePlaylistsQueryVariables = Exact<{
  id: Scalars['ID'];
  page: InputMaybe<Scalars['Int']>;
  perPage: InputMaybe<Scalars['Int']>;
}>;


export type GetFavoritePlaylistsQuery = { __typename?: 'Query', getFavoritePlaylists: { __typename?: 'PagedPlaylists', totalCount: number, perPage: number, page: number, data: Array<{ __typename?: 'Playlist', id: string, identifier: string | null | undefined, title: string, description: string | null | undefined, owner: { __typename?: 'User', id: string, firstName: string | null | undefined } | { __typename?: 'CurrentUser', id: string, firstName: string | null | undefined } | null | undefined, meta: { __typename?: 'Meta', videoCount: number | null | undefined, minutes: number | null | undefined } | null | undefined, assets: { __typename?: 'PlaylistAssets', thumbnailUrl: string | null | undefined } | null | undefined }> } | null | undefined };

export type GetFavoriteVideosQueryVariables = Exact<{
  id: Scalars['ID'];
  page: InputMaybe<Scalars['Int']>;
  perPage: InputMaybe<Scalars['Int']>;
}>;


export type GetFavoriteVideosQuery = { __typename?: 'Query', getFavoriteVideos: { __typename?: 'PagedVideos', totalCount: number, perPage: number, page: number, data: Array<{ __typename?: 'Video', id: string, identifier: string, cursorAt: number | null | undefined, content: { __typename?: 'VideoContent', title: string | null | undefined, shortDescription: string | null | undefined } | null | undefined, meta: { __typename?: 'VideoMeta', minutes: number | null | undefined, publishedAt: number | null | undefined } | null | undefined, taxonomies: { __typename?: 'Taxonomy', flavor: { __typename?: 'Term', name: string | null | undefined } | null | undefined, instructors: Array<{ __typename?: 'Instructor', id: string, name: string | null | undefined, slug: string | null | undefined } | null | undefined> | null | undefined, genre: { __typename?: 'Term', id: string, name: string | null | undefined, slug: string | null | undefined } | null | undefined }, assets: { __typename?: 'VideoAssets', thumbnailUrl: string | null | undefined } | null | undefined }> } | null | undefined };

export type ReclaimTrialMutationVariables = Exact<{
  code: Scalars['String'];
  source: Scalars['String'];
}>;


export type ReclaimTrialMutation = { __typename?: 'Mutation', reclaimTrial: { __typename?: 'ReclaimTrialPayload', errors: string | null | undefined, success: boolean } | null | undefined };

export type StoreUserDecisionMutationVariables = Exact<{
  decision: UserDecisionKind;
  value: InputMaybe<Scalars['Boolean']>;
}>;


export type StoreUserDecisionMutation = { __typename?: 'Mutation', storeUserDecision: { __typename?: 'StoreUserDecisionPayload', user: { __typename?: 'User', id: string } } | null | undefined };

export const PricingSubscriptionFieldsFragmentDoc = gql`
    fragment PricingSubscriptionFields on UserSubscription {
  title
  description
  shortDescription
  amount
  discountedAmount
  currency
  months
  days
  subscriptionName
  subscriptionPlan
  promotionKind
  promotionName
  recurringPromotion
}
    `;
export const BundleEssentialFieldsFragmentDoc = gql`
    fragment BundleEssentialFields on Bundle {
  id
  title
  slug
  heroImage
  heroMobileImage
  active
  kind
  accessStrategy
  isUserEligible
  bundleCategory
  userAccess {
    active
    accessUntil
  }
  client {
    id
    logo
    name
    slug
  }
  hiddenInListing
  metaDescription
  metaImage
  publishedAt
  shortDescription
  promotionalImage
  tags
}
    `;
export const BlogPostFieldsFragmentDoc = gql`
    fragment BlogPostFields on BlogPost {
  id
  slug
  tags
  title
  body
  authors
  categories
  featuredImage
  language
  market
  publishedAt
}
    `;
export const ProgramInstructorsFragmentDoc = gql`
    fragment ProgramInstructors on Instructor {
  id
  name
  slug
  assets {
    squareImage
  }
}
    `;
export const EssentialGenericFieldsFragmentDoc = gql`
    fragment EssentialGenericFields on GenericProgram {
  id
  title
  slug
  promotionalImageUrl
  category
  priceType
  kind
  language
  titleImageUrl
  shortDescription
  description
  themes
  accessStatus
  price {
    originalPrice
    discountedPrice
    discountApplied
    currency
  }
  accessPeriod {
    unit
    value
  }
  duration {
    unit
    value
  }
  instructors {
    ...ProgramInstructors
  }
}
    ${ProgramInstructorsFragmentDoc}`;
export const FullGenericProgramFieldsFragmentDoc = gql`
    fragment FullGenericProgramFields on GenericProgram {
  id
  ...EssentialGenericFields
  progress
  summaryAsset
  meta {
    title
    description
    imageUrl
  }
  discount {
    discountType
    discountValue
    discountedPrice
    endDate
    identifier
    startDate
  }
  postSurvey {
    id
    label
    kind
    link
    finished
    locked
  }
  preSurvey {
    id
    label
    kind
    link
    finished
    locked
  }
  trailer {
    content {
      title
    }
    minutes
    thumbnailUrl
    hls
    player {
      assets {
        resolution
        src
      }
    }
  }
}
    ${EssentialGenericFieldsFragmentDoc}`;
export const PlaylistEssentialFieldsFragmentDoc = gql`
    fragment PlaylistEssentialFields on Playlist {
  id
  identifier
  visibility
  title
  description
  owner {
    id
    firstName
  }
  meta {
    videoCount
    minutes
  }
  assets {
    thumbnailUrl
  }
  videos {
    id
    identifier
    kind
    assets {
      thumbnailUrl
    }
    hls
    hasAccess
    player {
      assets {
        src
        resolution
      }
    }
    cursorAt
    meta {
      minutes
    }
    content {
      title
      longDescription
      shortDescription
    }
    taxonomies {
      instructors {
        id
        name
        slug
      }
      needs {
        id
        name
      }
      bodyparts {
        id
        name
      }
      styles {
        id
        name
      }
      genre {
        id
        name
        slug
      }
    }
  }
}
    `;
export const PlaylistCardFieldsFragmentDoc = gql`
    fragment PlaylistCardFields on Playlist {
  id
  identifier
  visibility
  title
  description
  owner {
    id
    firstName
  }
  meta {
    videoCount
    minutes
  }
  assets {
    thumbnailUrl
  }
}
    `;
export const VideoFieldsFragmentDoc = gql`
    fragment VideoFields on Video {
  id
  identifier
  kind
  cursorAt
  content {
    title
    shortDescription
    longDescription
  }
  meta {
    minutes
    publishedAt
  }
  primaryStyle {
    name
    slug
  }
  taxonomies {
    flavor {
      id
      name
    }
    needs {
      id
      name
    }
    instructors {
      id
      name
      slug
    }
    genre {
      id
      name
      slug
    }
  }
  assets {
    thumbnailUrl
  }
}
    `;
export const LiveEventEssentialFieldsFragmentDoc = gql`
    fragment LiveEventEssentialFields on LiveEvent {
  id
  title
  slug
  thumbnail
  duration
  eventDates
  kind
  language
  level
  theme
  availableSpots
  maximumParticipants
  bookingAvailable
  price {
    originalPrice
    discountApplied
    discountedPrice
    currency
  }
  descriptionLong
  registrationEndDate
  registrationStartDate
  isExpired @client
  isComingSoon @client
  primaryInstructor {
    id
    name
    slug
    assets {
      squareImage
    }
  }
  instructors @client {
    id
    name
    slug
    assets {
      squareImage
    }
  }
}
    `;
export const LiveCodeDataFieldsFragmentDoc = gql`
    fragment LiveCodeDataFields on PromotionCode {
  code
  expirationDate
  usageLimit
  creationDate
  provider
  matchingResources {
    ... on LiveEvent {
      ...LiveEventEssentialFields
    }
  }
  usedIn {
    usageDate
    live {
      ...LiveEventEssentialFields
    }
  }
}
    ${LiveEventEssentialFieldsFragmentDoc}`;
export const FullLiveEventFieldsFragmentDoc = gql`
    fragment FullLiveEventFields on LiveEvent {
  ...LiveEventEssentialFields
  otherInstructors {
    id
    name
    slug
    assets {
      squareImage
    }
  }
  accessories
  linkToRecordings {
    link
    id
    eventDate
  }
}
    ${LiveEventEssentialFieldsFragmentDoc}`;
export const ProgramIntroFieldsFragmentDoc = gql`
    fragment ProgramIntroFields on SpecialSection {
  description
  label
  assetUrl
  slug
}
    `;
export const ProgramVideoFieldsFragmentDoc = gql`
    fragment ProgramVideoFields on ProgramVideo {
  id
  slug
  title
  subheader
  customTitle
  locked
  watched
  finished
  position
  positionLabel
  videoKind
  progressIsCurrent
  repeatRecomendation
  customDescription
  preMoodTracker {
    id
    finished
    kind
  }
  postMoodTracker {
    id
    finished
    kind
  }
  video {
    id
    title
    kind
    identifier
    hasAccess
    cursorAt
    content {
      title
      shortDescription
      longDescription
    }
    hls
    player {
      assets {
        src
        size
        resolution
      }
    }
    meta {
      publishedAt
      minutes
    }
    taxonomies {
      flavor {
        name
      }
      instructors {
        name
        slug
      }
      genre {
        name
        slug
      }
    }
    assets {
      thumbnailUrl
    }
  }
}
    `;
export const ProgramOutroFieldsFragmentDoc = gql`
    fragment ProgramOutroFields on SpecialSection {
  description
  label
  slug
  videos {
    ...ProgramVideoFields
  }
}
    ${ProgramVideoFieldsFragmentDoc}`;
export const PhasedProgramFieldsFragmentDoc = gql`
    fragment PhasedProgramFields on PhasedProgram {
  id
  slug
  title @client
  progress @client
  language @client
  weeksCount @client
  phasesCount @client
  currentElement @client {
    path
    title
  }
  videosCount @client
  instructors @client {
    id
    name
    assets {
      squareImage
    }
  }
  intro {
    ...ProgramIntroFields
  }
  outro {
    ...ProgramOutroFields
  }
  phases {
    id
    description
    label
    progress
    slug
    finished
    locked
    videosCount @client
    videosDuration @client
    weeksRange @client
    weeks {
      id
      label
      slug
      locked
      finished
      indexInProgram @client
      videos {
        ...ProgramVideoFields
      }
    }
  }
}
    ${ProgramIntroFieldsFragmentDoc}
${ProgramOutroFieldsFragmentDoc}
${ProgramVideoFieldsFragmentDoc}`;
export const SearchVideoFieldsFragmentDoc = gql`
    fragment SearchVideoFields on SearchVideo {
  id
  identifier
  title
  thumbnailUrl
  instructorName
  instructorSlug
  longDescription
  kind
  minutes
  primaryStyleName
  primaryStyleSlug
  shortDescription
}
    `;
export const SearchPlaylistFieldsFragmentDoc = gql`
    fragment SearchPlaylistFields on SearchPlaylist {
  id
  identifier
  title
  description
  minutes
  thumbnailUrl
  videoCount
  ownerId
  visibility
}
    `;
export const SearchGenericProgramFieldsFragmentDoc = gql`
    fragment SearchGenericProgramFields on SearchGenericProgram {
  accessPeriod {
    unit
    value
  }
  category
  description
  durationUnit
  durationValue
  id
  instructorName
  instructorSlug
  price {
    currency
    discountApplied
    discountedPrice
    originalPrice
  }
  priceType
  slug
  themes
  title
  titleImageUrl
}
    `;
export const SearchInstructorFieldsFragmentDoc = gql`
    fragment SearchInstructorFields on SearchInstructor {
  description
  id
  name
  slug
  squareImageUrl
}
    `;
export const SearchEventFieldsFragmentDoc = gql`
    fragment SearchEventFields on SearchEvent {
  id
  name
  slug
  description
  endsAt
  instructor
  startsAt
  titleImageUrl
  location
}
    `;
export const SearchLiveEventFieldsFragmentDoc = gql`
    fragment SearchLiveEventFields on SearchLiveEvent {
  id
  kind
  slug
  theme
  thumbnailUrl
  title
  availableSpots
  bookingAvailable
  duration
  eventDates
  instructorName
  instructorSlug
  maximumParticipants
  registrationEndDate
  registrationStartDate
  isExpired @client
  isComingSoon @client
  price @client {
    currency
    discountApplied
    discountedPrice
    originalPrice
  }
}
    `;
export const SearchLandingPageFieldsFragmentDoc = gql`
    fragment SearchLandingPageFields on SearchLandingPage {
  id
  lede
  locale
  title
  slug
}
    `;
export const SearchBlogPostFieldsFragmentDoc = gql`
    fragment SearchBlogPostFields on SearchBlogPost {
  featuredImageUrl
  id
  slug
  title
}
    `;
export const ProgramTextElementFieldsFragmentDoc = gql`
    fragment ProgramTextElementFields on ProgramPartElement {
  id
  slug
  subheader
  title
  description
  locked
  finished
  position
  positionLabel
  progressIsCurrent
}
    `;
export const ProgramSurveyFieldsFragmentDoc = gql`
    fragment ProgramSurveyFields on Survey {
  id
  name
  description
  content {
    page1Description
    page1Title
    page2Description
    page2Title
    page3ButtonUrl
    page3ButtonText
    page3Description
    page3Title
  }
  questions {
    id
    question
    answers
    options {
      default
      hint
      leftLabel
      maxValue
      minValue
      required
      rightLabel
      useForNps
      type
    }
  }
}
    `;
export const ProgramSurveyElementFieldsFragmentDoc = gql`
    fragment ProgramSurveyElementFields on ProgramSurveyElement {
  id
  slug
  subheader
  title
  description
  locked
  finished
  position
  positionLabel
  progressIsCurrent
  lastSubmittedAt
  surveysAnswer {
    id
    state
    contextableType
    content {
      key
      value
    }
  }
  survey {
    ...ProgramSurveyFields
  }
}
    ${ProgramSurveyFieldsFragmentDoc}`;
export const ProgramDocumentFieldsFragmentDoc = gql`
    fragment ProgramDocumentFields on ProgramDocument {
  id
  slug
  title
  subheader
  description
  finished
  kind
  locked
  position
  positionLabel
  progressIsCurrent
  document {
    url
    name
  }
}
    `;
export const WeeklyProgramWeekFragmentFragmentDoc = gql`
    fragment WeeklyProgramWeekFragment on ProgramWeek {
  id
  label
  slug
  locked
  finished
  progress
  description
  duration @client
  videosCount @client
  elements {
    __typename
    ... on ProgramPartElement {
      ...ProgramTextElementFields
    }
    ... on ProgramSurveyElement {
      ...ProgramSurveyElementFields
    }
    ... on ProgramDocument {
      ...ProgramDocumentFields
    }
    ... on ProgramVideo {
      ...ProgramVideoFields
    }
  }
}
    ${ProgramTextElementFieldsFragmentDoc}
${ProgramSurveyElementFieldsFragmentDoc}
${ProgramDocumentFieldsFragmentDoc}
${ProgramVideoFieldsFragmentDoc}`;
export const WeeklyProgramFieldsFragmentDoc = gql`
    fragment WeeklyProgramFields on WeeklyProgram {
  id
  slug
  recomendation
  progress @client
  videosCount @client
  currentElement @client {
    path
    title
  }
  instructors @client {
    ...ProgramInstructors
  }
  intro {
    ...ProgramIntroFields
  }
  outro {
    ...ProgramOutroFields
  }
  weeks {
    ...WeeklyProgramWeekFragment
  }
}
    ${ProgramInstructorsFragmentDoc}
${ProgramIntroFieldsFragmentDoc}
${ProgramOutroFieldsFragmentDoc}
${WeeklyProgramWeekFragmentFragmentDoc}`;
export const CancelSubscriptionDocument = gql`
    mutation cancelSubscription {
  cancelSubscription {
    success
  }
}
    `;
export type CancelSubscriptionMutationFn = Apollo.MutationFunction<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>;

/**
 * __useCancelSubscriptionMutation__
 *
 * To run a mutation, you first call `useCancelSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelSubscriptionMutation, { data, loading, error }] = useCancelSubscriptionMutation({
 *   variables: {
 *   },
 * });
 */
export function useCancelSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>(CancelSubscriptionDocument, options);
      }
export type CancelSubscriptionMutationHookResult = ReturnType<typeof useCancelSubscriptionMutation>;
export type CancelSubscriptionMutationResult = Apollo.MutationResult<CancelSubscriptionMutation>;
export type CancelSubscriptionMutationOptions = Apollo.BaseMutationOptions<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>;
export const AuthenticateUserDocument = gql`
    mutation authenticateUser($email: String!, $password: String!) {
  authenticateUser(email: $email, password: $password) {
    user {
      id
      firstName
      lastName
      email
    }
  }
}
    `;
export type AuthenticateUserMutationFn = Apollo.MutationFunction<AuthenticateUserMutation, AuthenticateUserMutationVariables>;

/**
 * __useAuthenticateUserMutation__
 *
 * To run a mutation, you first call `useAuthenticateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticateUserMutation, { data, loading, error }] = useAuthenticateUserMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useAuthenticateUserMutation(baseOptions?: Apollo.MutationHookOptions<AuthenticateUserMutation, AuthenticateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthenticateUserMutation, AuthenticateUserMutationVariables>(AuthenticateUserDocument, options);
      }
export type AuthenticateUserMutationHookResult = ReturnType<typeof useAuthenticateUserMutation>;
export type AuthenticateUserMutationResult = Apollo.MutationResult<AuthenticateUserMutation>;
export type AuthenticateUserMutationOptions = Apollo.BaseMutationOptions<AuthenticateUserMutation, AuthenticateUserMutationVariables>;
export const AvailableOneTimeCodeDocument = gql`
    query availableOneTimeCode($code: String) {
  availableOneTimeCode(code: $code, platform: web) {
    isCodeValid
    code
    codeType
    validationMessage
    oneTimeCodes {
      ...PricingSubscriptionFields
    }
  }
}
    ${PricingSubscriptionFieldsFragmentDoc}`;

/**
 * __useAvailableOneTimeCodeQuery__
 *
 * To run a query within a React component, call `useAvailableOneTimeCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableOneTimeCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableOneTimeCodeQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useAvailableOneTimeCodeQuery(baseOptions?: Apollo.QueryHookOptions<AvailableOneTimeCodeQuery, AvailableOneTimeCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailableOneTimeCodeQuery, AvailableOneTimeCodeQueryVariables>(AvailableOneTimeCodeDocument, options);
      }
export function useAvailableOneTimeCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailableOneTimeCodeQuery, AvailableOneTimeCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailableOneTimeCodeQuery, AvailableOneTimeCodeQueryVariables>(AvailableOneTimeCodeDocument, options);
        }
export type AvailableOneTimeCodeQueryHookResult = ReturnType<typeof useAvailableOneTimeCodeQuery>;
export type AvailableOneTimeCodeLazyQueryHookResult = ReturnType<typeof useAvailableOneTimeCodeLazyQuery>;
export type AvailableOneTimeCodeQueryResult = Apollo.QueryResult<AvailableOneTimeCodeQuery, AvailableOneTimeCodeQueryVariables>;
export function refetchAvailableOneTimeCodeQuery(variables?: AvailableOneTimeCodeQueryVariables) {
      return { query: AvailableOneTimeCodeDocument, variables: variables }
    }
export const PricingSubscriptionPlansDocument = gql`
    query PricingSubscriptionPlans($code: String) {
  availableSubscriptionPlans(code: $code, platform: web) {
    code
    isCodeValid
    subscriptions {
      ...PricingSubscriptionFields
    }
  }
}
    ${PricingSubscriptionFieldsFragmentDoc}`;

/**
 * __usePricingSubscriptionPlansQuery__
 *
 * To run a query within a React component, call `usePricingSubscriptionPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `usePricingSubscriptionPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePricingSubscriptionPlansQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function usePricingSubscriptionPlansQuery(baseOptions?: Apollo.QueryHookOptions<PricingSubscriptionPlansQuery, PricingSubscriptionPlansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PricingSubscriptionPlansQuery, PricingSubscriptionPlansQueryVariables>(PricingSubscriptionPlansDocument, options);
      }
export function usePricingSubscriptionPlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PricingSubscriptionPlansQuery, PricingSubscriptionPlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PricingSubscriptionPlansQuery, PricingSubscriptionPlansQueryVariables>(PricingSubscriptionPlansDocument, options);
        }
export type PricingSubscriptionPlansQueryHookResult = ReturnType<typeof usePricingSubscriptionPlansQuery>;
export type PricingSubscriptionPlansLazyQueryHookResult = ReturnType<typeof usePricingSubscriptionPlansLazyQuery>;
export type PricingSubscriptionPlansQueryResult = Apollo.QueryResult<PricingSubscriptionPlansQuery, PricingSubscriptionPlansQueryVariables>;
export function refetchPricingSubscriptionPlansQuery(variables?: PricingSubscriptionPlansQueryVariables) {
      return { query: PricingSubscriptionPlansDocument, variables: variables }
    }
export const FullAvailableSubscriptionPlansDocument = gql`
    query FullAvailableSubscriptionPlans($code: String) {
  availableSubscriptionPlans(code: $code, platform: web) {
    code
    codeType
    isCodeValid
    validationMessage
    subscriptions {
      ...PricingSubscriptionFields
    }
    fullAccesses {
      title
      description
      shortDescription
      currency
      promotionKind
      promotionName
      extraPromotion
      subscriptionName
      subscriptionPlan
    }
    oneTimeCodes {
      title
      description
      shortDescription
      promotionKind
      promotionName
    }
  }
}
    ${PricingSubscriptionFieldsFragmentDoc}`;

/**
 * __useFullAvailableSubscriptionPlansQuery__
 *
 * To run a query within a React component, call `useFullAvailableSubscriptionPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useFullAvailableSubscriptionPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFullAvailableSubscriptionPlansQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useFullAvailableSubscriptionPlansQuery(baseOptions?: Apollo.QueryHookOptions<FullAvailableSubscriptionPlansQuery, FullAvailableSubscriptionPlansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FullAvailableSubscriptionPlansQuery, FullAvailableSubscriptionPlansQueryVariables>(FullAvailableSubscriptionPlansDocument, options);
      }
export function useFullAvailableSubscriptionPlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FullAvailableSubscriptionPlansQuery, FullAvailableSubscriptionPlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FullAvailableSubscriptionPlansQuery, FullAvailableSubscriptionPlansQueryVariables>(FullAvailableSubscriptionPlansDocument, options);
        }
export type FullAvailableSubscriptionPlansQueryHookResult = ReturnType<typeof useFullAvailableSubscriptionPlansQuery>;
export type FullAvailableSubscriptionPlansLazyQueryHookResult = ReturnType<typeof useFullAvailableSubscriptionPlansLazyQuery>;
export type FullAvailableSubscriptionPlansQueryResult = Apollo.QueryResult<FullAvailableSubscriptionPlansQuery, FullAvailableSubscriptionPlansQueryVariables>;
export function refetchFullAvailableSubscriptionPlansQuery(variables?: FullAvailableSubscriptionPlansQueryVariables) {
      return { query: FullAvailableSubscriptionPlansDocument, variables: variables }
    }
export const AvailableTrialExtensionsDocument = gql`
    query availableTrialExtensions($code: String) {
  availableTrialExtensions(code: $code, platform: web) {
    code
    codeType
    isCodeValid
    validationMessage
    trials {
      months
      days
      subscriptionPlan
      promotionKind
      promotionName
    }
    trialReferralCodes {
      months
      days
      subscriptionPlan
      promotionKind
      promotionName
    }
    oneTimeCodes {
      accessUntil
      months
      days
      subscriptionPlan
      promotionKind
      promotionName
    }
  }
}
    `;

/**
 * __useAvailableTrialExtensionsQuery__
 *
 * To run a query within a React component, call `useAvailableTrialExtensionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableTrialExtensionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableTrialExtensionsQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useAvailableTrialExtensionsQuery(baseOptions?: Apollo.QueryHookOptions<AvailableTrialExtensionsQuery, AvailableTrialExtensionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailableTrialExtensionsQuery, AvailableTrialExtensionsQueryVariables>(AvailableTrialExtensionsDocument, options);
      }
export function useAvailableTrialExtensionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailableTrialExtensionsQuery, AvailableTrialExtensionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailableTrialExtensionsQuery, AvailableTrialExtensionsQueryVariables>(AvailableTrialExtensionsDocument, options);
        }
export type AvailableTrialExtensionsQueryHookResult = ReturnType<typeof useAvailableTrialExtensionsQuery>;
export type AvailableTrialExtensionsLazyQueryHookResult = ReturnType<typeof useAvailableTrialExtensionsLazyQuery>;
export type AvailableTrialExtensionsQueryResult = Apollo.QueryResult<AvailableTrialExtensionsQuery, AvailableTrialExtensionsQueryVariables>;
export function refetchAvailableTrialExtensionsQuery(variables?: AvailableTrialExtensionsQueryVariables) {
      return { query: AvailableTrialExtensionsDocument, variables: variables }
    }
export const BasicBundleDocument = gql`
    query basicBundle($slug: String!, $client: String!) {
  basicBundle: bundle(slug: $slug, client: $client) {
    ...BundleEssentialFields
  }
}
    ${BundleEssentialFieldsFragmentDoc}`;

/**
 * __useBasicBundleQuery__
 *
 * To run a query within a React component, call `useBasicBundleQuery` and pass it any options that fit your needs.
 * When your component renders, `useBasicBundleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBasicBundleQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      client: // value for 'client'
 *   },
 * });
 */
export function useBasicBundleQuery(baseOptions: Apollo.QueryHookOptions<BasicBundleQuery, BasicBundleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BasicBundleQuery, BasicBundleQueryVariables>(BasicBundleDocument, options);
      }
export function useBasicBundleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BasicBundleQuery, BasicBundleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BasicBundleQuery, BasicBundleQueryVariables>(BasicBundleDocument, options);
        }
export type BasicBundleQueryHookResult = ReturnType<typeof useBasicBundleQuery>;
export type BasicBundleLazyQueryHookResult = ReturnType<typeof useBasicBundleLazyQuery>;
export type BasicBundleQueryResult = Apollo.QueryResult<BasicBundleQuery, BasicBundleQueryVariables>;
export function refetchBasicBundleQuery(variables: BasicBundleQueryVariables) {
      return { query: BasicBundleDocument, variables: variables }
    }
export const BundleDocument = gql`
    query bundle($slug: String!, $client: String!) {
  bundle(slug: $slug, client: $client) {
    ...BundleEssentialFields
    trailer {
      identifier
      minutes
      thumbnailUrl
      hls
      player {
        assets {
          resolution
          src
        }
      }
    }
    sections
    infoPanel {
      title
      description
      image
    }
    infoPanel2 {
      title
      image
      longText
      previewText
    }
    bundleItems {
      __typename
      videos {
        ... on Video {
          ...VideoFields
        }
      }
      challenges {
        ... on GenericProgram {
          ...EssentialGenericFields
        }
      }
      programs {
        ... on GenericProgram {
          ...EssentialGenericFields
        }
      }
      playlists {
        ... on Playlist {
          ...PlaylistCardFields
        }
      }
      liveEvents {
        ... on LiveEvent {
          ...LiveEventEssentialFields
        }
      }
      blogPosts {
        ... on BlogPost {
          ...BlogPostFields
        }
      }
      documents {
        ... on Document {
          contentType
          id
          name
          url
        }
      }
    }
  }
}
    ${BundleEssentialFieldsFragmentDoc}
${VideoFieldsFragmentDoc}
${EssentialGenericFieldsFragmentDoc}
${PlaylistCardFieldsFragmentDoc}
${LiveEventEssentialFieldsFragmentDoc}
${BlogPostFieldsFragmentDoc}`;

/**
 * __useBundleQuery__
 *
 * To run a query within a React component, call `useBundleQuery` and pass it any options that fit your needs.
 * When your component renders, `useBundleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBundleQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      client: // value for 'client'
 *   },
 * });
 */
export function useBundleQuery(baseOptions: Apollo.QueryHookOptions<BundleQuery, BundleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BundleQuery, BundleQueryVariables>(BundleDocument, options);
      }
export function useBundleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BundleQuery, BundleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BundleQuery, BundleQueryVariables>(BundleDocument, options);
        }
export type BundleQueryHookResult = ReturnType<typeof useBundleQuery>;
export type BundleLazyQueryHookResult = ReturnType<typeof useBundleLazyQuery>;
export type BundleQueryResult = Apollo.QueryResult<BundleQuery, BundleQueryVariables>;
export function refetchBundleQuery(variables: BundleQueryVariables) {
      return { query: BundleDocument, variables: variables }
    }
export const ActivateBundleDocument = gql`
    mutation activateBundle($slug: String!, $client: String!, $code: String!) {
  activateBundle(slug: $slug, code: $code, client: $client) {
    success
    errors
  }
}
    `;
export type ActivateBundleMutationFn = Apollo.MutationFunction<ActivateBundleMutation, ActivateBundleMutationVariables>;

/**
 * __useActivateBundleMutation__
 *
 * To run a mutation, you first call `useActivateBundleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateBundleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateBundleMutation, { data, loading, error }] = useActivateBundleMutation({
 *   variables: {
 *      slug: // value for 'slug'
 *      client: // value for 'client'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useActivateBundleMutation(baseOptions?: Apollo.MutationHookOptions<ActivateBundleMutation, ActivateBundleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateBundleMutation, ActivateBundleMutationVariables>(ActivateBundleDocument, options);
      }
export type ActivateBundleMutationHookResult = ReturnType<typeof useActivateBundleMutation>;
export type ActivateBundleMutationResult = Apollo.MutationResult<ActivateBundleMutation>;
export type ActivateBundleMutationOptions = Apollo.BaseMutationOptions<ActivateBundleMutation, ActivateBundleMutationVariables>;
export const ValidateBundleCodeDocument = gql`
    query validateBundleCode($slug: String!, $code: String!, $client: String!) {
  validateBundleCode(slug: $slug, code: $code, client: $client) {
    code
    message
    status
  }
}
    `;

/**
 * __useValidateBundleCodeQuery__
 *
 * To run a query within a React component, call `useValidateBundleCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateBundleCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateBundleCodeQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      code: // value for 'code'
 *      client: // value for 'client'
 *   },
 * });
 */
export function useValidateBundleCodeQuery(baseOptions: Apollo.QueryHookOptions<ValidateBundleCodeQuery, ValidateBundleCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateBundleCodeQuery, ValidateBundleCodeQueryVariables>(ValidateBundleCodeDocument, options);
      }
export function useValidateBundleCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateBundleCodeQuery, ValidateBundleCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateBundleCodeQuery, ValidateBundleCodeQueryVariables>(ValidateBundleCodeDocument, options);
        }
export type ValidateBundleCodeQueryHookResult = ReturnType<typeof useValidateBundleCodeQuery>;
export type ValidateBundleCodeLazyQueryHookResult = ReturnType<typeof useValidateBundleCodeLazyQuery>;
export type ValidateBundleCodeQueryResult = Apollo.QueryResult<ValidateBundleCodeQuery, ValidateBundleCodeQueryVariables>;
export function refetchValidateBundleCodeQuery(variables: ValidateBundleCodeQueryVariables) {
      return { query: ValidateBundleCodeDocument, variables: variables }
    }
export const BundlesDocument = gql`
    query bundles($page: Int, $perPage: Int) {
  bundles(page: $page, perPage: $perPage) {
    page
    perPage
    totalCount
    data {
      slug
      client {
        slug
      }
    }
  }
}
    `;

/**
 * __useBundlesQuery__
 *
 * To run a query within a React component, call `useBundlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBundlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBundlesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useBundlesQuery(baseOptions?: Apollo.QueryHookOptions<BundlesQuery, BundlesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BundlesQuery, BundlesQueryVariables>(BundlesDocument, options);
      }
export function useBundlesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BundlesQuery, BundlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BundlesQuery, BundlesQueryVariables>(BundlesDocument, options);
        }
export type BundlesQueryHookResult = ReturnType<typeof useBundlesQuery>;
export type BundlesLazyQueryHookResult = ReturnType<typeof useBundlesLazyQuery>;
export type BundlesQueryResult = Apollo.QueryResult<BundlesQuery, BundlesQueryVariables>;
export function refetchBundlesQuery(variables?: BundlesQueryVariables) {
      return { query: BundlesDocument, variables: variables }
    }
export const MyBundlesDocument = gql`
    query myBundles($page: Int, $perPage: Int) {
  myBundles(page: $page, perPage: $perPage) {
    page
    perPage
    totalCount
    data {
      ...BundleEssentialFields
    }
  }
}
    ${BundleEssentialFieldsFragmentDoc}`;

/**
 * __useMyBundlesQuery__
 *
 * To run a query within a React component, call `useMyBundlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyBundlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyBundlesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useMyBundlesQuery(baseOptions?: Apollo.QueryHookOptions<MyBundlesQuery, MyBundlesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyBundlesQuery, MyBundlesQueryVariables>(MyBundlesDocument, options);
      }
export function useMyBundlesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyBundlesQuery, MyBundlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyBundlesQuery, MyBundlesQueryVariables>(MyBundlesDocument, options);
        }
export type MyBundlesQueryHookResult = ReturnType<typeof useMyBundlesQuery>;
export type MyBundlesLazyQueryHookResult = ReturnType<typeof useMyBundlesLazyQuery>;
export type MyBundlesQueryResult = Apollo.QueryResult<MyBundlesQuery, MyBundlesQueryVariables>;
export function refetchMyBundlesQuery(variables?: MyBundlesQueryVariables) {
      return { query: MyBundlesDocument, variables: variables }
    }
export const ChangeProfileDataDocument = gql`
    mutation changeProfileData($displayName: String, $shortBio: String, $instagramUrl: String, $facebookUrl: String, $linkedinUrl: String, $timezone: String, $avatar: Upload) {
  changeProfileData(displayName: $displayName, shortBio: $shortBio, instagramUrl: $instagramUrl, facebookUrl: $facebookUrl, linkedinUrl: $linkedinUrl, timezone: $timezone, avatar: $avatar) {
    user {
      id
    }
  }
}
    `;
export type ChangeProfileDataMutationFn = Apollo.MutationFunction<ChangeProfileDataMutation, ChangeProfileDataMutationVariables>;

/**
 * __useChangeProfileDataMutation__
 *
 * To run a mutation, you first call `useChangeProfileDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeProfileDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeProfileDataMutation, { data, loading, error }] = useChangeProfileDataMutation({
 *   variables: {
 *      displayName: // value for 'displayName'
 *      shortBio: // value for 'shortBio'
 *      instagramUrl: // value for 'instagramUrl'
 *      facebookUrl: // value for 'facebookUrl'
 *      linkedinUrl: // value for 'linkedinUrl'
 *      timezone: // value for 'timezone'
 *      avatar: // value for 'avatar'
 *   },
 * });
 */
export function useChangeProfileDataMutation(baseOptions?: Apollo.MutationHookOptions<ChangeProfileDataMutation, ChangeProfileDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeProfileDataMutation, ChangeProfileDataMutationVariables>(ChangeProfileDataDocument, options);
      }
export type ChangeProfileDataMutationHookResult = ReturnType<typeof useChangeProfileDataMutation>;
export type ChangeProfileDataMutationResult = Apollo.MutationResult<ChangeProfileDataMutation>;
export type ChangeProfileDataMutationOptions = Apollo.BaseMutationOptions<ChangeProfileDataMutation, ChangeProfileDataMutationVariables>;
export const CompleteProfileDocument = gql`
    mutation completeProfile($phone: String, $address: String, $postalCode: String, $city: String, $gender: GenderKind, $country: String, $countryCode: String = "SE", $trialExtensionCode: String, $oneTimeCode: String) {
  completeProfile(phone: $phone, address: $address, postalCode: $postalCode, city: $city, gender: $gender, country: $country, countryCode: $countryCode, platform: web, trialExtensionCode: $trialExtensionCode, oneTimeCode: $oneTimeCode) {
    errors {
      message
    }
    user {
      id
    }
  }
}
    `;
export type CompleteProfileMutationFn = Apollo.MutationFunction<CompleteProfileMutation, CompleteProfileMutationVariables>;

/**
 * __useCompleteProfileMutation__
 *
 * To run a mutation, you first call `useCompleteProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeProfileMutation, { data, loading, error }] = useCompleteProfileMutation({
 *   variables: {
 *      phone: // value for 'phone'
 *      address: // value for 'address'
 *      postalCode: // value for 'postalCode'
 *      city: // value for 'city'
 *      gender: // value for 'gender'
 *      country: // value for 'country'
 *      countryCode: // value for 'countryCode'
 *      trialExtensionCode: // value for 'trialExtensionCode'
 *      oneTimeCode: // value for 'oneTimeCode'
 *   },
 * });
 */
export function useCompleteProfileMutation(baseOptions?: Apollo.MutationHookOptions<CompleteProfileMutation, CompleteProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteProfileMutation, CompleteProfileMutationVariables>(CompleteProfileDocument, options);
      }
export type CompleteProfileMutationHookResult = ReturnType<typeof useCompleteProfileMutation>;
export type CompleteProfileMutationResult = Apollo.MutationResult<CompleteProfileMutation>;
export type CompleteProfileMutationOptions = Apollo.BaseMutationOptions<CompleteProfileMutation, CompleteProfileMutationVariables>;
export const CurrentUserDocument = gql`
    query currentUser {
  currentUser {
    id
    firstName
    lastName
    email
    accessToken
    accessUntil
    completedAt
    eligibleForTrialReclaim(promotionName: ProvaYogobe14)
    isPremium @client
    isNoneTrialPremium @client
    hasWellness @client
    group
    isEmailActivated
    accountActivatedAt
    isPublic
    kind
    locale
    slug
    previousEmail
    trialPeriod
    country
    zipcode
    city
    phone
    address
    referralCode
    profile {
      displayName
      shortBio
      instagramURL
      linkedinURL
      facebookURL
      timezone
    }
    assets {
      avatar
    }
    preferences {
      contentLanguages
      preferTerms
      excludeTerms
      videoLevels
    }
    subscriptionPlanSelected
    subscription {
      provider
      status
      inTrialPeriod
      currentSubscriptionPlan {
        platform
        planType
        platform
        productId
      }
    }
    onboardingCompleted
    onboardingSkipped
    onboardingInterestsSkipped
    onboardingTopicsSkipped
  }
}
    `;

/**
 * __useCurrentUserQuery__
 *
 * To run a query within a React component, call `useCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
      }
export function useCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
        }
export type CurrentUserQueryHookResult = ReturnType<typeof useCurrentUserQuery>;
export type CurrentUserLazyQueryHookResult = ReturnType<typeof useCurrentUserLazyQuery>;
export type CurrentUserQueryResult = Apollo.QueryResult<CurrentUserQuery, CurrentUserQueryVariables>;
export function refetchCurrentUserQuery(variables?: CurrentUserQueryVariables) {
      return { query: CurrentUserDocument, variables: variables }
    }
export const CurrentUser2Document = gql`
    query currentUser2 {
  currentUser {
    id
    accessUntil
    paymentTypeRenews
    paymentFailedAt
    gender
    dateOfBirth
    profession
    nextBillingCycle {
      paymentStatus
      amount
      billingDate
      planName
    }
    topics {
      name
      slug
    }
    interests {
      name
      slug
    }
    favorites {
      videos
      playlists
    }
    privacySettings {
      isPrivateFavorites
      isPrivateHistory
      isPrivatePlaylists
      isPrivateProfile
      isPrivateStats
    }
    statistics {
      sessionsLastWeek
      sessionsCompleted
      totalTime
      averageDuration
    }
    receipts {
      date
      number
      paymentType
      paymentProvider
      amount
      currency
      transact
      downloadUrl
    }
    extraPayments {
      date
      number
      paymentType
      amount
      currency
      transact
      downloadUrl
    }
    liveEventsAccess {
      liveEvent {
        id
        duration
        eventDates
        kind
        language
        level
        theme
        slug
        title
        thumbnail
        accessories
        price {
          originalPrice
          discountApplied
          discountedPrice
          currency
        }
        registrationEndDate
        registrationStartDate
        descriptionLong
        availableSpots
        bookingAvailable
        primaryInstructor {
          id
          name
          slug
          assets {
            squareImage
          }
        }
        otherInstructors {
          id
          name
          slug
          assets {
            squareImage
          }
        }
        instructors @client {
          id
          name
          slug
          assets {
            squareImage
          }
        }
      }
      zoomLink
      zoomPassword
    }
    programAccess {
      accessStatus
      accessUntil
      program {
        id
        name
        title: name
        slug
        lede
        shortDescription
        themes
        legacy
        language
        titleImageUrl
        tags
        duration {
          value
          unit
        }
        instructors {
          id
          name
          slug
          assets {
            squareImage
          }
        }
      }
    }
    courseAccesses {
      accessUntil
      accessStatus
      course {
        id
        name
        titleImageUrl
        slug
        path
        themes
        legacy
        content {
          lede
        }
      }
    }
    challengeParticipations {
      accessUntil
      challenge {
        name
      }
    }
  }
}
    `;

/**
 * __useCurrentUser2Query__
 *
 * To run a query within a React component, call `useCurrentUser2Query` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUser2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUser2Query({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUser2Query(baseOptions?: Apollo.QueryHookOptions<CurrentUser2Query, CurrentUser2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUser2Query, CurrentUser2QueryVariables>(CurrentUser2Document, options);
      }
export function useCurrentUser2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUser2Query, CurrentUser2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUser2Query, CurrentUser2QueryVariables>(CurrentUser2Document, options);
        }
export type CurrentUser2QueryHookResult = ReturnType<typeof useCurrentUser2Query>;
export type CurrentUser2LazyQueryHookResult = ReturnType<typeof useCurrentUser2LazyQuery>;
export type CurrentUser2QueryResult = Apollo.QueryResult<CurrentUser2Query, CurrentUser2QueryVariables>;
export function refetchCurrentUser2Query(variables?: CurrentUser2QueryVariables) {
      return { query: CurrentUser2Document, variables: variables }
    }
export const DashboardRecentVideosDocument = gql`
    query dashboardRecentVideos {
  recentVideos {
    id
    identifier
    content {
      title
      shortDescription
    }
    meta {
      minutes
      publishedAt
    }
    taxonomies {
      flavor {
        name
      }
      instructors {
        name
        slug
      }
      genre {
        name
        slug
      }
    }
    assets {
      thumbnailUrl
    }
  }
}
    `;

/**
 * __useDashboardRecentVideosQuery__
 *
 * To run a query within a React component, call `useDashboardRecentVideosQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardRecentVideosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardRecentVideosQuery({
 *   variables: {
 *   },
 * });
 */
export function useDashboardRecentVideosQuery(baseOptions?: Apollo.QueryHookOptions<DashboardRecentVideosQuery, DashboardRecentVideosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardRecentVideosQuery, DashboardRecentVideosQueryVariables>(DashboardRecentVideosDocument, options);
      }
export function useDashboardRecentVideosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardRecentVideosQuery, DashboardRecentVideosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardRecentVideosQuery, DashboardRecentVideosQueryVariables>(DashboardRecentVideosDocument, options);
        }
export type DashboardRecentVideosQueryHookResult = ReturnType<typeof useDashboardRecentVideosQuery>;
export type DashboardRecentVideosLazyQueryHookResult = ReturnType<typeof useDashboardRecentVideosLazyQuery>;
export type DashboardRecentVideosQueryResult = Apollo.QueryResult<DashboardRecentVideosQuery, DashboardRecentVideosQueryVariables>;
export function refetchDashboardRecentVideosQuery(variables?: DashboardRecentVideosQueryVariables) {
      return { query: DashboardRecentVideosDocument, variables: variables }
    }
export const DashboardTaxonomiesDocument = gql`
    query dashboardTaxonomies($filter: String) {
  playlists: taxonomies(filter: $filter) {
    terms {
      id
      name
      titleImageUrl
      slug
    }
  }
}
    `;

/**
 * __useDashboardTaxonomiesQuery__
 *
 * To run a query within a React component, call `useDashboardTaxonomiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardTaxonomiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardTaxonomiesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDashboardTaxonomiesQuery(baseOptions?: Apollo.QueryHookOptions<DashboardTaxonomiesQuery, DashboardTaxonomiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardTaxonomiesQuery, DashboardTaxonomiesQueryVariables>(DashboardTaxonomiesDocument, options);
      }
export function useDashboardTaxonomiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardTaxonomiesQuery, DashboardTaxonomiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardTaxonomiesQuery, DashboardTaxonomiesQueryVariables>(DashboardTaxonomiesDocument, options);
        }
export type DashboardTaxonomiesQueryHookResult = ReturnType<typeof useDashboardTaxonomiesQuery>;
export type DashboardTaxonomiesLazyQueryHookResult = ReturnType<typeof useDashboardTaxonomiesLazyQuery>;
export type DashboardTaxonomiesQueryResult = Apollo.QueryResult<DashboardTaxonomiesQuery, DashboardTaxonomiesQueryVariables>;
export function refetchDashboardTaxonomiesQuery(variables?: DashboardTaxonomiesQueryVariables) {
      return { query: DashboardTaxonomiesDocument, variables: variables }
    }
export const EmailPreferencesDocument = gql`
    query EmailPreferences($email: String, $token: String) {
  emailPreferences(email: $email, token: $token) {
    id
    isMuted
    key
    name
    description
  }
}
    `;

/**
 * __useEmailPreferencesQuery__
 *
 * To run a query within a React component, call `useEmailPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailPreferencesQuery({
 *   variables: {
 *      email: // value for 'email'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useEmailPreferencesQuery(baseOptions?: Apollo.QueryHookOptions<EmailPreferencesQuery, EmailPreferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmailPreferencesQuery, EmailPreferencesQueryVariables>(EmailPreferencesDocument, options);
      }
export function useEmailPreferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmailPreferencesQuery, EmailPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmailPreferencesQuery, EmailPreferencesQueryVariables>(EmailPreferencesDocument, options);
        }
export type EmailPreferencesQueryHookResult = ReturnType<typeof useEmailPreferencesQuery>;
export type EmailPreferencesLazyQueryHookResult = ReturnType<typeof useEmailPreferencesLazyQuery>;
export type EmailPreferencesQueryResult = Apollo.QueryResult<EmailPreferencesQuery, EmailPreferencesQueryVariables>;
export function refetchEmailPreferencesQuery(variables?: EmailPreferencesQueryVariables) {
      return { query: EmailPreferencesDocument, variables: variables }
    }
export const ChangeEmailPreferenceDocument = gql`
    mutation ChangeEmailPreference($mute: Boolean!, $key: String!, $email: String, $token: String) {
  changeEmailPreference(mute: $mute, key: $key, email: $email, token: $token) {
    errors
    success
  }
}
    `;
export type ChangeEmailPreferenceMutationFn = Apollo.MutationFunction<ChangeEmailPreferenceMutation, ChangeEmailPreferenceMutationVariables>;

/**
 * __useChangeEmailPreferenceMutation__
 *
 * To run a mutation, you first call `useChangeEmailPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeEmailPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeEmailPreferenceMutation, { data, loading, error }] = useChangeEmailPreferenceMutation({
 *   variables: {
 *      mute: // value for 'mute'
 *      key: // value for 'key'
 *      email: // value for 'email'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useChangeEmailPreferenceMutation(baseOptions?: Apollo.MutationHookOptions<ChangeEmailPreferenceMutation, ChangeEmailPreferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeEmailPreferenceMutation, ChangeEmailPreferenceMutationVariables>(ChangeEmailPreferenceDocument, options);
      }
export type ChangeEmailPreferenceMutationHookResult = ReturnType<typeof useChangeEmailPreferenceMutation>;
export type ChangeEmailPreferenceMutationResult = Apollo.MutationResult<ChangeEmailPreferenceMutation>;
export type ChangeEmailPreferenceMutationOptions = Apollo.BaseMutationOptions<ChangeEmailPreferenceMutation, ChangeEmailPreferenceMutationVariables>;
export const EventProxyDocument = gql`
    mutation eventProxy($event: ProxyEventKind!, $properties: [EventPropertyInput!]) {
  eventProxy(event: $event, properties: $properties) {
    errors {
      message
    }
  }
}
    `;
export type EventProxyMutationFn = Apollo.MutationFunction<EventProxyMutation, EventProxyMutationVariables>;

/**
 * __useEventProxyMutation__
 *
 * To run a mutation, you first call `useEventProxyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEventProxyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [eventProxyMutation, { data, loading, error }] = useEventProxyMutation({
 *   variables: {
 *      event: // value for 'event'
 *      properties: // value for 'properties'
 *   },
 * });
 */
export function useEventProxyMutation(baseOptions?: Apollo.MutationHookOptions<EventProxyMutation, EventProxyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EventProxyMutation, EventProxyMutationVariables>(EventProxyDocument, options);
      }
export type EventProxyMutationHookResult = ReturnType<typeof useEventProxyMutation>;
export type EventProxyMutationResult = Apollo.MutationResult<EventProxyMutation>;
export type EventProxyMutationOptions = Apollo.BaseMutationOptions<EventProxyMutation, EventProxyMutationVariables>;
export const GetBasicGenericProgramDocument = gql`
    query GetBasicGenericProgram($slug: String!) {
  genericProgram(slug: $slug) {
    ...EssentialGenericFields
  }
}
    ${EssentialGenericFieldsFragmentDoc}`;

/**
 * __useGetBasicGenericProgramQuery__
 *
 * To run a query within a React component, call `useGetBasicGenericProgramQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBasicGenericProgramQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBasicGenericProgramQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetBasicGenericProgramQuery(baseOptions: Apollo.QueryHookOptions<GetBasicGenericProgramQuery, GetBasicGenericProgramQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBasicGenericProgramQuery, GetBasicGenericProgramQueryVariables>(GetBasicGenericProgramDocument, options);
      }
export function useGetBasicGenericProgramLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBasicGenericProgramQuery, GetBasicGenericProgramQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBasicGenericProgramQuery, GetBasicGenericProgramQueryVariables>(GetBasicGenericProgramDocument, options);
        }
export type GetBasicGenericProgramQueryHookResult = ReturnType<typeof useGetBasicGenericProgramQuery>;
export type GetBasicGenericProgramLazyQueryHookResult = ReturnType<typeof useGetBasicGenericProgramLazyQuery>;
export type GetBasicGenericProgramQueryResult = Apollo.QueryResult<GetBasicGenericProgramQuery, GetBasicGenericProgramQueryVariables>;
export function refetchGetBasicGenericProgramQuery(variables: GetBasicGenericProgramQueryVariables) {
      return { query: GetBasicGenericProgramDocument, variables: variables }
    }
export const GetFullGenericProgramDocument = gql`
    query GetFullGenericProgram($slug: String!) {
  genericProgram(slug: $slug) {
    ...FullGenericProgramFields
  }
}
    ${FullGenericProgramFieldsFragmentDoc}`;

/**
 * __useGetFullGenericProgramQuery__
 *
 * To run a query within a React component, call `useGetFullGenericProgramQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFullGenericProgramQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFullGenericProgramQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetFullGenericProgramQuery(baseOptions: Apollo.QueryHookOptions<GetFullGenericProgramQuery, GetFullGenericProgramQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFullGenericProgramQuery, GetFullGenericProgramQueryVariables>(GetFullGenericProgramDocument, options);
      }
export function useGetFullGenericProgramLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFullGenericProgramQuery, GetFullGenericProgramQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFullGenericProgramQuery, GetFullGenericProgramQueryVariables>(GetFullGenericProgramDocument, options);
        }
export type GetFullGenericProgramQueryHookResult = ReturnType<typeof useGetFullGenericProgramQuery>;
export type GetFullGenericProgramLazyQueryHookResult = ReturnType<typeof useGetFullGenericProgramLazyQuery>;
export type GetFullGenericProgramQueryResult = Apollo.QueryResult<GetFullGenericProgramQuery, GetFullGenericProgramQueryVariables>;
export function refetchGetFullGenericProgramQuery(variables: GetFullGenericProgramQueryVariables) {
      return { query: GetFullGenericProgramDocument, variables: variables }
    }
export const GenericProgramsDocument = gql`
    query genericPrograms($perPage: Int = 12, $page: Int, $search: String, $languages: [LanguageKind!], $instructor: String, $sortBy: GenericProgramSortAttribute, $theme: String, $category: ProgramCategory, $tags: [String!]) {
  genericPrograms(perPage: $perPage, page: $page, query: $search, languages: $languages, instructor: $instructor, sort: $sortBy, theme: $theme, category: $category, tags: $tags) {
    page
    totalCount
    data {
      ...EssentialGenericFields
      discount {
        discountType
        discountValue
        discountedPrice
        endDate
        identifier
        startDate
      }
    }
  }
}
    ${EssentialGenericFieldsFragmentDoc}`;

/**
 * __useGenericProgramsQuery__
 *
 * To run a query within a React component, call `useGenericProgramsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenericProgramsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenericProgramsQuery({
 *   variables: {
 *      perPage: // value for 'perPage'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *      languages: // value for 'languages'
 *      instructor: // value for 'instructor'
 *      sortBy: // value for 'sortBy'
 *      theme: // value for 'theme'
 *      category: // value for 'category'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useGenericProgramsQuery(baseOptions?: Apollo.QueryHookOptions<GenericProgramsQuery, GenericProgramsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenericProgramsQuery, GenericProgramsQueryVariables>(GenericProgramsDocument, options);
      }
export function useGenericProgramsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenericProgramsQuery, GenericProgramsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenericProgramsQuery, GenericProgramsQueryVariables>(GenericProgramsDocument, options);
        }
export type GenericProgramsQueryHookResult = ReturnType<typeof useGenericProgramsQuery>;
export type GenericProgramsLazyQueryHookResult = ReturnType<typeof useGenericProgramsLazyQuery>;
export type GenericProgramsQueryResult = Apollo.QueryResult<GenericProgramsQuery, GenericProgramsQueryVariables>;
export function refetchGenericProgramsQuery(variables?: GenericProgramsQueryVariables) {
      return { query: GenericProgramsDocument, variables: variables }
    }
export const PlaylistDocument = gql`
    query playlist($id: ID!) {
  playlist(id: $id) {
    ...PlaylistEssentialFields
  }
}
    ${PlaylistEssentialFieldsFragmentDoc}`;

/**
 * __usePlaylistQuery__
 *
 * To run a query within a React component, call `usePlaylistQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlaylistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlaylistQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePlaylistQuery(baseOptions: Apollo.QueryHookOptions<PlaylistQuery, PlaylistQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlaylistQuery, PlaylistQueryVariables>(PlaylistDocument, options);
      }
export function usePlaylistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlaylistQuery, PlaylistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlaylistQuery, PlaylistQueryVariables>(PlaylistDocument, options);
        }
export type PlaylistQueryHookResult = ReturnType<typeof usePlaylistQuery>;
export type PlaylistLazyQueryHookResult = ReturnType<typeof usePlaylistLazyQuery>;
export type PlaylistQueryResult = Apollo.QueryResult<PlaylistQuery, PlaylistQueryVariables>;
export function refetchPlaylistQuery(variables: PlaylistQueryVariables) {
      return { query: PlaylistDocument, variables: variables }
    }
export const VideosDocument = gql`
    query videos($taxonomies: [TaxonomyInput!], $page: Int, $perPage: Int, $genre: String, $query: String, $useLocale: Boolean, $contentLanguages: [String], $excludeTerms: [String], $videoLevels: [String], $orderBy: VideoOrderBy) {
  videos(taxonomies: $taxonomies, perPage: $perPage, page: $page, genre: $genre, query: $query, useLocale: $useLocale, contentLanguages: $contentLanguages, excludeTerms: $excludeTerms, videoLevels: $videoLevels, orderBy: $orderBy) {
    page
    perPage
    totalCount
    data {
      ...VideoFields
    }
  }
}
    ${VideoFieldsFragmentDoc}`;

/**
 * __useVideosQuery__
 *
 * To run a query within a React component, call `useVideosQuery` and pass it any options that fit your needs.
 * When your component renders, `useVideosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVideosQuery({
 *   variables: {
 *      taxonomies: // value for 'taxonomies'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      genre: // value for 'genre'
 *      query: // value for 'query'
 *      useLocale: // value for 'useLocale'
 *      contentLanguages: // value for 'contentLanguages'
 *      excludeTerms: // value for 'excludeTerms'
 *      videoLevels: // value for 'videoLevels'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useVideosQuery(baseOptions?: Apollo.QueryHookOptions<VideosQuery, VideosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VideosQuery, VideosQueryVariables>(VideosDocument, options);
      }
export function useVideosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VideosQuery, VideosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VideosQuery, VideosQueryVariables>(VideosDocument, options);
        }
export type VideosQueryHookResult = ReturnType<typeof useVideosQuery>;
export type VideosLazyQueryHookResult = ReturnType<typeof useVideosLazyQuery>;
export type VideosQueryResult = Apollo.QueryResult<VideosQuery, VideosQueryVariables>;
export function refetchVideosQuery(variables?: VideosQueryVariables) {
      return { query: VideosDocument, variables: variables }
    }
export const LastWatchedSessionsDocument = gql`
    query lastWatchedSessions {
  lastWatchedSessions {
    ...VideoFields
  }
}
    ${VideoFieldsFragmentDoc}`;

/**
 * __useLastWatchedSessionsQuery__
 *
 * To run a query within a React component, call `useLastWatchedSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLastWatchedSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLastWatchedSessionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useLastWatchedSessionsQuery(baseOptions?: Apollo.QueryHookOptions<LastWatchedSessionsQuery, LastWatchedSessionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LastWatchedSessionsQuery, LastWatchedSessionsQueryVariables>(LastWatchedSessionsDocument, options);
      }
export function useLastWatchedSessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LastWatchedSessionsQuery, LastWatchedSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LastWatchedSessionsQuery, LastWatchedSessionsQueryVariables>(LastWatchedSessionsDocument, options);
        }
export type LastWatchedSessionsQueryHookResult = ReturnType<typeof useLastWatchedSessionsQuery>;
export type LastWatchedSessionsLazyQueryHookResult = ReturnType<typeof useLastWatchedSessionsLazyQuery>;
export type LastWatchedSessionsQueryResult = Apollo.QueryResult<LastWatchedSessionsQuery, LastWatchedSessionsQueryVariables>;
export function refetchLastWatchedSessionsQuery(variables?: LastWatchedSessionsQueryVariables) {
      return { query: LastWatchedSessionsDocument, variables: variables }
    }
export const LiveEventCodesDocument = gql`
    query liveEventCodes {
  liveEventCodes {
    trial {
      ...LiveCodeDataFields
    }
    wellness {
      ...LiveCodeDataFields
    }
  }
}
    ${LiveCodeDataFieldsFragmentDoc}`;

/**
 * __useLiveEventCodesQuery__
 *
 * To run a query within a React component, call `useLiveEventCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLiveEventCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveEventCodesQuery({
 *   variables: {
 *   },
 * });
 */
export function useLiveEventCodesQuery(baseOptions?: Apollo.QueryHookOptions<LiveEventCodesQuery, LiveEventCodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LiveEventCodesQuery, LiveEventCodesQueryVariables>(LiveEventCodesDocument, options);
      }
export function useLiveEventCodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LiveEventCodesQuery, LiveEventCodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LiveEventCodesQuery, LiveEventCodesQueryVariables>(LiveEventCodesDocument, options);
        }
export type LiveEventCodesQueryHookResult = ReturnType<typeof useLiveEventCodesQuery>;
export type LiveEventCodesLazyQueryHookResult = ReturnType<typeof useLiveEventCodesLazyQuery>;
export type LiveEventCodesQueryResult = Apollo.QueryResult<LiveEventCodesQuery, LiveEventCodesQueryVariables>;
export function refetchLiveEventCodesQuery(variables?: LiveEventCodesQueryVariables) {
      return { query: LiveEventCodesDocument, variables: variables }
    }
export const ParticipateInAnEventDocument = gql`
    mutation participateInAnEvent($slug: String!) {
  participateInAnEvent(slug: $slug) {
    success
    errors {
      message
    }
  }
}
    `;
export type ParticipateInAnEventMutationFn = Apollo.MutationFunction<ParticipateInAnEventMutation, ParticipateInAnEventMutationVariables>;

/**
 * __useParticipateInAnEventMutation__
 *
 * To run a mutation, you first call `useParticipateInAnEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useParticipateInAnEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [participateInAnEventMutation, { data, loading, error }] = useParticipateInAnEventMutation({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useParticipateInAnEventMutation(baseOptions?: Apollo.MutationHookOptions<ParticipateInAnEventMutation, ParticipateInAnEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ParticipateInAnEventMutation, ParticipateInAnEventMutationVariables>(ParticipateInAnEventDocument, options);
      }
export type ParticipateInAnEventMutationHookResult = ReturnType<typeof useParticipateInAnEventMutation>;
export type ParticipateInAnEventMutationResult = Apollo.MutationResult<ParticipateInAnEventMutation>;
export type ParticipateInAnEventMutationOptions = Apollo.BaseMutationOptions<ParticipateInAnEventMutation, ParticipateInAnEventMutationVariables>;
export const ActivateLiveEventDocument = gql`
    mutation activateLiveEvent($slug: String!, $code: String!) {
  activateLiveEvent(slug: $slug, code: $code) {
    success
    errors
  }
}
    `;
export type ActivateLiveEventMutationFn = Apollo.MutationFunction<ActivateLiveEventMutation, ActivateLiveEventMutationVariables>;

/**
 * __useActivateLiveEventMutation__
 *
 * To run a mutation, you first call `useActivateLiveEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateLiveEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateLiveEventMutation, { data, loading, error }] = useActivateLiveEventMutation({
 *   variables: {
 *      slug: // value for 'slug'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useActivateLiveEventMutation(baseOptions?: Apollo.MutationHookOptions<ActivateLiveEventMutation, ActivateLiveEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateLiveEventMutation, ActivateLiveEventMutationVariables>(ActivateLiveEventDocument, options);
      }
export type ActivateLiveEventMutationHookResult = ReturnType<typeof useActivateLiveEventMutation>;
export type ActivateLiveEventMutationResult = Apollo.MutationResult<ActivateLiveEventMutation>;
export type ActivateLiveEventMutationOptions = Apollo.BaseMutationOptions<ActivateLiveEventMutation, ActivateLiveEventMutationVariables>;
export const LiveEventDocument = gql`
    query liveEvent($slug: String!) {
  liveEvent(slug: $slug) {
    ...FullLiveEventFields
  }
}
    ${FullLiveEventFieldsFragmentDoc}`;

/**
 * __useLiveEventQuery__
 *
 * To run a query within a React component, call `useLiveEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useLiveEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveEventQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useLiveEventQuery(baseOptions: Apollo.QueryHookOptions<LiveEventQuery, LiveEventQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LiveEventQuery, LiveEventQueryVariables>(LiveEventDocument, options);
      }
export function useLiveEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LiveEventQuery, LiveEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LiveEventQuery, LiveEventQueryVariables>(LiveEventDocument, options);
        }
export type LiveEventQueryHookResult = ReturnType<typeof useLiveEventQuery>;
export type LiveEventLazyQueryHookResult = ReturnType<typeof useLiveEventLazyQuery>;
export type LiveEventQueryResult = Apollo.QueryResult<LiveEventQuery, LiveEventQueryVariables>;
export function refetchLiveEventQuery(variables: LiveEventQueryVariables) {
      return { query: LiveEventDocument, variables: variables }
    }
export const ValidateLiveEventCodeDocument = gql`
    query validateLiveEventCode($slug: String!, $code: String!) {
  validateLiveEventCode(slug: $slug, code: $code) {
    code
    message
    status
  }
}
    `;

/**
 * __useValidateLiveEventCodeQuery__
 *
 * To run a query within a React component, call `useValidateLiveEventCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateLiveEventCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateLiveEventCodeQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useValidateLiveEventCodeQuery(baseOptions: Apollo.QueryHookOptions<ValidateLiveEventCodeQuery, ValidateLiveEventCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateLiveEventCodeQuery, ValidateLiveEventCodeQueryVariables>(ValidateLiveEventCodeDocument, options);
      }
export function useValidateLiveEventCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateLiveEventCodeQuery, ValidateLiveEventCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateLiveEventCodeQuery, ValidateLiveEventCodeQueryVariables>(ValidateLiveEventCodeDocument, options);
        }
export type ValidateLiveEventCodeQueryHookResult = ReturnType<typeof useValidateLiveEventCodeQuery>;
export type ValidateLiveEventCodeLazyQueryHookResult = ReturnType<typeof useValidateLiveEventCodeLazyQuery>;
export type ValidateLiveEventCodeQueryResult = Apollo.QueryResult<ValidateLiveEventCodeQuery, ValidateLiveEventCodeQueryVariables>;
export function refetchValidateLiveEventCodeQuery(variables: ValidateLiveEventCodeQueryVariables) {
      return { query: ValidateLiveEventCodeDocument, variables: variables }
    }
export const LiveEventsDocument = gql`
    query liveEvents($perPage: Int = 12, $page: Int, $search: String, $languages: [LanguageKind!], $instructor: String, $sortBy: LiveEventSortAttribute, $kind: LiveEventKind) {
  liveEvents(perPage: $perPage, page: $page, keyword: $search, languages: $languages, instructor: $instructor, sortBy: $sortBy, kind: $kind) {
    page
    totalCount
    availableKinds
    data {
      ...LiveEventEssentialFields
    }
  }
}
    ${LiveEventEssentialFieldsFragmentDoc}`;

/**
 * __useLiveEventsQuery__
 *
 * To run a query within a React component, call `useLiveEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLiveEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveEventsQuery({
 *   variables: {
 *      perPage: // value for 'perPage'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *      languages: // value for 'languages'
 *      instructor: // value for 'instructor'
 *      sortBy: // value for 'sortBy'
 *      kind: // value for 'kind'
 *   },
 * });
 */
export function useLiveEventsQuery(baseOptions?: Apollo.QueryHookOptions<LiveEventsQuery, LiveEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LiveEventsQuery, LiveEventsQueryVariables>(LiveEventsDocument, options);
      }
export function useLiveEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LiveEventsQuery, LiveEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LiveEventsQuery, LiveEventsQueryVariables>(LiveEventsDocument, options);
        }
export type LiveEventsQueryHookResult = ReturnType<typeof useLiveEventsQuery>;
export type LiveEventsLazyQueryHookResult = ReturnType<typeof useLiveEventsLazyQuery>;
export type LiveEventsQueryResult = Apollo.QueryResult<LiveEventsQuery, LiveEventsQueryVariables>;
export function refetchLiveEventsQuery(variables?: LiveEventsQueryVariables) {
      return { query: LiveEventsDocument, variables: variables }
    }
export const OrderDocument = gql`
    query Order($id: String!) {
  order(id: $id) {
    ... on GenericProgramPayment {
      success
      amountCents
      amountCurrency
      orderId
      originalAmountCents
      paymentProvider
      voucher
      program {
        id
        slug
        title
        category
      }
    }
    ... on LiveEventPayment {
      success
      amountCents
      amountCurrency
      orderId
      originalAmountCents
      paymentProvider
      live {
        id
        slug
        title
      }
    }
    ... on SubscriptionPayment {
      amountCents
      amountCurrency
      months
      orderId
      originalAmountCents
      paymentProvider
      recurringAmountCents
      recurringDate
      success
    }
  }
}
    `;

/**
 * __useOrderQuery__
 *
 * To run a query within a React component, call `useOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrderQuery(baseOptions: Apollo.QueryHookOptions<OrderQuery, OrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderQuery, OrderQueryVariables>(OrderDocument, options);
      }
export function useOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderQuery, OrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderQuery, OrderQueryVariables>(OrderDocument, options);
        }
export type OrderQueryHookResult = ReturnType<typeof useOrderQuery>;
export type OrderLazyQueryHookResult = ReturnType<typeof useOrderLazyQuery>;
export type OrderQueryResult = Apollo.QueryResult<OrderQuery, OrderQueryVariables>;
export function refetchOrderQuery(variables: OrderQueryVariables) {
      return { query: OrderDocument, variables: variables }
    }
export const PayForItemDocument = gql`
    mutation payForItem($slug: String!, $paymentMethod: PaymentMethodInput!, $riskData: RiskDataInput, $redirectToSuccess: String, $redirectToFailed: String, $browserInfo: BrowserInfoInput, $itemKind: ItemKind!, $discountCode: String) {
  payForItem(slug: $slug, paymentMethod: $paymentMethod, riskData: $riskData, browserInfo: $browserInfo, itemKind: $itemKind, discountCode: $discountCode, redirectToSuccess: $redirectToSuccess, redirectToFailed: $redirectToFailed) {
    orderId
    resultAction {
      actionType
      url
      httpMethod
      paymentMethodType
      paymentData
      redirectData
    }
    resultCode
    transaction
    errors {
      message
    }
  }
}
    `;
export type PayForItemMutationFn = Apollo.MutationFunction<PayForItemMutation, PayForItemMutationVariables>;

/**
 * __usePayForItemMutation__
 *
 * To run a mutation, you first call `usePayForItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePayForItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [payForItemMutation, { data, loading, error }] = usePayForItemMutation({
 *   variables: {
 *      slug: // value for 'slug'
 *      paymentMethod: // value for 'paymentMethod'
 *      riskData: // value for 'riskData'
 *      redirectToSuccess: // value for 'redirectToSuccess'
 *      redirectToFailed: // value for 'redirectToFailed'
 *      browserInfo: // value for 'browserInfo'
 *      itemKind: // value for 'itemKind'
 *      discountCode: // value for 'discountCode'
 *   },
 * });
 */
export function usePayForItemMutation(baseOptions?: Apollo.MutationHookOptions<PayForItemMutation, PayForItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PayForItemMutation, PayForItemMutationVariables>(PayForItemDocument, options);
      }
export type PayForItemMutationHookResult = ReturnType<typeof usePayForItemMutation>;
export type PayForItemMutationResult = Apollo.MutationResult<PayForItemMutation>;
export type PayForItemMutationOptions = Apollo.BaseMutationOptions<PayForItemMutation, PayForItemMutationVariables>;
export const PayForVoucherDocument = gql`
    mutation payForVoucher($slug: String!, $paymentMethod: PaymentMethodInput!, $itemKind: ItemKind!, $redirectToSuccess: String, $redirectToFailed: String, $riskData: RiskDataInput, $browserInfo: BrowserInfoInput, $discountCode: String, $senderName: String!, $recipientName: String!, $recipientEmail: String!, $sendGiftEmail: Boolean!, $customMessage: String) {
  payForVoucher(slug: $slug, paymentMethod: $paymentMethod, itemKind: $itemKind, redirectToSuccess: $redirectToSuccess, redirectToFailed: $redirectToFailed, riskData: $riskData, browserInfo: $browserInfo, discountCode: $discountCode, senderName: $senderName, recipientName: $recipientName, recipientEmail: $recipientEmail, customMessage: $customMessage, sendGiftEmail: $sendGiftEmail) {
    orderId
    resultCode
    transaction
    resultAction {
      actionType
      url
      httpMethod
      paymentMethodType
      paymentData
      redirectData
    }
    errors {
      message
    }
  }
}
    `;
export type PayForVoucherMutationFn = Apollo.MutationFunction<PayForVoucherMutation, PayForVoucherMutationVariables>;

/**
 * __usePayForVoucherMutation__
 *
 * To run a mutation, you first call `usePayForVoucherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePayForVoucherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [payForVoucherMutation, { data, loading, error }] = usePayForVoucherMutation({
 *   variables: {
 *      slug: // value for 'slug'
 *      paymentMethod: // value for 'paymentMethod'
 *      itemKind: // value for 'itemKind'
 *      redirectToSuccess: // value for 'redirectToSuccess'
 *      redirectToFailed: // value for 'redirectToFailed'
 *      riskData: // value for 'riskData'
 *      browserInfo: // value for 'browserInfo'
 *      discountCode: // value for 'discountCode'
 *      senderName: // value for 'senderName'
 *      recipientName: // value for 'recipientName'
 *      recipientEmail: // value for 'recipientEmail'
 *      sendGiftEmail: // value for 'sendGiftEmail'
 *      customMessage: // value for 'customMessage'
 *   },
 * });
 */
export function usePayForVoucherMutation(baseOptions?: Apollo.MutationHookOptions<PayForVoucherMutation, PayForVoucherMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PayForVoucherMutation, PayForVoucherMutationVariables>(PayForVoucherDocument, options);
      }
export type PayForVoucherMutationHookResult = ReturnType<typeof usePayForVoucherMutation>;
export type PayForVoucherMutationResult = Apollo.MutationResult<PayForVoucherMutation>;
export type PayForVoucherMutationOptions = Apollo.BaseMutationOptions<PayForVoucherMutation, PayForVoucherMutationVariables>;
export const PhasedProgramDocument = gql`
    query phasedProgram($slug: String!) {
  phasedProgram(slug: $slug) {
    ...PhasedProgramFields
  }
}
    ${PhasedProgramFieldsFragmentDoc}`;

/**
 * __usePhasedProgramQuery__
 *
 * To run a query within a React component, call `usePhasedProgramQuery` and pass it any options that fit your needs.
 * When your component renders, `usePhasedProgramQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePhasedProgramQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function usePhasedProgramQuery(baseOptions: Apollo.QueryHookOptions<PhasedProgramQuery, PhasedProgramQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PhasedProgramQuery, PhasedProgramQueryVariables>(PhasedProgramDocument, options);
      }
export function usePhasedProgramLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PhasedProgramQuery, PhasedProgramQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PhasedProgramQuery, PhasedProgramQueryVariables>(PhasedProgramDocument, options);
        }
export type PhasedProgramQueryHookResult = ReturnType<typeof usePhasedProgramQuery>;
export type PhasedProgramLazyQueryHookResult = ReturnType<typeof usePhasedProgramLazyQuery>;
export type PhasedProgramQueryResult = Apollo.QueryResult<PhasedProgramQuery, PhasedProgramQueryVariables>;
export function refetchPhasedProgramQuery(variables: PhasedProgramQueryVariables) {
      return { query: PhasedProgramDocument, variables: variables }
    }
export const AddFavoritePlaylistDocument = gql`
    mutation addFavoritePlaylist($playlistId: ID!) {
  addFavoritePlaylist(playlistId: $playlistId) {
    playlist {
      favorited
    }
  }
}
    `;
export type AddFavoritePlaylistMutationFn = Apollo.MutationFunction<AddFavoritePlaylistMutation, AddFavoritePlaylistMutationVariables>;

/**
 * __useAddFavoritePlaylistMutation__
 *
 * To run a mutation, you first call `useAddFavoritePlaylistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFavoritePlaylistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFavoritePlaylistMutation, { data, loading, error }] = useAddFavoritePlaylistMutation({
 *   variables: {
 *      playlistId: // value for 'playlistId'
 *   },
 * });
 */
export function useAddFavoritePlaylistMutation(baseOptions?: Apollo.MutationHookOptions<AddFavoritePlaylistMutation, AddFavoritePlaylistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddFavoritePlaylistMutation, AddFavoritePlaylistMutationVariables>(AddFavoritePlaylistDocument, options);
      }
export type AddFavoritePlaylistMutationHookResult = ReturnType<typeof useAddFavoritePlaylistMutation>;
export type AddFavoritePlaylistMutationResult = Apollo.MutationResult<AddFavoritePlaylistMutation>;
export type AddFavoritePlaylistMutationOptions = Apollo.BaseMutationOptions<AddFavoritePlaylistMutation, AddFavoritePlaylistMutationVariables>;
export const DeleteFavoritePlaylistDocument = gql`
    mutation deleteFavoritePlaylist($playlistId: ID!) {
  deleteFavoritePlaylist(playlistId: $playlistId) {
    playlist {
      favorited
    }
  }
}
    `;
export type DeleteFavoritePlaylistMutationFn = Apollo.MutationFunction<DeleteFavoritePlaylistMutation, DeleteFavoritePlaylistMutationVariables>;

/**
 * __useDeleteFavoritePlaylistMutation__
 *
 * To run a mutation, you first call `useDeleteFavoritePlaylistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFavoritePlaylistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFavoritePlaylistMutation, { data, loading, error }] = useDeleteFavoritePlaylistMutation({
 *   variables: {
 *      playlistId: // value for 'playlistId'
 *   },
 * });
 */
export function useDeleteFavoritePlaylistMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFavoritePlaylistMutation, DeleteFavoritePlaylistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFavoritePlaylistMutation, DeleteFavoritePlaylistMutationVariables>(DeleteFavoritePlaylistDocument, options);
      }
export type DeleteFavoritePlaylistMutationHookResult = ReturnType<typeof useDeleteFavoritePlaylistMutation>;
export type DeleteFavoritePlaylistMutationResult = Apollo.MutationResult<DeleteFavoritePlaylistMutation>;
export type DeleteFavoritePlaylistMutationOptions = Apollo.BaseMutationOptions<DeleteFavoritePlaylistMutation, DeleteFavoritePlaylistMutationVariables>;
export const AutocompleteDocument = gql`
    query autocomplete($query: String!) {
  autocomplete(query: $query) {
    query
    error
    results
  }
}
    `;

/**
 * __useAutocompleteQuery__
 *
 * To run a query within a React component, call `useAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutocompleteQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useAutocompleteQuery(baseOptions: Apollo.QueryHookOptions<AutocompleteQuery, AutocompleteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AutocompleteQuery, AutocompleteQueryVariables>(AutocompleteDocument, options);
      }
export function useAutocompleteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AutocompleteQuery, AutocompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AutocompleteQuery, AutocompleteQueryVariables>(AutocompleteDocument, options);
        }
export type AutocompleteQueryHookResult = ReturnType<typeof useAutocompleteQuery>;
export type AutocompleteLazyQueryHookResult = ReturnType<typeof useAutocompleteLazyQuery>;
export type AutocompleteQueryResult = Apollo.QueryResult<AutocompleteQuery, AutocompleteQueryVariables>;
export function refetchAutocompleteQuery(variables: AutocompleteQueryVariables) {
      return { query: AutocompleteDocument, variables: variables }
    }
export const SpecificSearchDocument = gql`
    query specificSearch($query: String!, $page: Int = 1, $perPage: Int = 10, $modelType: ModelNameKind!, $languages: [LanguageKind!]!) {
  specificSearch(query: $query, page: $page, perPage: $perPage, modelType: $modelType, languages: $languages) {
    query
    blogPosts {
      page
      perPage
      totalCount
      results {
        __typename
        ... on SearchBlogPost {
          ...SearchBlogPostFields
        }
      }
    }
    challenges {
      page
      perPage
      totalCount
      results {
        __typename
        ... on SearchGenericProgram {
          ...SearchGenericProgramFields
        }
      }
    }
    events {
      page
      perPage
      totalCount
      results {
        __typename
        ... on SearchEvent {
          ...SearchEventFields
        }
      }
    }
    genericPrograms {
      page
      perPage
      totalCount
      results {
        __typename
        ... on SearchGenericProgram {
          ...SearchGenericProgramFields
        }
      }
    }
    challenges {
      page
      perPage
      totalCount
      results {
        __typename
        ... on SearchGenericProgram {
          ...SearchGenericProgramFields
        }
      }
    }
    courses {
      page
      perPage
      totalCount
      results {
        __typename
        ... on SearchGenericProgram {
          ...SearchGenericProgramFields
        }
      }
    }
    instructors {
      page
      perPage
      totalCount
      results {
        __typename
        ... on SearchInstructor {
          ...SearchInstructorFields
        }
      }
    }
    landingPages {
      page
      perPage
      totalCount
      results {
        __typename
        ... on SearchLandingPage {
          ...SearchLandingPageFields
        }
      }
    }
    liveEvents {
      page
      perPage
      totalCount
      results {
        __typename
        ... on SearchLiveEvent {
          ...SearchLiveEventFields
        }
      }
    }
    playlists {
      page
      perPage
      totalCount
      results {
        __typename
        ... on SearchPlaylist {
          ...SearchPlaylistFields
        }
      }
    }
    videos {
      page
      perPage
      totalCount
      results {
        __typename
        ... on SearchVideo {
          ...SearchVideoFields
        }
      }
    }
  }
}
    ${SearchBlogPostFieldsFragmentDoc}
${SearchGenericProgramFieldsFragmentDoc}
${SearchEventFieldsFragmentDoc}
${SearchInstructorFieldsFragmentDoc}
${SearchLandingPageFieldsFragmentDoc}
${SearchLiveEventFieldsFragmentDoc}
${SearchPlaylistFieldsFragmentDoc}
${SearchVideoFieldsFragmentDoc}`;

/**
 * __useSpecificSearchQuery__
 *
 * To run a query within a React component, call `useSpecificSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpecificSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpecificSearchQuery({
 *   variables: {
 *      query: // value for 'query'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      modelType: // value for 'modelType'
 *      languages: // value for 'languages'
 *   },
 * });
 */
export function useSpecificSearchQuery(baseOptions: Apollo.QueryHookOptions<SpecificSearchQuery, SpecificSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SpecificSearchQuery, SpecificSearchQueryVariables>(SpecificSearchDocument, options);
      }
export function useSpecificSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SpecificSearchQuery, SpecificSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SpecificSearchQuery, SpecificSearchQueryVariables>(SpecificSearchDocument, options);
        }
export type SpecificSearchQueryHookResult = ReturnType<typeof useSpecificSearchQuery>;
export type SpecificSearchLazyQueryHookResult = ReturnType<typeof useSpecificSearchLazyQuery>;
export type SpecificSearchQueryResult = Apollo.QueryResult<SpecificSearchQuery, SpecificSearchQueryVariables>;
export function refetchSpecificSearchQuery(variables: SpecificSearchQueryVariables) {
      return { query: SpecificSearchDocument, variables: variables }
    }
export const SearchDocument = gql`
    query Search($query: String!, $searchType: GlobalSearch!, $languages: [LanguageKind!]!) {
  search(query: $query, searchType: $searchType, languages: $languages) {
    query
    blogPosts {
      page
      perPage
      totalCount
      results {
        __typename
        ... on SearchBlogPost {
          ...SearchBlogPostFields
        }
      }
    }
    challenges {
      page
      perPage
      totalCount
      results {
        __typename
        ... on SearchGenericProgram {
          ...SearchGenericProgramFields
        }
      }
    }
    events {
      page
      perPage
      totalCount
      results {
        __typename
        ... on SearchEvent {
          ...SearchEventFields
        }
      }
    }
    genericPrograms {
      page
      perPage
      totalCount
      results {
        __typename
        ... on SearchGenericProgram {
          ...SearchGenericProgramFields
        }
      }
    }
    challenges {
      page
      perPage
      totalCount
      results {
        __typename
        ... on SearchGenericProgram {
          ...SearchGenericProgramFields
        }
      }
    }
    courses {
      page
      perPage
      totalCount
      results {
        __typename
        ... on SearchGenericProgram {
          ...SearchGenericProgramFields
        }
      }
    }
    instructors {
      page
      perPage
      totalCount
      results {
        __typename
        ... on SearchInstructor {
          ...SearchInstructorFields
        }
      }
    }
    landingPages {
      page
      perPage
      totalCount
      results {
        __typename
        ... on SearchLandingPage {
          ...SearchLandingPageFields
        }
      }
    }
    liveEvents {
      page
      perPage
      totalCount
      results {
        __typename
        ... on SearchLiveEvent {
          ...SearchLiveEventFields
        }
      }
    }
    playlists {
      page
      perPage
      totalCount
      results {
        __typename
        ... on SearchPlaylist {
          ...SearchPlaylistFields
        }
      }
    }
    videos {
      page
      perPage
      totalCount
      results {
        __typename
        ... on SearchVideo {
          ...SearchVideoFields
        }
      }
    }
  }
}
    ${SearchBlogPostFieldsFragmentDoc}
${SearchGenericProgramFieldsFragmentDoc}
${SearchEventFieldsFragmentDoc}
${SearchInstructorFieldsFragmentDoc}
${SearchLandingPageFieldsFragmentDoc}
${SearchLiveEventFieldsFragmentDoc}
${SearchPlaylistFieldsFragmentDoc}
${SearchVideoFieldsFragmentDoc}`;

/**
 * __useSearchQuery__
 *
 * To run a query within a React component, call `useSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchQuery({
 *   variables: {
 *      query: // value for 'query'
 *      searchType: // value for 'searchType'
 *      languages: // value for 'languages'
 *   },
 * });
 */
export function useSearchQuery(baseOptions: Apollo.QueryHookOptions<SearchQuery, SearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchQuery, SearchQueryVariables>(SearchDocument, options);
      }
export function useSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchQuery, SearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchQuery, SearchQueryVariables>(SearchDocument, options);
        }
export type SearchQueryHookResult = ReturnType<typeof useSearchQuery>;
export type SearchLazyQueryHookResult = ReturnType<typeof useSearchLazyQuery>;
export type SearchQueryResult = Apollo.QueryResult<SearchQuery, SearchQueryVariables>;
export function refetchSearchQuery(variables: SearchQueryVariables) {
      return { query: SearchDocument, variables: variables }
    }
export const AddSearchResultDocument = gql`
    mutation addSearchResult($modelType: ModelNameKind!, $documentId: String!, $query: String!) {
  addSearchResult(modelType: $modelType, documentId: $documentId, query: $query) {
    documentId
  }
}
    `;
export type AddSearchResultMutationFn = Apollo.MutationFunction<AddSearchResultMutation, AddSearchResultMutationVariables>;

/**
 * __useAddSearchResultMutation__
 *
 * To run a mutation, you first call `useAddSearchResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSearchResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSearchResultMutation, { data, loading, error }] = useAddSearchResultMutation({
 *   variables: {
 *      modelType: // value for 'modelType'
 *      documentId: // value for 'documentId'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useAddSearchResultMutation(baseOptions?: Apollo.MutationHookOptions<AddSearchResultMutation, AddSearchResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSearchResultMutation, AddSearchResultMutationVariables>(AddSearchResultDocument, options);
      }
export type AddSearchResultMutationHookResult = ReturnType<typeof useAddSearchResultMutation>;
export type AddSearchResultMutationResult = Apollo.MutationResult<AddSearchResultMutation>;
export type AddSearchResultMutationOptions = Apollo.BaseMutationOptions<AddSearchResultMutation, AddSearchResultMutationVariables>;
export const SignUpDocument = gql`
    mutation signUp($firstName: String!, $email: String!, $password: String!, $country: String!, $lastName: String, $utmSource: String, $utmMedium: String, $utmCampaign: String, $paymentType: String, $campaignCode: String) {
  signUpV2(firstName: $firstName, lastName: $lastName, email: $email, country: $country, password: $password, paymentType: $paymentType, campaignCode: $campaignCode, utmSource: $utmSource, utmMedium: $utmMedium, utmCampaign: $utmCampaign, platform: web) {
    user {
      id
      email
      gender
      country
      accessUntil
    }
    errors {
      message
    }
  }
}
    `;
export type SignUpMutationFn = Apollo.MutationFunction<SignUpMutation, SignUpMutationVariables>;

/**
 * __useSignUpMutation__
 *
 * To run a mutation, you first call `useSignUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUpMutation, { data, loading, error }] = useSignUpMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      country: // value for 'country'
 *      lastName: // value for 'lastName'
 *      utmSource: // value for 'utmSource'
 *      utmMedium: // value for 'utmMedium'
 *      utmCampaign: // value for 'utmCampaign'
 *      paymentType: // value for 'paymentType'
 *      campaignCode: // value for 'campaignCode'
 *   },
 * });
 */
export function useSignUpMutation(baseOptions?: Apollo.MutationHookOptions<SignUpMutation, SignUpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignUpMutation, SignUpMutationVariables>(SignUpDocument, options);
      }
export type SignUpMutationHookResult = ReturnType<typeof useSignUpMutation>;
export type SignUpMutationResult = Apollo.MutationResult<SignUpMutation>;
export type SignUpMutationOptions = Apollo.BaseMutationOptions<SignUpMutation, SignUpMutationVariables>;
export const SocialSignUpDocument = gql`
    mutation socialSignUp($provider: ProviderTypes!, $method: MethodTypes!, $code: String, $accessToken: String, $identityToken: String, $firstName: String, $lastName: String, $avatarFromUrl: String, $paymentType: String, $campaignCode: String, $utmSource: String, $utmMedium: String, $utmCampaign: String) {
  socialSignUp(provider: $provider, method: $method, code: $code, accessToken: $accessToken, identityToken: $identityToken, firstName: $firstName, lastName: $lastName, avatarFromUrl: $avatarFromUrl, paymentType: $paymentType, campaignCode: $campaignCode, utmSource: $utmSource, utmMedium: $utmMedium, utmCampaign: $utmCampaign, platform: web) {
    success
    user {
      id
    }
  }
}
    `;
export type SocialSignUpMutationFn = Apollo.MutationFunction<SocialSignUpMutation, SocialSignUpMutationVariables>;

/**
 * __useSocialSignUpMutation__
 *
 * To run a mutation, you first call `useSocialSignUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSocialSignUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [socialSignUpMutation, { data, loading, error }] = useSocialSignUpMutation({
 *   variables: {
 *      provider: // value for 'provider'
 *      method: // value for 'method'
 *      code: // value for 'code'
 *      accessToken: // value for 'accessToken'
 *      identityToken: // value for 'identityToken'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      avatarFromUrl: // value for 'avatarFromUrl'
 *      paymentType: // value for 'paymentType'
 *      campaignCode: // value for 'campaignCode'
 *      utmSource: // value for 'utmSource'
 *      utmMedium: // value for 'utmMedium'
 *      utmCampaign: // value for 'utmCampaign'
 *   },
 * });
 */
export function useSocialSignUpMutation(baseOptions?: Apollo.MutationHookOptions<SocialSignUpMutation, SocialSignUpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SocialSignUpMutation, SocialSignUpMutationVariables>(SocialSignUpDocument, options);
      }
export type SocialSignUpMutationHookResult = ReturnType<typeof useSocialSignUpMutation>;
export type SocialSignUpMutationResult = Apollo.MutationResult<SocialSignUpMutation>;
export type SocialSignUpMutationOptions = Apollo.BaseMutationOptions<SocialSignUpMutation, SocialSignUpMutationVariables>;
export const SocialSignInDocument = gql`
    mutation socialSignIn($provider: ProviderTypes!, $method: MethodTypes!, $code: String, $accessToken: String, $identityToken: String) {
  socialSignIn(provider: $provider, method: $method, code: $code, accessToken: $accessToken, identityToken: $identityToken, platform: web) {
    success
    user {
      id
    }
  }
}
    `;
export type SocialSignInMutationFn = Apollo.MutationFunction<SocialSignInMutation, SocialSignInMutationVariables>;

/**
 * __useSocialSignInMutation__
 *
 * To run a mutation, you first call `useSocialSignInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSocialSignInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [socialSignInMutation, { data, loading, error }] = useSocialSignInMutation({
 *   variables: {
 *      provider: // value for 'provider'
 *      method: // value for 'method'
 *      code: // value for 'code'
 *      accessToken: // value for 'accessToken'
 *      identityToken: // value for 'identityToken'
 *   },
 * });
 */
export function useSocialSignInMutation(baseOptions?: Apollo.MutationHookOptions<SocialSignInMutation, SocialSignInMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SocialSignInMutation, SocialSignInMutationVariables>(SocialSignInDocument, options);
      }
export type SocialSignInMutationHookResult = ReturnType<typeof useSocialSignInMutation>;
export type SocialSignInMutationResult = Apollo.MutationResult<SocialSignInMutation>;
export type SocialSignInMutationOptions = Apollo.BaseMutationOptions<SocialSignInMutation, SocialSignInMutationVariables>;
export const StartOverviewDocument = gql`
    query startOverview {
  startOverview {
    metaSection {
      description
      imageUrl
      title
    }
    heroSection {
      title
      description
      smallNote
      imageUrl
    }
    coursesSection {
      title
      description
      group1Title
      group1Description
      group1ButtonLink
      group1ButtonText
      group1ImageUrl
      group2Title
      group2Description
      group2ButtonLink
      group2ButtonText
      group2ImageUrl
    }
    campaignSection {
      title
      description
      buttonLink
      buttonText
      imageUrl
      tag
    }
    featuresSection {
      description
      featureBullets
      imageUrl
      title
    }
    genresSection {
      title
      description
      genre {
        title
        slug
        name
        description
        imageUrl
        otherType
        sectionType
      }
    }
    mobileAppSection {
      description
      imageUrl
      title
    }
    otherFeaturesSection {
      description
      title
      otherFeatures {
        description
        imageUrl
        name
        url
        otherType
        sectionType
        slug
        title
      }
    }
    videoLibrarySection {
      description
      title
      videosLibrary {
        slug
        title
        name
        description
        url
        imageUrl
        otherType
        sectionType
      }
    }
  }
}
    `;

/**
 * __useStartOverviewQuery__
 *
 * To run a query within a React component, call `useStartOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useStartOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStartOverviewQuery({
 *   variables: {
 *   },
 * });
 */
export function useStartOverviewQuery(baseOptions?: Apollo.QueryHookOptions<StartOverviewQuery, StartOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StartOverviewQuery, StartOverviewQueryVariables>(StartOverviewDocument, options);
      }
export function useStartOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StartOverviewQuery, StartOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StartOverviewQuery, StartOverviewQueryVariables>(StartOverviewDocument, options);
        }
export type StartOverviewQueryHookResult = ReturnType<typeof useStartOverviewQuery>;
export type StartOverviewLazyQueryHookResult = ReturnType<typeof useStartOverviewLazyQuery>;
export type StartOverviewQueryResult = Apollo.QueryResult<StartOverviewQuery, StartOverviewQueryVariables>;
export function refetchStartOverviewQuery(variables?: StartOverviewQueryVariables) {
      return { query: StartOverviewDocument, variables: variables }
    }
export const VideoWatchDocument = gql`
    mutation videoWatch($videoId: String!, $seconds: Int!, $cursorAt: Int!) {
  videoWatch(videoId: $videoId, seconds: $seconds, cursorAt: $cursorAt) {
    errors {
      message
    }
  }
}
    `;
export type VideoWatchMutationFn = Apollo.MutationFunction<VideoWatchMutation, VideoWatchMutationVariables>;

/**
 * __useVideoWatchMutation__
 *
 * To run a mutation, you first call `useVideoWatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVideoWatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [videoWatchMutation, { data, loading, error }] = useVideoWatchMutation({
 *   variables: {
 *      videoId: // value for 'videoId'
 *      seconds: // value for 'seconds'
 *      cursorAt: // value for 'cursorAt'
 *   },
 * });
 */
export function useVideoWatchMutation(baseOptions?: Apollo.MutationHookOptions<VideoWatchMutation, VideoWatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VideoWatchMutation, VideoWatchMutationVariables>(VideoWatchDocument, options);
      }
export type VideoWatchMutationHookResult = ReturnType<typeof useVideoWatchMutation>;
export type VideoWatchMutationResult = Apollo.MutationResult<VideoWatchMutation>;
export type VideoWatchMutationOptions = Apollo.BaseMutationOptions<VideoWatchMutation, VideoWatchMutationVariables>;
export const VideoWatchCompletedDocument = gql`
    mutation videoWatchCompleted($videoId: String!, $seconds: Int!, $cursorAt: Int!) {
  videoWatchCompleted(videoId: $videoId, seconds: $seconds, cursorAt: $cursorAt) {
    errors {
      message
    }
  }
}
    `;
export type VideoWatchCompletedMutationFn = Apollo.MutationFunction<VideoWatchCompletedMutation, VideoWatchCompletedMutationVariables>;

/**
 * __useVideoWatchCompletedMutation__
 *
 * To run a mutation, you first call `useVideoWatchCompletedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVideoWatchCompletedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [videoWatchCompletedMutation, { data, loading, error }] = useVideoWatchCompletedMutation({
 *   variables: {
 *      videoId: // value for 'videoId'
 *      seconds: // value for 'seconds'
 *      cursorAt: // value for 'cursorAt'
 *   },
 * });
 */
export function useVideoWatchCompletedMutation(baseOptions?: Apollo.MutationHookOptions<VideoWatchCompletedMutation, VideoWatchCompletedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VideoWatchCompletedMutation, VideoWatchCompletedMutationVariables>(VideoWatchCompletedDocument, options);
      }
export type VideoWatchCompletedMutationHookResult = ReturnType<typeof useVideoWatchCompletedMutation>;
export type VideoWatchCompletedMutationResult = Apollo.MutationResult<VideoWatchCompletedMutation>;
export type VideoWatchCompletedMutationOptions = Apollo.BaseMutationOptions<VideoWatchCompletedMutation, VideoWatchCompletedMutationVariables>;
export const UserStatsDocument = gql`
    query userStats($period: StatsPeriodKind) {
  userStats(period: $period) {
    numberOfChallengesStarted
    numberOfCoursesStarted
    numberOfLiveEventsBooked
    numberOfProgramsStarted
    playlistsCreated
    sessionsCompleted
    sessionsFavorited
    threeMostWatchedInstructors {
      id
      name
      assets {
        squareImage
      }
    }
    threeMostWatchedStyles {
      slug
      name
    }
    totalWatchTime
  }
}
    `;

/**
 * __useUserStatsQuery__
 *
 * To run a query within a React component, call `useUserStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserStatsQuery({
 *   variables: {
 *      period: // value for 'period'
 *   },
 * });
 */
export function useUserStatsQuery(baseOptions?: Apollo.QueryHookOptions<UserStatsQuery, UserStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserStatsQuery, UserStatsQueryVariables>(UserStatsDocument, options);
      }
export function useUserStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserStatsQuery, UserStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserStatsQuery, UserStatsQueryVariables>(UserStatsDocument, options);
        }
export type UserStatsQueryHookResult = ReturnType<typeof useUserStatsQuery>;
export type UserStatsLazyQueryHookResult = ReturnType<typeof useUserStatsLazyQuery>;
export type UserStatsQueryResult = Apollo.QueryResult<UserStatsQuery, UserStatsQueryVariables>;
export function refetchUserStatsQuery(variables?: UserStatsQueryVariables) {
      return { query: UserStatsDocument, variables: variables }
    }
export const ActivateFullAccessCodeDocument = gql`
    mutation activateFullAccessCode($promotionName: String!, $code: String!) {
  activateFullAccessCode(promotionName: $promotionName, code: $code) {
    success
    errors {
      message
    }
  }
}
    `;
export type ActivateFullAccessCodeMutationFn = Apollo.MutationFunction<ActivateFullAccessCodeMutation, ActivateFullAccessCodeMutationVariables>;

/**
 * __useActivateFullAccessCodeMutation__
 *
 * To run a mutation, you first call `useActivateFullAccessCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateFullAccessCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateFullAccessCodeMutation, { data, loading, error }] = useActivateFullAccessCodeMutation({
 *   variables: {
 *      promotionName: // value for 'promotionName'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useActivateFullAccessCodeMutation(baseOptions?: Apollo.MutationHookOptions<ActivateFullAccessCodeMutation, ActivateFullAccessCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateFullAccessCodeMutation, ActivateFullAccessCodeMutationVariables>(ActivateFullAccessCodeDocument, options);
      }
export type ActivateFullAccessCodeMutationHookResult = ReturnType<typeof useActivateFullAccessCodeMutation>;
export type ActivateFullAccessCodeMutationResult = Apollo.MutationResult<ActivateFullAccessCodeMutation>;
export type ActivateFullAccessCodeMutationOptions = Apollo.BaseMutationOptions<ActivateFullAccessCodeMutation, ActivateFullAccessCodeMutationVariables>;
export const ActivateOneTimeCodeDocument = gql`
    mutation activateOneTimeCode($promotionName: String!, $code: String!) {
  activateOneTimeCode(promotionName: $promotionName, code: $code) {
    success
    errors {
      message
    }
  }
}
    `;
export type ActivateOneTimeCodeMutationFn = Apollo.MutationFunction<ActivateOneTimeCodeMutation, ActivateOneTimeCodeMutationVariables>;

/**
 * __useActivateOneTimeCodeMutation__
 *
 * To run a mutation, you first call `useActivateOneTimeCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateOneTimeCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateOneTimeCodeMutation, { data, loading, error }] = useActivateOneTimeCodeMutation({
 *   variables: {
 *      promotionName: // value for 'promotionName'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useActivateOneTimeCodeMutation(baseOptions?: Apollo.MutationHookOptions<ActivateOneTimeCodeMutation, ActivateOneTimeCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateOneTimeCodeMutation, ActivateOneTimeCodeMutationVariables>(ActivateOneTimeCodeDocument, options);
      }
export type ActivateOneTimeCodeMutationHookResult = ReturnType<typeof useActivateOneTimeCodeMutation>;
export type ActivateOneTimeCodeMutationResult = Apollo.MutationResult<ActivateOneTimeCodeMutation>;
export type ActivateOneTimeCodeMutationOptions = Apollo.BaseMutationOptions<ActivateOneTimeCodeMutation, ActivateOneTimeCodeMutationVariables>;
export const PaymentsStoreAdyenDropinDocument = gql`
    mutation paymentsStoreAdyenDropin($redirectTo: String, $paymentType: String!, $riskData: RiskDataInput, $paymentMethod: PaymentMethodInput!, $storePaymentMethod: Boolean, $browserInfo: BrowserInfoInput) {
  paymentsStoreAdyenDropin(redirectTo: $redirectTo, paymentType: $paymentType, riskData: $riskData, paymentMethod: $paymentMethod, storePaymentMethod: $storePaymentMethod, browserInfo: $browserInfo) {
    orderId
    transaction
    recurringDate
    recurringPaymentAmount
    resultCode
    resultAction {
      actionType
      url
      httpMethod
      paymentMethodType
      paymentData
      redirectData
    }
    errors {
      message
    }
  }
}
    `;
export type PaymentsStoreAdyenDropinMutationFn = Apollo.MutationFunction<PaymentsStoreAdyenDropinMutation, PaymentsStoreAdyenDropinMutationVariables>;

/**
 * __usePaymentsStoreAdyenDropinMutation__
 *
 * To run a mutation, you first call `usePaymentsStoreAdyenDropinMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentsStoreAdyenDropinMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentsStoreAdyenDropinMutation, { data, loading, error }] = usePaymentsStoreAdyenDropinMutation({
 *   variables: {
 *      redirectTo: // value for 'redirectTo'
 *      paymentType: // value for 'paymentType'
 *      riskData: // value for 'riskData'
 *      paymentMethod: // value for 'paymentMethod'
 *      storePaymentMethod: // value for 'storePaymentMethod'
 *      browserInfo: // value for 'browserInfo'
 *   },
 * });
 */
export function usePaymentsStoreAdyenDropinMutation(baseOptions?: Apollo.MutationHookOptions<PaymentsStoreAdyenDropinMutation, PaymentsStoreAdyenDropinMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PaymentsStoreAdyenDropinMutation, PaymentsStoreAdyenDropinMutationVariables>(PaymentsStoreAdyenDropinDocument, options);
      }
export type PaymentsStoreAdyenDropinMutationHookResult = ReturnType<typeof usePaymentsStoreAdyenDropinMutation>;
export type PaymentsStoreAdyenDropinMutationResult = Apollo.MutationResult<PaymentsStoreAdyenDropinMutation>;
export type PaymentsStoreAdyenDropinMutationOptions = Apollo.BaseMutationOptions<PaymentsStoreAdyenDropinMutation, PaymentsStoreAdyenDropinMutationVariables>;
export const PaymentsStoreTrustlyDocument = gql`
    mutation paymentsStoreTrustly($paymentType: String!, $redirectTo: String) {
  paymentsStoreTrustly(paymentType: $paymentType, redirectTo: $redirectTo) {
    resultUrl
    recurringPaymentAmount
    recurringPaymentCurrency
    recurringDate
    transaction
    orderId
    errors {
      path
      message
    }
  }
}
    `;
export type PaymentsStoreTrustlyMutationFn = Apollo.MutationFunction<PaymentsStoreTrustlyMutation, PaymentsStoreTrustlyMutationVariables>;

/**
 * __usePaymentsStoreTrustlyMutation__
 *
 * To run a mutation, you first call `usePaymentsStoreTrustlyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentsStoreTrustlyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentsStoreTrustlyMutation, { data, loading, error }] = usePaymentsStoreTrustlyMutation({
 *   variables: {
 *      paymentType: // value for 'paymentType'
 *      redirectTo: // value for 'redirectTo'
 *   },
 * });
 */
export function usePaymentsStoreTrustlyMutation(baseOptions?: Apollo.MutationHookOptions<PaymentsStoreTrustlyMutation, PaymentsStoreTrustlyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PaymentsStoreTrustlyMutation, PaymentsStoreTrustlyMutationVariables>(PaymentsStoreTrustlyDocument, options);
      }
export type PaymentsStoreTrustlyMutationHookResult = ReturnType<typeof usePaymentsStoreTrustlyMutation>;
export type PaymentsStoreTrustlyMutationResult = Apollo.MutationResult<PaymentsStoreTrustlyMutation>;
export type PaymentsStoreTrustlyMutationOptions = Apollo.BaseMutationOptions<PaymentsStoreTrustlyMutation, PaymentsStoreTrustlyMutationVariables>;
export const SurveyDocument = gql`
    query survey($slug: String!) {
  survey(slug: $slug) {
    ...ProgramSurveyFields
  }
}
    ${ProgramSurveyFieldsFragmentDoc}`;

/**
 * __useSurveyQuery__
 *
 * To run a query within a React component, call `useSurveyQuery` and pass it any options that fit your needs.
 * When your component renders, `useSurveyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSurveyQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useSurveyQuery(baseOptions: Apollo.QueryHookOptions<SurveyQuery, SurveyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SurveyQuery, SurveyQueryVariables>(SurveyDocument, options);
      }
export function useSurveyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SurveyQuery, SurveyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SurveyQuery, SurveyQueryVariables>(SurveyDocument, options);
        }
export type SurveyQueryHookResult = ReturnType<typeof useSurveyQuery>;
export type SurveyLazyQueryHookResult = ReturnType<typeof useSurveyLazyQuery>;
export type SurveyQueryResult = Apollo.QueryResult<SurveyQuery, SurveyQueryVariables>;
export function refetchSurveyQuery(variables: SurveyQueryVariables) {
      return { query: SurveyDocument, variables: variables }
    }
export const GetSurveyDocument = gql`
    query GetSurvey($surveyPartId: Int!) {
  surveyPart(surveyPartId: $surveyPartId) {
    ...ProgramSurveyElementFields
  }
}
    ${ProgramSurveyElementFieldsFragmentDoc}`;

/**
 * __useGetSurveyQuery__
 *
 * To run a query within a React component, call `useGetSurveyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSurveyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSurveyQuery({
 *   variables: {
 *      surveyPartId: // value for 'surveyPartId'
 *   },
 * });
 */
export function useGetSurveyQuery(baseOptions: Apollo.QueryHookOptions<GetSurveyQuery, GetSurveyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSurveyQuery, GetSurveyQueryVariables>(GetSurveyDocument, options);
      }
export function useGetSurveyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSurveyQuery, GetSurveyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSurveyQuery, GetSurveyQueryVariables>(GetSurveyDocument, options);
        }
export type GetSurveyQueryHookResult = ReturnType<typeof useGetSurveyQuery>;
export type GetSurveyLazyQueryHookResult = ReturnType<typeof useGetSurveyLazyQuery>;
export type GetSurveyQueryResult = Apollo.QueryResult<GetSurveyQuery, GetSurveyQueryVariables>;
export function refetchGetSurveyQuery(variables: GetSurveyQueryVariables) {
      return { query: GetSurveyDocument, variables: variables }
    }
export const UserPlaylistsDocument = gql`
    query userPlaylists($id: ID, $page: Int, $perPage: Int) {
  userPlaylists(id: $id, page: $page, perPage: $perPage) {
    page
    perPage
    totalCount
    data {
      id
      identifier
      title
      visibility
      owner {
        id
        firstName
      }
      meta {
        videoCount
        minutes
      }
      description
      assets {
        thumbnailUrl
      }
      videos {
        id
      }
    }
  }
}
    `;

/**
 * __useUserPlaylistsQuery__
 *
 * To run a query within a React component, call `useUserPlaylistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserPlaylistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserPlaylistsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useUserPlaylistsQuery(baseOptions?: Apollo.QueryHookOptions<UserPlaylistsQuery, UserPlaylistsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserPlaylistsQuery, UserPlaylistsQueryVariables>(UserPlaylistsDocument, options);
      }
export function useUserPlaylistsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserPlaylistsQuery, UserPlaylistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserPlaylistsQuery, UserPlaylistsQueryVariables>(UserPlaylistsDocument, options);
        }
export type UserPlaylistsQueryHookResult = ReturnType<typeof useUserPlaylistsQuery>;
export type UserPlaylistsLazyQueryHookResult = ReturnType<typeof useUserPlaylistsLazyQuery>;
export type UserPlaylistsQueryResult = Apollo.QueryResult<UserPlaylistsQuery, UserPlaylistsQueryVariables>;
export function refetchUserPlaylistsQuery(variables?: UserPlaylistsQueryVariables) {
      return { query: UserPlaylistsDocument, variables: variables }
    }
export const RemoveVideoFromPlaylistDocument = gql`
    mutation removeVideoFromPlaylist($playlistId: ID!, $videoId: ID!) {
  removeVideoFromPlaylist(playlistId: $playlistId, videoId: $videoId) {
    playlist {
      id
    }
  }
}
    `;
export type RemoveVideoFromPlaylistMutationFn = Apollo.MutationFunction<RemoveVideoFromPlaylistMutation, RemoveVideoFromPlaylistMutationVariables>;

/**
 * __useRemoveVideoFromPlaylistMutation__
 *
 * To run a mutation, you first call `useRemoveVideoFromPlaylistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveVideoFromPlaylistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeVideoFromPlaylistMutation, { data, loading, error }] = useRemoveVideoFromPlaylistMutation({
 *   variables: {
 *      playlistId: // value for 'playlistId'
 *      videoId: // value for 'videoId'
 *   },
 * });
 */
export function useRemoveVideoFromPlaylistMutation(baseOptions?: Apollo.MutationHookOptions<RemoveVideoFromPlaylistMutation, RemoveVideoFromPlaylistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveVideoFromPlaylistMutation, RemoveVideoFromPlaylistMutationVariables>(RemoveVideoFromPlaylistDocument, options);
      }
export type RemoveVideoFromPlaylistMutationHookResult = ReturnType<typeof useRemoveVideoFromPlaylistMutation>;
export type RemoveVideoFromPlaylistMutationResult = Apollo.MutationResult<RemoveVideoFromPlaylistMutation>;
export type RemoveVideoFromPlaylistMutationOptions = Apollo.BaseMutationOptions<RemoveVideoFromPlaylistMutation, RemoveVideoFromPlaylistMutationVariables>;
export const AddVideoToPlaylistDocument = gql`
    mutation addVideoToPlaylist($playlistId: ID!, $videoId: ID!) {
  addVideoToPlaylist(playlistId: $playlistId, videoId: $videoId) {
    playlist {
      id
    }
  }
}
    `;
export type AddVideoToPlaylistMutationFn = Apollo.MutationFunction<AddVideoToPlaylistMutation, AddVideoToPlaylistMutationVariables>;

/**
 * __useAddVideoToPlaylistMutation__
 *
 * To run a mutation, you first call `useAddVideoToPlaylistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddVideoToPlaylistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addVideoToPlaylistMutation, { data, loading, error }] = useAddVideoToPlaylistMutation({
 *   variables: {
 *      playlistId: // value for 'playlistId'
 *      videoId: // value for 'videoId'
 *   },
 * });
 */
export function useAddVideoToPlaylistMutation(baseOptions?: Apollo.MutationHookOptions<AddVideoToPlaylistMutation, AddVideoToPlaylistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddVideoToPlaylistMutation, AddVideoToPlaylistMutationVariables>(AddVideoToPlaylistDocument, options);
      }
export type AddVideoToPlaylistMutationHookResult = ReturnType<typeof useAddVideoToPlaylistMutation>;
export type AddVideoToPlaylistMutationResult = Apollo.MutationResult<AddVideoToPlaylistMutation>;
export type AddVideoToPlaylistMutationOptions = Apollo.BaseMutationOptions<AddVideoToPlaylistMutation, AddVideoToPlaylistMutationVariables>;
export const DeleteFavoriteVideoDocument = gql`
    mutation deleteFavoriteVideo($videoId: ID!) {
  deleteFavoriteVideo(videoId: $videoId) {
    video {
      favorited
    }
  }
}
    `;
export type DeleteFavoriteVideoMutationFn = Apollo.MutationFunction<DeleteFavoriteVideoMutation, DeleteFavoriteVideoMutationVariables>;

/**
 * __useDeleteFavoriteVideoMutation__
 *
 * To run a mutation, you first call `useDeleteFavoriteVideoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFavoriteVideoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFavoriteVideoMutation, { data, loading, error }] = useDeleteFavoriteVideoMutation({
 *   variables: {
 *      videoId: // value for 'videoId'
 *   },
 * });
 */
export function useDeleteFavoriteVideoMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFavoriteVideoMutation, DeleteFavoriteVideoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFavoriteVideoMutation, DeleteFavoriteVideoMutationVariables>(DeleteFavoriteVideoDocument, options);
      }
export type DeleteFavoriteVideoMutationHookResult = ReturnType<typeof useDeleteFavoriteVideoMutation>;
export type DeleteFavoriteVideoMutationResult = Apollo.MutationResult<DeleteFavoriteVideoMutation>;
export type DeleteFavoriteVideoMutationOptions = Apollo.BaseMutationOptions<DeleteFavoriteVideoMutation, DeleteFavoriteVideoMutationVariables>;
export const AddFavoriteVideoDocument = gql`
    mutation addFavoriteVideo($videoId: ID!) {
  addFavoriteVideo(videoId: $videoId) {
    video {
      favorited
    }
  }
}
    `;
export type AddFavoriteVideoMutationFn = Apollo.MutationFunction<AddFavoriteVideoMutation, AddFavoriteVideoMutationVariables>;

/**
 * __useAddFavoriteVideoMutation__
 *
 * To run a mutation, you first call `useAddFavoriteVideoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFavoriteVideoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFavoriteVideoMutation, { data, loading, error }] = useAddFavoriteVideoMutation({
 *   variables: {
 *      videoId: // value for 'videoId'
 *   },
 * });
 */
export function useAddFavoriteVideoMutation(baseOptions?: Apollo.MutationHookOptions<AddFavoriteVideoMutation, AddFavoriteVideoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddFavoriteVideoMutation, AddFavoriteVideoMutationVariables>(AddFavoriteVideoDocument, options);
      }
export type AddFavoriteVideoMutationHookResult = ReturnType<typeof useAddFavoriteVideoMutation>;
export type AddFavoriteVideoMutationResult = Apollo.MutationResult<AddFavoriteVideoMutation>;
export type AddFavoriteVideoMutationOptions = Apollo.BaseMutationOptions<AddFavoriteVideoMutation, AddFavoriteVideoMutationVariables>;
export const TaxonomiesDocument = gql`
    query taxonomies($genre: String, $languages: [String!]) {
  taxonomies(genre: $genre, languages: $languages) {
    id
    name
    slug
    terms {
      id
      name
      slug
      important
    }
  }
}
    `;

/**
 * __useTaxonomiesQuery__
 *
 * To run a query within a React component, call `useTaxonomiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaxonomiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaxonomiesQuery({
 *   variables: {
 *      genre: // value for 'genre'
 *      languages: // value for 'languages'
 *   },
 * });
 */
export function useTaxonomiesQuery(baseOptions?: Apollo.QueryHookOptions<TaxonomiesQuery, TaxonomiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaxonomiesQuery, TaxonomiesQueryVariables>(TaxonomiesDocument, options);
      }
export function useTaxonomiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaxonomiesQuery, TaxonomiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaxonomiesQuery, TaxonomiesQueryVariables>(TaxonomiesDocument, options);
        }
export type TaxonomiesQueryHookResult = ReturnType<typeof useTaxonomiesQuery>;
export type TaxonomiesLazyQueryHookResult = ReturnType<typeof useTaxonomiesLazyQuery>;
export type TaxonomiesQueryResult = Apollo.QueryResult<TaxonomiesQuery, TaxonomiesQueryVariables>;
export function refetchTaxonomiesQuery(variables?: TaxonomiesQueryVariables) {
      return { query: TaxonomiesDocument, variables: variables }
    }
export const VideoDocument = gql`
    query video($id: ID!) {
  video(id: $id) {
    id
    kind
    hls
    identifier
    hasAccess
    cursorAt
    categories
    player {
      assets {
        src
        resolution
      }
    }
    crossPromotion {
      id
      slug
      title
      category
      description
      titleImageUrl
    }
    assets {
      thumbnailUrl
      thumbnailUrlMedium
    }
    primaryStyle {
      name
      slug
    }
    taxonomies {
      flavor {
        id
        name
      }
      needs {
        id
        name
      }
      instructors {
        id
        name
        slug
        shortDescription
        assets {
          squareImage
        }
      }
      genre {
        id
        name
        slug
      }
    }
    meta {
      minutes
    }
    content {
      title
      shortDescription
      longDescription
    }
  }
}
    `;

/**
 * __useVideoQuery__
 *
 * To run a query within a React component, call `useVideoQuery` and pass it any options that fit your needs.
 * When your component renders, `useVideoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVideoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVideoQuery(baseOptions: Apollo.QueryHookOptions<VideoQuery, VideoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VideoQuery, VideoQueryVariables>(VideoDocument, options);
      }
export function useVideoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VideoQuery, VideoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VideoQuery, VideoQueryVariables>(VideoDocument, options);
        }
export type VideoQueryHookResult = ReturnType<typeof useVideoQuery>;
export type VideoLazyQueryHookResult = ReturnType<typeof useVideoLazyQuery>;
export type VideoQueryResult = Apollo.QueryResult<VideoQuery, VideoQueryVariables>;
export function refetchVideoQuery(variables: VideoQueryVariables) {
      return { query: VideoDocument, variables: variables }
    }
export const InstructorByGenreDocument = gql`
    query instructorByGenre($genre: String, $instructor: String!, $languages: [String]) {
  instructorByGenre(genre: $genre, instructor: $instructor, languages: $languages) {
    instructor {
      id
      name
      assets {
        squareImage
      }
    }
    videosCountInGenres {
      channel
      slug
      count
    }
  }
}
    `;

/**
 * __useInstructorByGenreQuery__
 *
 * To run a query within a React component, call `useInstructorByGenreQuery` and pass it any options that fit your needs.
 * When your component renders, `useInstructorByGenreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInstructorByGenreQuery({
 *   variables: {
 *      genre: // value for 'genre'
 *      instructor: // value for 'instructor'
 *      languages: // value for 'languages'
 *   },
 * });
 */
export function useInstructorByGenreQuery(baseOptions: Apollo.QueryHookOptions<InstructorByGenreQuery, InstructorByGenreQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InstructorByGenreQuery, InstructorByGenreQueryVariables>(InstructorByGenreDocument, options);
      }
export function useInstructorByGenreLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InstructorByGenreQuery, InstructorByGenreQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InstructorByGenreQuery, InstructorByGenreQueryVariables>(InstructorByGenreDocument, options);
        }
export type InstructorByGenreQueryHookResult = ReturnType<typeof useInstructorByGenreQuery>;
export type InstructorByGenreLazyQueryHookResult = ReturnType<typeof useInstructorByGenreLazyQuery>;
export type InstructorByGenreQueryResult = Apollo.QueryResult<InstructorByGenreQuery, InstructorByGenreQueryVariables>;
export function refetchInstructorByGenreQuery(variables: InstructorByGenreQueryVariables) {
      return { query: InstructorByGenreDocument, variables: variables }
    }
export const WeeklyProgramDocument = gql`
    query weeklyProgram($slug: String!) {
  weeklyProgram(slug: $slug) {
    ...WeeklyProgramFields
  }
}
    ${WeeklyProgramFieldsFragmentDoc}`;

/**
 * __useWeeklyProgramQuery__
 *
 * To run a query within a React component, call `useWeeklyProgramQuery` and pass it any options that fit your needs.
 * When your component renders, `useWeeklyProgramQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWeeklyProgramQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useWeeklyProgramQuery(baseOptions: Apollo.QueryHookOptions<WeeklyProgramQuery, WeeklyProgramQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WeeklyProgramQuery, WeeklyProgramQueryVariables>(WeeklyProgramDocument, options);
      }
export function useWeeklyProgramLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WeeklyProgramQuery, WeeklyProgramQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WeeklyProgramQuery, WeeklyProgramQueryVariables>(WeeklyProgramDocument, options);
        }
export type WeeklyProgramQueryHookResult = ReturnType<typeof useWeeklyProgramQuery>;
export type WeeklyProgramLazyQueryHookResult = ReturnType<typeof useWeeklyProgramLazyQuery>;
export type WeeklyProgramQueryResult = Apollo.QueryResult<WeeklyProgramQuery, WeeklyProgramQueryVariables>;
export function refetchWeeklyProgramQuery(variables: WeeklyProgramQueryVariables) {
      return { query: WeeklyProgramDocument, variables: variables }
    }
export const YearlyPageDocument = gql`
    query YearlyPage {
  startOverview {
    featuresSection {
      description
      featureBullets
      imageUrl
      title
    }
  }
}
    `;

/**
 * __useYearlyPageQuery__
 *
 * To run a query within a React component, call `useYearlyPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useYearlyPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useYearlyPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useYearlyPageQuery(baseOptions?: Apollo.QueryHookOptions<YearlyPageQuery, YearlyPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<YearlyPageQuery, YearlyPageQueryVariables>(YearlyPageDocument, options);
      }
export function useYearlyPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<YearlyPageQuery, YearlyPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<YearlyPageQuery, YearlyPageQueryVariables>(YearlyPageDocument, options);
        }
export type YearlyPageQueryHookResult = ReturnType<typeof useYearlyPageQuery>;
export type YearlyPageLazyQueryHookResult = ReturnType<typeof useYearlyPageLazyQuery>;
export type YearlyPageQueryResult = Apollo.QueryResult<YearlyPageQuery, YearlyPageQueryVariables>;
export function refetchYearlyPageQuery(variables?: YearlyPageQueryVariables) {
      return { query: YearlyPageDocument, variables: variables }
    }
export const AnswerSurveyDocument = gql`
    mutation answerSurvey($surveyPartId: ID!, $surveyAnswerId: ID, $answers: [AnswerInput!], $surveyAction: ActionInput!) {
  answerSurvey(surveyPartId: $surveyPartId, surveyAnswerId: $surveyAnswerId, answers: $answers, surveyAction: $surveyAction) {
    errors {
      message
      status
    }
  }
}
    `;
export type AnswerSurveyMutationFn = Apollo.MutationFunction<AnswerSurveyMutation, AnswerSurveyMutationVariables>;

/**
 * __useAnswerSurveyMutation__
 *
 * To run a mutation, you first call `useAnswerSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnswerSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [answerSurveyMutation, { data, loading, error }] = useAnswerSurveyMutation({
 *   variables: {
 *      surveyPartId: // value for 'surveyPartId'
 *      surveyAnswerId: // value for 'surveyAnswerId'
 *      answers: // value for 'answers'
 *      surveyAction: // value for 'surveyAction'
 *   },
 * });
 */
export function useAnswerSurveyMutation(baseOptions?: Apollo.MutationHookOptions<AnswerSurveyMutation, AnswerSurveyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AnswerSurveyMutation, AnswerSurveyMutationVariables>(AnswerSurveyDocument, options);
      }
export type AnswerSurveyMutationHookResult = ReturnType<typeof useAnswerSurveyMutation>;
export type AnswerSurveyMutationResult = Apollo.MutationResult<AnswerSurveyMutation>;
export type AnswerSurveyMutationOptions = Apollo.BaseMutationOptions<AnswerSurveyMutation, AnswerSurveyMutationVariables>;
export const GetFavoritePlaylistsDocument = gql`
    query getFavoritePlaylists($id: ID!, $page: Int, $perPage: Int) {
  getFavoritePlaylists(id: $id, page: $page, perPage: $perPage) {
    totalCount
    perPage
    page
    data {
      id
      identifier
      title
      owner {
        id
        firstName
      }
      meta {
        videoCount
        minutes
      }
      description
      assets {
        thumbnailUrl
      }
    }
  }
}
    `;

/**
 * __useGetFavoritePlaylistsQuery__
 *
 * To run a query within a React component, call `useGetFavoritePlaylistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFavoritePlaylistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFavoritePlaylistsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useGetFavoritePlaylistsQuery(baseOptions: Apollo.QueryHookOptions<GetFavoritePlaylistsQuery, GetFavoritePlaylistsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFavoritePlaylistsQuery, GetFavoritePlaylistsQueryVariables>(GetFavoritePlaylistsDocument, options);
      }
export function useGetFavoritePlaylistsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFavoritePlaylistsQuery, GetFavoritePlaylistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFavoritePlaylistsQuery, GetFavoritePlaylistsQueryVariables>(GetFavoritePlaylistsDocument, options);
        }
export type GetFavoritePlaylistsQueryHookResult = ReturnType<typeof useGetFavoritePlaylistsQuery>;
export type GetFavoritePlaylistsLazyQueryHookResult = ReturnType<typeof useGetFavoritePlaylistsLazyQuery>;
export type GetFavoritePlaylistsQueryResult = Apollo.QueryResult<GetFavoritePlaylistsQuery, GetFavoritePlaylistsQueryVariables>;
export function refetchGetFavoritePlaylistsQuery(variables: GetFavoritePlaylistsQueryVariables) {
      return { query: GetFavoritePlaylistsDocument, variables: variables }
    }
export const GetFavoriteVideosDocument = gql`
    query getFavoriteVideos($id: ID!, $page: Int, $perPage: Int) {
  getFavoriteVideos(id: $id, page: $page, perPage: $perPage) {
    totalCount
    perPage
    page
    data {
      id
      identifier
      content {
        title
        shortDescription
      }
      cursorAt
      meta {
        minutes
        publishedAt
      }
      taxonomies {
        flavor {
          name
        }
        instructors {
          id
          name
          slug
        }
        genre {
          id
          name
          slug
        }
      }
      assets {
        thumbnailUrl
      }
    }
  }
}
    `;

/**
 * __useGetFavoriteVideosQuery__
 *
 * To run a query within a React component, call `useGetFavoriteVideosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFavoriteVideosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFavoriteVideosQuery({
 *   variables: {
 *      id: // value for 'id'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useGetFavoriteVideosQuery(baseOptions: Apollo.QueryHookOptions<GetFavoriteVideosQuery, GetFavoriteVideosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFavoriteVideosQuery, GetFavoriteVideosQueryVariables>(GetFavoriteVideosDocument, options);
      }
export function useGetFavoriteVideosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFavoriteVideosQuery, GetFavoriteVideosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFavoriteVideosQuery, GetFavoriteVideosQueryVariables>(GetFavoriteVideosDocument, options);
        }
export type GetFavoriteVideosQueryHookResult = ReturnType<typeof useGetFavoriteVideosQuery>;
export type GetFavoriteVideosLazyQueryHookResult = ReturnType<typeof useGetFavoriteVideosLazyQuery>;
export type GetFavoriteVideosQueryResult = Apollo.QueryResult<GetFavoriteVideosQuery, GetFavoriteVideosQueryVariables>;
export function refetchGetFavoriteVideosQuery(variables: GetFavoriteVideosQueryVariables) {
      return { query: GetFavoriteVideosDocument, variables: variables }
    }
export const ReclaimTrialDocument = gql`
    mutation reclaimTrial($code: String!, $source: String!) {
  reclaimTrial(code: $code, source: $source) {
    errors
    success
  }
}
    `;
export type ReclaimTrialMutationFn = Apollo.MutationFunction<ReclaimTrialMutation, ReclaimTrialMutationVariables>;

/**
 * __useReclaimTrialMutation__
 *
 * To run a mutation, you first call `useReclaimTrialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReclaimTrialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reclaimTrialMutation, { data, loading, error }] = useReclaimTrialMutation({
 *   variables: {
 *      code: // value for 'code'
 *      source: // value for 'source'
 *   },
 * });
 */
export function useReclaimTrialMutation(baseOptions?: Apollo.MutationHookOptions<ReclaimTrialMutation, ReclaimTrialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReclaimTrialMutation, ReclaimTrialMutationVariables>(ReclaimTrialDocument, options);
      }
export type ReclaimTrialMutationHookResult = ReturnType<typeof useReclaimTrialMutation>;
export type ReclaimTrialMutationResult = Apollo.MutationResult<ReclaimTrialMutation>;
export type ReclaimTrialMutationOptions = Apollo.BaseMutationOptions<ReclaimTrialMutation, ReclaimTrialMutationVariables>;
export const StoreUserDecisionDocument = gql`
    mutation storeUserDecision($decision: UserDecisionKind!, $value: Boolean) {
  storeUserDecision(decision: $decision, value: $value) {
    user {
      id
    }
  }
}
    `;
export type StoreUserDecisionMutationFn = Apollo.MutationFunction<StoreUserDecisionMutation, StoreUserDecisionMutationVariables>;

/**
 * __useStoreUserDecisionMutation__
 *
 * To run a mutation, you first call `useStoreUserDecisionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStoreUserDecisionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storeUserDecisionMutation, { data, loading, error }] = useStoreUserDecisionMutation({
 *   variables: {
 *      decision: // value for 'decision'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useStoreUserDecisionMutation(baseOptions?: Apollo.MutationHookOptions<StoreUserDecisionMutation, StoreUserDecisionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StoreUserDecisionMutation, StoreUserDecisionMutationVariables>(StoreUserDecisionDocument, options);
      }
export type StoreUserDecisionMutationHookResult = ReturnType<typeof useStoreUserDecisionMutation>;
export type StoreUserDecisionMutationResult = Apollo.MutationResult<StoreUserDecisionMutation>;
export type StoreUserDecisionMutationOptions = Apollo.BaseMutationOptions<StoreUserDecisionMutation, StoreUserDecisionMutationVariables>;

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "VideoInterface": [
      "Video"
    ],
    "PagedInterface": [
      "PagedVideos",
      "PagedBundles",
      "PagedPlaylists",
      "PagedGenericPrograms",
      "PagedInstructors",
      "PagedLiveEvents",
      "PagedPages",
      "PagedBlogPosts",
      "SearchResults",
      "PagedSurveys",
      "PagedUsers"
    ],
    "Item": [
      "BlogPost",
      "Document",
      "GenericProgram",
      "LiveEvent",
      "Playlist",
      "Video"
    ],
    "UserInterface": [
      "User",
      "CurrentUser"
    ],
    "PromotionCodeResource": [
      "Bundle",
      "GenericProgram",
      "LiveEvent"
    ],
    "Order": [
      "GenericProgramPayment",
      "LiveEventPayment",
      "SubscriptionPayment"
    ],
    "OrderPaymentInterface": [
      "GenericProgramPayment",
      "LiveEventPayment",
      "SubscriptionPayment"
    ],
    "ProgramElement": [
      "ProgramDocument",
      "ProgramPartElement",
      "ProgramSurveyElement",
      "ProgramVideo"
    ],
    "SearchResult": [
      "SearchBlogPost",
      "SearchEvent",
      "SearchGenericProgram",
      "SearchInstructor",
      "SearchLandingPage",
      "SearchLiveEvent",
      "SearchPlaylist",
      "SearchVideo"
    ]
  }
};
      export default result;
    